import { baseDealerContactForm, DealerContactTypes, hasValue, isValidEmail, Days, formatString, useDealerships, MarkupText, DefaultTitle, DefaultText, DefaultImage, groupOpeningHoursByDay, isToday, DefaultDealershipRef, navigateInternalUrl, DefaultMapViewPort, DefaultTitleTextIconActionItem, DefaultTitleTextIconItem, ActionLink, DefaultAction, useWindowDimensions, DefaultTitleActionAndItems, hasWindow, ExternalLink, DefaultSocialMediaIcons, baseMenuFavoritesBtn, baseLanguagePicker, hasDocument, DefaultLinks, baseCookieBanner, baseFinancingBanner, baseFinancingContent, DefaultSeoBlock, DefaultSeoMakeBlock, baseFavoriteBtn, getStickiesOffset, formatPrice, baseCompare, useScrollPosition, formatNumber, baseCompareBanner, navigateInternalPage, formatPriceByCulture, baseImageViewerAndThumbnails, ImageThumbnails, ImageViewer, baseVehicleDetail, InternalLink, b64DecodeUnicode, DefaultPrimaryAction, DefaultAdditionalVehicleImages, baseCompareBtn, baseVehicleCard, baseFavoriteVehicles, baseReservationWizardUserForm, isPhoneValid, baseReservationWizard, baseTypedSearchAgentCriteria, SearchAgentCriteriaTypes, FilterTypes, baseSearchAgentCriteria, baseSearchAgentField, baseSearchAgentTopBar, baseSearchAgentForm, baseSearchAgent, baseModelFilterForMakeModel, baseMakeFilterForMakeModel, useVehiclesFilterData, useVehiclesCount, useQuery, generateVehicleFilterCountNodeByFormData, generateUrlParametersByFormDataV2, baseSliderWithCustomImageCard, Slider as Slider$1, baseTypedFilter, baseFilter, withFilters, baseNotifyBtn, basePagination, baseVehiclesPaged, withSort, baseVehiclesAndFilters, hasFilter } from '@digitalexperience/dealer-website-core';
export { CaptchaProvider, DataContext, DataContextProvider, defaults as coreDefaults, types as coreTypes, utils as coreUtils, useAnalytics, useSession } from '@digitalexperience/dealer-website-core';
import React, { useEffect, useState, Suspense, useRef } from 'react';
import { startCase, map, orderBy, lowerCase, filter, each, times, find, head, forEach, includes, capitalize, sortBy, min, max, uniq, groupBy, isEmpty, range, keys as keys$2, some, toString, last, take, values } from 'lodash';
import { useTranslation } from 'react-i18next';
import Map, { Marker, Popup } from 'react-map-gl';
import Sticky from 'react-stickynode';
import Fade from 'react-reveal/Fade';
import Switch from 'react-switch';
import { Fade as Fade$1 } from 'react-reveal';
import Slider from 'rc-slider';
import Select, { components } from 'react-select';
import Modal from 'react-modal';

var fonts = [];
var icons = [];
var css = [];
var config = {
  defaultCulture: 'nl',
  fonts: fonts,
  icons: icons,
  css: css
};

var ErrorIndicator = function ErrorIndicator(_ref) {
  var error = _ref.error,
    icon = _ref.icon;
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full bg-red-200 flex items-center rounded"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex h-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-16 bg-red-300 flex items-center justify-center rounded-l"
  }, /*#__PURE__*/React.createElement("i", {
    className: icon + " text-2xl text-red-900"
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-auto text-black opacity-75 items-center px-4 py-4  flex items-center"
  }, /*#__PURE__*/React.createElement("p", {
    className: "leading-tight"
  }, error))));
};
ErrorIndicator.defaultProps = {
  error: 'Er ging iets mis. Probeer later opnieuw.',
  icon: 'fad fa-exclamation-circle'
};

var LoadingIndicator$1 = function LoadingIndicator(_ref) {
  var color = _ref.color,
    small = _ref.small,
    extraSmall = _ref.extraSmall;
  var classes = small ? 'small-loader' : 'loader';
  classes = extraSmall ? 'extra-small' : classes;
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner one " + (color === null ? 'border-primary' : ''),
    style: {
      borderColor: color !== null ? color : ''
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "inner two " + (color === null ? 'border-primary' : ''),
    style: {
      borderColor: color !== null ? color : ''
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "inner three " + (color === null ? 'border-primary' : ''),
    style: {
      borderColor: color !== null ? color : ''
    }
  }));
};
LoadingIndicator$1.defaultProps = {
  color: null,
  small: false,
  extraSmall: false
};

var SuccessIndicator = function SuccessIndicator(_ref) {
  var success = _ref.success,
    icon = _ref.icon;
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-green-200 flex items-center rounded"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex h-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-16 bg-green-300 flex items-center justify-center rounded-l",
    style: {
      minWidth: '4rem'
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: icon + " text-2xl text-green-900"
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-auto text-black opacity-75 items-center px-4 py-4 flex items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leading-tight list-none"
  }, success))));
};
SuccessIndicator.defaultProps = {
  success: 'Success!',
  icon: 'fad fa-check'
};

var InputField = function InputField(_ref) {
  var containerClass = _ref.containerClass,
    label = _ref.label,
    placeholder = _ref.placeholder,
    value = _ref.value,
    _onChange = _ref.onChange,
    errorText = _ref.errorText,
    required = _ref.required,
    type = _ref.type,
    withIcon = _ref.withIcon,
    icon = _ref.icon,
    errorClass = _ref.errorClass,
    inputClass = _ref.inputClass,
    onlyNumbers = _ref.onlyNumbers,
    lightForm = _ref.lightForm;
  var hasError = errorText !== undefined;
  return /*#__PURE__*/React.createElement("div", {
    className: containerClass
  }, label && /*#__PURE__*/React.createElement("label", {
    className: "block tracking-wide " + (hasError ? 'text-red-400' : lightForm ? 'text-white' : 'text-gray-700') + " mb-2"
  }, label, " ", required ? '(*)' : ''), /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, withIcon && /*#__PURE__*/React.createElement("div", {
    className: "flex -mr-px"
  }, /*#__PURE__*/React.createElement("span", {
    className: "flex items-center leading-normal rounded rounded-r-none " + (lightForm ? 'text-white' : 'text-gray-700  border') + " border-r-0 " + (hasError ? 'bg-red-100 border-red-400' : lightForm ? 'bg-transparent border-b border-white' : 'bg-gray-100 border-gray-400') + " px-3 whitespace-nowrap text-sm"
  }, /*#__PURE__*/React.createElement("i", {
    className: "" + icon
  }))), /*#__PURE__*/React.createElement("input", {
    className: "appearance-none block w-full " + (lightForm ? 'text-white focus:border-gray-400 rounded-none px-0' : 'text-gray-700 border focus:border-primary px-4') + " " + (hasError ? 'bg-red-100 border-red-400' : lightForm ? 'bg-transparent border-b border-white' : 'bg-white border-gray-400') + "  " + (withIcon && 'rounded-l-none') + " py-3 focus:outline-none " + inputClass,
    type: type,
    placeholder: placeholder,
    value: value,
    onChange: function onChange(e) {
      if (onlyNumbers) {
        var re = /^[0-9\b]+$/;
        if (re.test(e.target.value)) {
          _onChange(e.target.value);
        }
      } else {
        _onChange(e.target.value);
      }
    }
  })), hasError && errorText !== '' && /*#__PURE__*/React.createElement("div", {
    className: "text-red-400 text-xs mt-1 " + errorClass
  }, errorText));
};
InputField.defaultProps = {
  containerClass: 'text-sm font-bold',
  type: 'text',
  required: false,
  withIcon: false,
  icon: '',
  errorClass: '',
  inputClass: 'rounded',
  onlyNumbers: false,
  lightForm: false
};

var TextAreaField = function TextAreaField(_ref) {
  var containerClass = _ref.containerClass,
    label = _ref.label,
    placeholder = _ref.placeholder,
    value = _ref.value,
    _onChange = _ref.onChange,
    errorText = _ref.errorText,
    required = _ref.required,
    heightClass = _ref.heightClass,
    inputClass = _ref.inputClass;
  var hasError = errorText !== undefined;
  return /*#__PURE__*/React.createElement("div", {
    className: containerClass
  }, label && /*#__PURE__*/React.createElement("label", {
    className: "block tracking-wide " + (hasError ? 'text-red-400' : 'text-gray-700') + " mb-2"
  }, label, " ", required ? '(*)' : ''), /*#__PURE__*/React.createElement("textarea", {
    className: "appearance-none block w-full " + (hasError ? 'bg-red-100 border-red-400' : 'bg-white border-gray-400') + " text-gray-700 border rounded py-3 px-4 mb-1 " + heightClass + " focus:outline-none focus:border-primary " + inputClass,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    value: value,
    placeholder: placeholder
  }), hasError && /*#__PURE__*/React.createElement("div", {
    className: "text-red-400 text-xs"
  }, errorText));
};
TextAreaField.defaultProps = {
  containerClass: 'text-xs font-bold',
  required: false,
  heightClass: 'h-48',
  inputClass: ''
};

var _initialFormData;
var FormFields = {
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phone: 'phone',
  message: 'message',
  privacy: 'privacy'
};
var initialFormData = (_initialFormData = {}, _initialFormData[FormFields.firstName] = '', _initialFormData[FormFields.lastName] = '', _initialFormData[FormFields.email] = '', _initialFormData[FormFields.phone] = '', _initialFormData[FormFields.message] = '', _initialFormData[FormFields.privacy] = false, _initialFormData);
var validator = function validator(data, t) {
  var errors = {};
  if (!hasValue(data.firstName)) {
    errors[FormFields.firstName] = t('First name is required.');
  }
  if (!hasValue(data.lastName)) {
    errors[FormFields.lastName] = t('Last name is required.');
  }
  if (!hasValue(data.email)) {
    errors[FormFields.email] = t('Email address is required.');
  } else if (!isValidEmail(data.email)) {
    errors[FormFields.email] = t('Email address is not valid.');
  }
  if (!hasValue(data.phone)) {
    errors[FormFields.phone] = t('Phone is required.');
  }
  if (!hasValue(data.message)) {
    errors[FormFields.message] = t('Message is required.');
  }
  if (data.privacy === false) {
    errors[FormFields.privacy] = '';
  }
  return errors;
};
var submitDataMapper = function submitDataMapper(formData, additionalData, context) {
  return {
    first_name: formData.firstName,
    last_name: formData.lastName,
    email: formData.email,
    phone: formData.phone,
    message: formData.message,
    privacy: formData.privacy
  };
};
var ContactForm = function ContactForm(_ref) {
  var data = _ref.data,
    submit = _ref.submit,
    submitting = _ref.submitting,
    submitSuccess = _ref.submitSuccess,
    submitError = _ref.submitError,
    validationErrors = _ref.validationErrors,
    setFormValue = _ref.setFormValue,
    navigatePrivacy = _ref.navigatePrivacy;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("form", {
    action: "",
    onSubmit: submit,
    className: "flex flex-col flex-1 relative"
  }, validationErrors && validationErrors['result'] && /*#__PURE__*/React.createElement("div", {
    className: "mb-4 px-5 md:px-0",
    style: {
      minHeight: 32
    }
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: validationErrors['result']
  })), submitError && submitError !== '' && /*#__PURE__*/React.createElement("div", {
    className: "mb-4 px-5 md:px-0",
    style: {
      minHeight: 32
    }
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: submitError
  })), submitSuccess && /*#__PURE__*/React.createElement("div", {
    className: "mb-4 px-5 md:px-0",
    style: {
      minHeight: 32
    }
  }, /*#__PURE__*/React.createElement(SuccessIndicator, {
    success: t('Thanks. We are going to answer as soon as possible.')
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row mb-5"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full font-secondary md:w-1/2 mb-5 md:mb-0 mr-0 md:mr-1",
    inputClass: "rounded-4",
    label: t('First name'),
    placeholder: t('First name'),
    value: data.firstName,
    onChange: function onChange(value) {
      return setFormValue(FormFields.firstName, value);
    },
    errorText: validationErrors[FormFields.firstName],
    required: true
  }), /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full font-secondary md:w-1/2 md:mb-0 ml-0 md:ml-1",
    inputClass: "rounded-4",
    label: t('Last name'),
    placeholder: t('Last name'),
    value: data.lastName,
    onChange: function onChange(value) {
      return setFormValue(FormFields.lastName, value);
    },
    errorText: validationErrors[FormFields.lastName],
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row mb-5"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full font-secondary md:w-1/2 mb-5 md:mb-0 mr-0 md:mr-1",
    inputClass: "rounded-4",
    label: t('Email address'),
    placeholder: t('Email address'),
    value: data.email,
    onChange: function onChange(value) {
      return setFormValue(FormFields.email, value);
    },
    errorText: validationErrors[FormFields.email],
    required: true
  }), /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full font-secondary md:w-1/2 md:mb-0 ml-0 md:ml-1",
    inputClass: "rounded-4",
    label: t('Phone'),
    placeholder: t('Phone'),
    value: data.phone,
    onChange: function onChange(value) {
      return setFormValue(FormFields.phone, value);
    },
    errorText: validationErrors[FormFields.phone],
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-2"
  }, /*#__PURE__*/React.createElement(TextAreaField, {
    containerClass: "font-secondary md:w-full md:mb-0",
    inputClass: "rounded-4",
    label: t('Any comments'),
    placeholder: t('Comments'),
    value: data.message,
    heightClass: "h-24",
    onChange: function onChange(value) {
      return setFormValue(FormFields.message, value);
    },
    errorText: validationErrors[FormFields.message],
    required: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex mb-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-primary font-secondary  " + (validationErrors['privacy'] !== undefined ? 'text-red-400' : '')
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: data.privacy,
    onChange: function onChange(e) {
      return setFormValue(FormFields.privacy, e.target.checked);
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "mr-1 ml-2 " + (validationErrors['privacy'] !== undefined ? 'text-red-400' : '')
  }, t('I agree to the'), " "), /*#__PURE__*/React.createElement("span", {
    className: "underline cursor-pointer " + (validationErrors['privacy'] !== undefined ? 'text-red-400' : ''),
    onClick: function onClick() {
      return navigatePrivacy();
    }
  }, t('privacy terms')), ".")), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-start"
  }, /*#__PURE__*/React.createElement("button", {
    className: "primary-button",
    type: "submit",
    disabled: submitting
  }, submitting ? t('Sending...') : t('Send'))));
};
var ContactForm$1 = baseDealerContactForm(DealerContactTypes.general, initialFormData, validator, submitDataMapper, ContactForm);

var getDayTranslation = function getDayTranslation(t, day) {
  switch (day) {
    case Days.mon:
      return t('Monday');
    case Days.tue:
      return t('Tuesday');
    case Days.wed:
      return t('Wednesday');
    case Days.thu:
      return t('Thursday');
    case Days.fri:
      return t('Friday');
    case Days.sat:
      return t('Saturday');
    case Days.sun:
      return t('Sunday');
    default:
      return '';
  }
};
var openingHoursDayFormatter = function openingHoursDayFormatter(t, from, till) {
  if (from && till === undefined) {
    return startCase(getDayTranslation(t, from));
  }
  if (from && till) {
    return formatString(t('{} to {}'), startCase(getDayTranslation(t, from)), startCase(getDayTranslation(t, till)));
  }
  return '';
};

var ContactFormTextImageSkeleton = function ContactFormTextImageSkeleton() {
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col flex-1 mt-5",
    style: {
      minHeight: 250
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 lg:grid-cols-2 container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full pr-0 md:pr-8 mb-10 lg:mb-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-8 w-80 bg-gray-200 animate-pulse h-8"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse w-1/2 h-12 mr-2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse w-1/2 h-12 ml-2"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse w-1/2 h-12 mr-2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse w-1/2 h-12 ml-2"
  })), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse w-full h-24 mb-4"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse w-48 h-2 mb-4"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse w-24 h-12"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex w-full h-80 lg:h-full bg-gray-200 animate-pulse"
  })));
};

var Dealerships_Query = "query Dealerships {\n  dealerships {\n    id\n    name\n    address\n    postal\n    city\n    reference\n    email\n    fax\n    tel \n    url\n    image\n    latitude\n    longitude\n    dealershipType\n    contactUrl\n    \n    openingHoursShowroom {    \n      day\n      start\n      stop\n    }\n    \n  }    \n}";
var ContactFormTextAndImage = function ContactFormTextAndImage(_ref) {
  var text = _ref.text,
    image = _ref.image,
    context = _ref.context;
  var _useDealerships = useDealerships(context, Dealerships_Query),
    general = _useDealerships.general,
    loading = _useDealerships.loading,
    error = _useDealerships.error,
    fetchDealerships = _useDealerships.fetchDealerships;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    fetchDealerships();
  }, []);
  if (loading) {
    return /*#__PURE__*/React.createElement(ContactFormTextImageSkeleton, null);
  }
  if (!loading && error) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1",
      style: {
        minHeight: 250
      }
    }, /*#__PURE__*/React.createElement(ErrorIndicator, {
      error: t('The dealerships could not be fetched.')
    }));
  }
  var formatDate = function formatDate(time) {
    var splitted = time.split(':');
    try {
      return splitted[0] + ":" + splitted[1];
    } catch (e) {
      return '';
    }
  };
  var renderOpeningsHours = function renderOpeningsHours(openingsHours) {
    var formattedOpeningHours = groupOpeningHoursByDay(openingsHours, function (from, till) {
      return openingHoursDayFormatter(t, from, till);
    });
    var closedDays = filter(formattedOpeningHours, function (oh) {
      return oh.closed;
    }).length;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "text-20 mb-5 font-medium font-primary"
    }, t('Opening hours')), map(formattedOpeningHours, function (oh, i) {
      if (closedDays === 1) {
        if (!oh.closed) {
          return /*#__PURE__*/React.createElement("div", {
            key: i,
            className: "mb-4 font-normal font-primary"
          }, /*#__PURE__*/React.createElement("div", {
            className: "mb-2 md:mb-0"
          }, oh.label), /*#__PURE__*/React.createElement("div", {
            className: "flex justify-center lg:justify-start"
          }, map(orderBy(oh.hours, 'start'), function (h, i) {
            return /*#__PURE__*/React.createElement("div", {
              className: i > 0 && 'border-l border-white pl-2 ml-2'
            }, formatDate(h.start), " - ", formatDate(h.stop));
          })));
        } else {
          return /*#__PURE__*/React.createElement("div", {
            key: i,
            className: "mb-4 font-normal font-primary"
          }, /*#__PURE__*/React.createElement("div", null, t('Closed at'), " ", lowerCase(oh.label)));
        }
      } else {
        return /*#__PURE__*/React.createElement("div", {
          key: i,
          className: "mb-4 font-normal font-primary"
        }, /*#__PURE__*/React.createElement("div", null, oh.label), !oh.closed && /*#__PURE__*/React.createElement("div", null, t('Closed')), map(oh.hours, function (h) {
          return /*#__PURE__*/React.createElement("div", null, formatDate(h.start), " - ", formatDate(h.stop));
        }));
      }
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col flex-1 mt-0 md:mt-5 ",
    style: {
      minHeight: 250
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 lg:grid-cols-2 container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid w-full " + (general || image ? 'pr-0 lg:pr-8 mb-10 lg:mb-0' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-8"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: text,
    context: context
  })), /*#__PURE__*/React.createElement(ContactForm$1, {
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid w-full bg-secondary"
  }, image && /*#__PURE__*/React.createElement("img", {
    srcSet: (image === null || image === void 0 ? void 0 : image.mobile) + " 300w, " + (image === null || image === void 0 ? void 0 : image.tablet) + " 768w, " + (image === null || image === void 0 ? void 0 : image.desktop) + " 1280w",
    src: image === null || image === void 0 ? void 0 : image.mobile,
    alt: image === null || image === void 0 ? void 0 : image.alt,
    className: "hidden lg:block object-center object-cover h-full w-full"
  }), general && /*#__PURE__*/React.createElement("div", {
    className: "p-8 text-white text-center lg:text-left"
  }, general && general.openingHoursShowroom && renderOpeningsHours(general.openingHoursShowroom)))));
};
ContactFormTextAndImage.defaultProps = {
  title: DefaultTitle,
  text: DefaultText,
  image: DefaultImage
};
ContactFormTextAndImage.human = {
  nl: '',
  fr: '',
  en: ''
};
ContactFormTextAndImage.preview = function () {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      height: 150
    }
  }, " CONTACT FORM IMAGE ");
};

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

var DealershipDetail = function DealershipDetail(_ref) {
  var image = _ref.image,
    text = _ref.text,
    dealership_data = _ref.dealership_data,
    brand_logos = _ref.brand_logos,
    context = _ref.context;
  var data = dealership_data ? dealership_data.data : undefined;
  var dealership = data.dealership ? data.dealership : undefined;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var getLocationTypeDescription = function getLocationTypeDescription(name) {
    switch (name) {
      case 'workplace':
        return t('Workplace');
      case 'showroom':
        return t('Showroom');
      case 'reception-aftersales':
        return t('Reception and after sales');
      default:
        return name;
    }
  };
  var renderHours = function renderHours(hours) {
    var am = hours[0];
    var pm = hours[1];
    if (am || pm) {
      return /*#__PURE__*/React.createElement("div", {
        className: "flex"
      }, am && /*#__PURE__*/React.createElement("span", null, am.start, " - ", am.stop), pm && /*#__PURE__*/React.createElement("span", null, ", ", pm.start, " - ", pm.stop));
    } else {
      return /*#__PURE__*/React.createElement("div", null, t('Closed'));
    }
  };
  var renderClosedLabel = function renderClosedLabel(closingDays) {
    var today = new Date();
    var label = '';
    each(closingDays, function (cd) {
      if (new Date(cd.start) < today && today < new Date(cd.stop)) {
        if (cd.description) {
          label = cd.description;
        } else {
          var options = {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          };
          label = t('We are closed until') + " " + new Date(cd.stop).toLocaleDateString('nl-NL', options);
        }
        return false;
      }
    });
    return label;
  };
  var isCurrentlyClosed = function isCurrentlyClosed(closingDays) {
    var today = new Date();
    var closed = false;
    each(closingDays, function (cd) {
      if (new Date(cd.start) < today && today < new Date(cd.stop)) {
        closed = true;
        return false;
      }
    });
    return closed;
  };
  var style = image ? {
    background: "url(" + (image === null || image === void 0 ? void 0 : image.desktop) + ") no-repeat center",
    backgroundSize: 'cover'
  } : {};
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col mt-0 md:mt-5",
    style: {
      minHeight: 150
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: !image && 'bg-secondary-one',
    style: _extends({
      height: 330
    }, style)
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center container mx-auto h-full relative text-white"
  }, dealership && /*#__PURE__*/React.createElement("div", {
    className: "text-white"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-white"
  }, dealership === null || dealership === void 0 ? void 0 : dealership.name), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center mb-1 font-primary"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mr-2",
    style: {
      width: 20
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "far fa-map-marker-alt "
  })), dealership === null || dealership === void 0 ? void 0 : dealership.address, ", ", dealership === null || dealership === void 0 ? void 0 : dealership.postal, " ", dealership === null || dealership === void 0 ? void 0 : dealership.city), (dealership === null || dealership === void 0 ? void 0 : dealership.tel) && /*#__PURE__*/React.createElement("a", {
    href: "tel:" + (dealership === null || dealership === void 0 ? void 0 : dealership.tel),
    className: "flex items-center font-primary"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mr-2",
    style: {
      width: 20
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "far fa-phone "
  })), dealership === null || dealership === void 0 ? void 0 : dealership.tel)), brand_logos && brand_logos.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "flex absolute bottom-0 left-0 bg-white p-5 rounded-t-4"
  }, map(brand_logos, function (url, i) {
    var isLast = brand_logos.length - 1 === i;
    return /*#__PURE__*/React.createElement("div", {
      className: "" + (isLast ? 'mr-0' : 'mr-9')
    }, /*#__PURE__*/React.createElement("img", {
      src: url,
      alt: "",
      style: {
        height: 30
      }
    }));
  })))), data && /*#__PURE__*/React.createElement("div", {
    className: "bg-secondary-four py-7 md:py-16"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container mx-auto"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    context: context,
    text: text
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex grid grid-cols-1 xl:grid-cols-2 3xl:grid-cols-3 gap-4 mt-5"
  }, data.location_types && map(data.location_types, function (lt, i) {
    var closingDays = filter(data.closing_days, function (cd) {
      return cd.type === lt.id;
    });
    if (closingDays && closingDays.length > 0 && isCurrentlyClosed(closingDays)) {
      return /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col bg-transparent md:bg-white rounded-4 p-0 md:p-10 mb-4 md:mb-0"
      }, /*#__PURE__*/React.createElement("h3", {
        className: "mb-4 capitalize"
      }, getLocationTypeDescription(lt.name)), /*#__PURE__*/React.createElement("div", {
        className: "text-15 font-primary font-medium text-secondary-five"
      }, renderClosedLabel(closingDays)));
    }
    var openingsHours = filter(data.openings_hours, function (op) {
      return op.type === lt.id;
    });
    if (openingsHours && openingsHours.length > 0) {
      return /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col bg-transparent md:bg-white rounded-4 p-0 md:p-10 mb-4 md:mb-0"
      }, /*#__PURE__*/React.createElement("h3", {
        className: "mb-4 capitalize"
      }, getLocationTypeDescription(lt.name)), map(Days, function (key, value) {
        var hours = filter(openingsHours, function (oh) {
          return oh.day === value;
        });
        return /*#__PURE__*/React.createElement("div", {
          className: "flex mb-1 md:mb-0 " + (isToday(key) ? 'text-secondary-two font-semibold' : 'opacity-50 text-secondary-three font-medium')
        }, /*#__PURE__*/React.createElement("div", {
          className: "text-15 font-primary w-1/3"
        }, getDayTranslation(t, key)), hours && /*#__PURE__*/React.createElement("div", {
          className: "text-15 font-primary w-2/3"
        }, renderHours(orderBy(hours, ['start']))));
      }));
    }
  })))));
};
DealershipDetail.defaultProps = {
  image: DefaultImage,
  text: DefaultText,
  dealership_data: DefaultDealershipRef,
  brand_logos: []
};
DealershipDetail.human = {
  nl: '',
  fr: '',
  en: ''
};
DealershipDetail.preview = function () {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      minHeight: 150
    }
  }, " Dealership Detail ");
};

function useIsMobile() {
  var _useState = useState(false),
    isMobile = _useState[0],
    setIsMobile = _useState[1];
  var _useState2 = useState(false),
    isTablet = _useState2[0],
    setIsTablet = _useState2[1];
  var resize = function resize() {
    setIsMobile(window.innerWidth <= 768);
    setIsTablet(window.innerWidth > 768 && window.innerWidth <= 1199);
  };
  useEffect(function () {
    setIsMobile(window.innerWidth <= 768);
    setIsTablet(window.innerWidth > 768 && window.innerWidth <= 1199);
    window.addEventListener('resize', resize);
    return function () {
      window.removeEventListener('resize', resize);
    };
  });
  return {
    isMobile: isMobile,
    isTablet: isTablet
  };
}

var MarkerMapAndDealershipSkeleton = function MarkerMapAndDealershipSkeleton() {
  var totalDealerships = 10;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col flex-1 mt-5 md:mt-12 ",
    style: {
      minHeight: 250
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row container mx-auto mb-5 md:mb-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-1/2 hidden lg:block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-full w-full bg-gray-200 animate-pulse mb-1"
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-full lg:w-1/2 rounded-4 bg-white lg:bg-secondary-four p-0 lg:p-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-8 text-center lg:text-left"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-8 bg-gray-200 animate-pulse"
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 lg:grid-cols-2 gap-x-4 gap-y-8 "
  }, times(totalDealerships, function (item) {
    return /*#__PURE__*/React.createElement("div", {
      key: item,
      className: "border-b border-gray-200 pb-8"
    }, /*#__PURE__*/React.createElement("div", {
      className: "h-6 w-full md:w-20 lg:w-32 bg-gray-200 animate-pulse mb-2"
    }), /*#__PURE__*/React.createElement("div", {
      className: "h-3 w-3/4 md:w-16 lg:w-24 bg-gray-200 animate-pulse mb-1"
    }), /*#__PURE__*/React.createElement("div", {
      className: "h-3 w-3/4 md:w-16 lg:w-24 bg-gray-200 animate-pulse"
    }));
  })))));
};

var CustomMarker = function CustomMarker(_ref) {
  var lat = _ref.lat,
    lng = _ref.lng,
    payload = _ref.payload,
    renderMarker = _ref.renderMarker,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement("div", null, "Loading...")
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Marker, {
    latitude: lat,
    longitude: lng,
    offsetTop: -34,
    offsetLeft: -17
  }, /*#__PURE__*/React.createElement("div", {
    onClick: onClick
  }, renderMarker(payload)))));
};

var MarkerMap = function MarkerMap(_ref) {
  var markers = _ref.markers,
    mapStyle = _ref.mapStyle,
    width = _ref.width,
    height = _ref.height,
    viewPort = _ref.viewPort,
    renderMarker = _ref.renderMarker,
    renderMarkerPopup = _ref.renderMarkerPopup,
    scrollZoom = _ref.scrollZoom,
    context = _ref.context;
  var _useState = useState({
      latitude: viewPort.latitude,
      longitude: viewPort.longitude,
      zoom: viewPort.zoom,
      bearing: 0,
      pitch: 0
    }),
    currentViewPort = _useState[0],
    setCurrentViewPort = _useState[1];
  var _useState2 = useState(undefined),
    selectedId = _useState2[0],
    setSelectedId = _useState2[1];
  useEffect(function () {
    setCurrentViewPort({
      latitude: viewPort.latitude,
      longitude: viewPort.longitude,
      zoom: viewPort.zoom,
      bearing: 0,
      pitch: 0
    });
  }, [viewPort]);
  return /*#__PURE__*/React.createElement(Map, _extends({}, currentViewPort, {
    width: width,
    height: height,
    mapStyle: mapStyle,
    mapboxApiAccessToken: context.mapBoxToken,
    onViewportChange: function onViewportChange(viewport) {
      setCurrentViewPort(viewport);
    },
    scrollZoom: scrollZoom
  }), map(markers, function (marker) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CustomMarker, {
      lat: marker.lat,
      lng: marker.lng,
      payload: marker.payload,
      renderMarker: renderMarker,
      onClick: function onClick() {
        return setSelectedId(marker.id);
      }
    }), renderMarkerPopup && selectedId && marker.id === selectedId && /*#__PURE__*/React.createElement(Popup, {
      tipSize: 5,
      anchor: "top",
      longitude: marker.lng,
      latitude: marker.lat,
      payload: marker.payload,
      closeOnClick: false,
      onClose: function onClose() {
        return setSelectedId(undefined);
      },
      closeButton: false
    }, renderMarkerPopup && renderMarkerPopup(marker.lat, marker.lng, function () {
      return setSelectedId(undefined);
    }, marker.payload)));
  }));
};
MarkerMap.defaultProps = {
  viewPort: {
    latitude: 50.5010789,
    longitude: 4.4764595,
    zoom: 7,
    scrollZoom: true
  }
};

var mapMarkers = function mapMarkers(dealerships) {
  return map(filter(dealerships, function (d) {
    return d.latitude && d.longitude;
  }), function (d) {
    return {
      lat: d.latitude,
      lng: d.longitude
    };
  });
};
var MarkerMapAndDealerships = function MarkerMapAndDealerships(_ref) {
  var marker_image = _ref.marker_image,
    viewport = _ref.viewport,
    context = _ref.context;
  var _useDealerships = useDealerships(context, Dealerships_Query),
    dealerships = _useDealerships.dealerships,
    loading = _useDealerships.loading,
    error = _useDealerships.error,
    fetchDealerships = _useDealerships.fetchDealerships;
  var _useState = useState(400),
    mapHeight = _useState[0],
    setMapHeight = _useState[1];
  var _useIsMobile = useIsMobile(),
    isMobile = _useIsMobile.isMobile;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var dealershipRef = useRef();
  useEffect(function () {
    fetchDealerships();
  }, []);
  useEffect(function () {
    if (!loading) {
      if (dealershipRef && dealershipRef.current) {
        setMapHeight(dealershipRef.current.offsetHeight);
      }
    }
  }, [loading]);
  if (loading) {
    return /*#__PURE__*/React.createElement(MarkerMapAndDealershipSkeleton, null);
  }
  if (!loading && error) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1",
      style: {
        minHeight: 250
      }
    }, /*#__PURE__*/React.createElement(ErrorIndicator, {
      error: t('The dealerships could not be fetched.')
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col flex-1 mt-5 md:mt-12 ",
    style: {
      minHeight: 250
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row container mx-auto mb-5 md:mb-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-1/2 hidden lg:block"
  }, /*#__PURE__*/React.createElement(MarkerMap, {
    markers: mapMarkers(dealerships),
    mapStyle: "mapbox://styles/mapbox/light-v10",
    width: "100%",
    height: isMobile ? 300 : mapHeight,
    viewPort: viewport,
    renderMarker: function renderMarker() {
      return /*#__PURE__*/React.createElement("img", {
        src: marker_image,
        style: {
          height: 34,
          width: 34
        },
        alt: "Marker"
      });
    },
    renderMarkerPopup: function renderMarkerPopup(lat, lng, onClose) {
      var dealership = find(dealerships, function (d) {
        return d.latitude === lat && d.longitude === lng;
      });
      if (dealership) {
        return /*#__PURE__*/React.createElement("div", {
          className: "p-5"
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex items-center justify-between mb-4"
        }, /*#__PURE__*/React.createElement("div", {
          className: "text-primary font-semibold text-24"
        }, dealership.name), /*#__PURE__*/React.createElement("i", {
          onClick: onClose,
          "class": "fas fa-times text-20 cursor-pointer"
        })), /*#__PURE__*/React.createElement("div", {
          className: "font-secondary " + (dealership.tel ? 'grid grid-cols-2 gap-4' : 'w-full')
        }, /*#__PURE__*/React.createElement("div", {
          className: ""
        }, /*#__PURE__*/React.createElement("div", {
          className: "font-semibold mb-2 text-primary"
        }, t('Address')), /*#__PURE__*/React.createElement("div", {
          className: "text-secondary-three"
        }, /*#__PURE__*/React.createElement("div", {
          className: "mb-1"
        }, dealership.address), /*#__PURE__*/React.createElement("div", null, dealership.postal, " ", dealership.city))), dealership.tel && /*#__PURE__*/React.createElement("div", {
          className: ""
        }, /*#__PURE__*/React.createElement("div", {
          className: "font-semibold mb-2 text-primary"
        }, t('Phone')), /*#__PURE__*/React.createElement("a", {
          href: "tel:" + dealership.tel,
          className: "text-secondary-three"
        }, dealership.tel))));
      }
    },
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    ref: dealershipRef,
    className: "w-full lg:w-1/2 rounded-4 bg-white lg:bg-secondary-four p-0 lg:p-10"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "mb-8 text-center lg:text-left"
  }, t('Our dealerships')), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 lg:grid-cols-2 gap-x-4 gap-y-8 "
  }, map(orderBy(dealerships, ['priority']), function (dealership, i) {
    var hideBorder = isMobile ? dealerships.length - 1 === i : dealerships.length - 1 === i || dealerships.length - 2 === i;
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "flex flex-col font-primary cursor-pointer hover:opacity-75 " + (!hideBorder && 'border-b border-secondary-eight pb-8'),
      onClick: function onClick() {
        return navigateInternalUrl(context, dealership === null || dealership === void 0 ? void 0 : dealership.contactUrl);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-20 text-secondary-three mb-2 font-medium w-full truncate"
    }, dealership.name, " ", /*#__PURE__*/React.createElement("i", {
      className: "far fa-angle-right ml-5 text-secondary-two"
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center text-secondary-three mb-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "mr-2",
      style: {
        width: 20
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "far fa-map-marker-alt "
    })), dealership.address.replace(',', ''), ", ", dealership.postal, " ", dealership.city), dealership.tel && /*#__PURE__*/React.createElement("a", {
      href: "tel:" + dealership.tel,
      className: "flex items-center text-secondary-three"
    }, /*#__PURE__*/React.createElement("div", {
      className: "mr-2",
      style: {
        width: 20
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "far fa-phone "
    })), dealership.tel));
  })))));
};
MarkerMapAndDealerships.defaultProps = {
  marker_image: DefaultImage,
  viewport: DefaultMapViewPort
};
MarkerMapAndDealerships.human = {
  nl: '',
  fr: '',
  en: ''
};
MarkerMapAndDealerships.preview = function () {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      height: 150
    }
  }, " MAP and dealerships ");
};

var AboutHeaderImageAndText = function AboutHeaderImageAndText(_ref) {
  var image = _ref.image,
    text = _ref.text,
    context = _ref.context;
  var _useState = useState('auto'),
    setHeight = _useState[1];
  var _useIsMobile = useIsMobile(),
    isMobile = _useIsMobile.isMobile;
  var textBlockRef = useRef(null);
  useEffect(function () {
    if (textBlockRef && textBlockRef.current) {
      setHeight(textBlockRef.current.clientHeight);
    }
  }, []);
  var style = image ? {
    background: "url(" + (image === null || image === void 0 ? void 0 : image.desktop) + ") no-repeat center",
    backgroundSize: 'cover'
  } : {};
  return /*#__PURE__*/React.createElement("div", {
    className: "container mx-auto my-0 md:my-5",
    style: {
      minHeight: 150
    }
  }, isMobile && /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-secondary-two rounded-4 p-7 md:p-12 text-white w-full"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-quote-right mb-8",
    style: {
      fontSize: 50
    }
  }), /*#__PURE__*/React.createElement(MarkupText, {
    context: context,
    text: text
  })), image && /*#__PURE__*/React.createElement("div", {
    className: "w-full",
    role: "img",
    "aria-label": image === null || image === void 0 ? void 0 : image.alt,
    title: image === null || image === void 0 ? void 0 : image.alt,
    style: _extends({
      height: 250
    }, style)
  })), !isMobile && /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-3 container mx-auto gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-secondary-two rounded-4 p-12 text-white"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-quote-right mb-8 row-span-2",
    style: {
      fontSize: 50
    }
  }), /*#__PURE__*/React.createElement(MarkupText, {
    context: context,
    text: text
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-span-2 rounded-4 " + (!image && 'bg-secondary-one'),
    role: "img",
    "aria-label": image === null || image === void 0 ? void 0 : image.alt,
    title: image === null || image === void 0 ? void 0 : image.alt,
    style: _extends({}, style)
  })));
};
AboutHeaderImageAndText.defaultProps = {
  header: DefaultText,
  image: DefaultImage,
  text: DefaultText
};
AboutHeaderImageAndText.human = {
  nl: '',
  fr: '',
  en: ''
};
AboutHeaderImageAndText.preview = AboutHeaderImageAndText;

var BannerGenericIconTextAction = function BannerGenericIconTextAction(_ref) {
  var data = _ref.data,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "container mx-auto py-5",
    style: {
      minHeight: 150
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-col-1 lg:grid-cols-3 gap-4"
  }, map(data, function (item, i) {
    var isFirst = i === 0;
    return /*#__PURE__*/React.createElement("div", {
      key: "icon-item-" + i,
      className: "p-10 2xl:p-16 rounded-4 " + (isFirst ? 'bg-secondary-two text-white' : 'bg-white text-secondary-three')
    }, /*#__PURE__*/React.createElement("i", {
      className: "mb-8 " + item.icon + " " + (!isFirst && 'text-secondary-two'),
      style: {
        fontSize: 50
      }
    }), /*#__PURE__*/React.createElement("h2", {
      className: "mb-8 " + (isFirst ? 'text-white' : 'text-secondary-three')
    }, item.title), /*#__PURE__*/React.createElement(MarkupText, {
      context: context,
      text: item.text
    }));
  })));
};
BannerGenericIconTextAction.defaultProps = {
  data: [_extends({}, DefaultTitleTextIconActionItem), _extends({}, DefaultTitleTextIconActionItem), _extends({}, DefaultTitleTextIconActionItem)]
};
BannerGenericIconTextAction.human = {
  nl: '',
  fr: '',
  en: ''
};
BannerGenericIconTextAction.preview = BannerGenericIconTextAction;

var BannerGenericIconTextAndTitle = function BannerGenericIconTextAndTitle(_ref) {
  var title = _ref.title,
    data = _ref.data,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-secondary-four pt-7 pb-2 md:pt-16 md:pb-10 mt-5 md:mt-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-7 md:mb-12 text-center"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: title,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-y-9 gap-x-2 w-full"
  }, map(data, function (item, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: "item-" + i,
      className: "flex items-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center "
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center mr-2",
      style: {
        width: 25,
        minWidth: 25
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: item.icon + " text-secondary-two text-20"
    })), /*#__PURE__*/React.createElement("div", {
      className: "text-15 font-secondary text-primary w-full truncate"
    }, item.title)), item.text && /*#__PURE__*/React.createElement("div", {
      className: "paragraph-default text-left mt-1"
    }, /*#__PURE__*/React.createElement(MarkupText, {
      text: item.text,
      context: context
    })));
  }))));
};
BannerGenericIconTextAndTitle.defaultProps = {
  title: DefaultText,
  data: [_extends({}, DefaultTitleTextIconItem), _extends({}, DefaultTitleTextIconItem), _extends({}, DefaultTitleTextIconItem)]
};
BannerGenericIconTextAndTitle.human = {
  nl: '',
  fr: '',
  en: ''
};
BannerGenericIconTextAndTitle.preview = BannerGenericIconTextAndTitle;

var BannerImageAndTextWithAction = function BannerImageAndTextWithAction(_ref) {
  var image = _ref.image,
    text = _ref.text,
    action = _ref.action,
    context = _ref.context;
  var style = image ? {
    background: "url(" + (image === null || image === void 0 ? void 0 : image.desktop) + ") no-repeat center",
    backgroundSize: 'cover'
  } : {};
  return /*#__PURE__*/React.createElement("div", {
    className: "container mx-auto my-5",
    style: {
      minHeight: 420
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center " + (!image && 'bg-secondary-one'),
    style: _extends({
      minHeight: 420
    }, style)
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-white w-full md:w-2/3 px-5 md:px-0 text-center"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    context: context,
    text: text
  }), action.type !== '' && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-full mt-7"
  }, /*#__PURE__*/React.createElement(ActionLink, {
    context: context,
    action: action,
    className: "primary-button"
  }, action.title))))));
};
BannerImageAndTextWithAction.defaultProps = {
  image: DefaultImage,
  text: DefaultText,
  action: DefaultAction
};
BannerImageAndTextWithAction.human = {
  nl: '',
  fr: '',
  en: ''
};
BannerImageAndTextWithAction.preview = BannerImageAndTextWithAction;

var BannerImageIconTextWithAction = function BannerImageIconTextWithAction(_ref) {
  var icon = _ref.icon,
    image = _ref.image,
    text = _ref.text,
    action = _ref.action,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "container mx-auto py-5",
    style: {
      minHeight: 150
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-col-1 lg:grid-cols-3 gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-span-3 md:col-span-2 lg:col-span-3 xl:col-span-2"
  }, image && /*#__PURE__*/React.createElement("img", {
    srcSet: (image === null || image === void 0 ? void 0 : image.mobile) + " 300w, " + (image === null || image === void 0 ? void 0 : image.tablet) + " 768w, " + (image === null || image === void 0 ? void 0 : image.desktop) + " 1280w",
    src: image === null || image === void 0 ? void 0 : image.mobile,
    alt: image === null || image === void 0 ? void 0 : image.alt,
    className: "rounded-4",
    style: {
      maxWidth: '100%',
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    }
  })), action && action.type !== '' && /*#__PURE__*/React.createElement(ActionLink, {
    context: context,
    className: "col-span-3 md:col-span-1 lg:col-span-3 xl:col-span-1 p-10 2xl:p-16 bg-secondary-four cursor-pointer hover:opacity-75",
    action: action
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", {
    className: "mb-8 text-secondary-two " + icon,
    style: {
      fontSize: 50
    }
  }), /*#__PURE__*/React.createElement(MarkupText, {
    context: context,
    text: text
  })))));
};
BannerImageIconTextWithAction.defaultProps = {
  icon: 'fal fa-heart',
  image: DefaultImage,
  text: DefaultText,
  action: DefaultAction
};
BannerImageIconTextWithAction.human = {
  nl: '',
  fr: '',
  en: ''
};
BannerImageIconTextWithAction.preview = BannerImageIconTextWithAction;

var BannerImageIconTextWithActionImageRight = function BannerImageIconTextWithActionImageRight(_ref) {
  var icon = _ref.icon,
    image = _ref.image,
    text = _ref.text,
    action = _ref.action,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "container mx-auto py-5",
    style: {
      minHeight: 150
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-col-1 lg:grid-cols-3 gap-4"
  }, action && action.type !== '' && /*#__PURE__*/React.createElement(ActionLink, {
    context: context,
    className: "col-span-3 md:col-span-1 lg:col-span-3 xl:col-span-1 p-10 2xl:p-16 bg-secondary-four cursor-pointer hover:opacity-75",
    action: action
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", {
    className: "lg-8 text-secondary-two " + icon,
    style: {
      fontSize: 50
    }
  }), /*#__PURE__*/React.createElement(MarkupText, {
    context: context,
    text: text
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-span-3 md:col-span-2 lg:col-span-3 xl:col-span-2"
  }, image && /*#__PURE__*/React.createElement("img", {
    srcSet: (image === null || image === void 0 ? void 0 : image.mobile) + " 300w, " + (image === null || image === void 0 ? void 0 : image.tablet) + " 768w, " + (image === null || image === void 0 ? void 0 : image.desktop) + " 1280w",
    src: image === null || image === void 0 ? void 0 : image.mobile,
    alt: image === null || image === void 0 ? void 0 : image.alt,
    className: "rounded-4",
    style: {
      maxWidth: '100%',
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    }
  }))));
};
BannerImageIconTextWithActionImageRight.defaultProps = {
  icon: 'fal fa-heart',
  image: DefaultImage,
  text: DefaultText,
  action: DefaultAction
};
BannerImageIconTextWithActionImageRight.human = {
  nl: '',
  fr: '',
  en: ''
};
BannerImageIconTextWithActionImageRight.preview = BannerImageIconTextWithActionImageRight;

var BannerResponsiveImage = function BannerResponsiveImage(_ref) {
  var _data$image, _data$image2, _data$image3, _data$image4, _data$image5;
  var data = _ref.data,
    context = _ref.context;
  var _useWindowDimensions = useWindowDimensions();
  return /*#__PURE__*/React.createElement("div", {
    style: {
      minHeight: context.builder ? 100 : 0
    }
  }, "Responsive image", /*#__PURE__*/React.createElement(ActionLink, {
    action: data === null || data === void 0 ? void 0 : data.action,
    className: "container mt-5 md:mt-10"
  }, /*#__PURE__*/React.createElement("img", {
    srcSet: (data === null || data === void 0 ? void 0 : (_data$image = data.image) === null || _data$image === void 0 ? void 0 : _data$image.mobile) + " 300w, " + (data === null || data === void 0 ? void 0 : (_data$image2 = data.image) === null || _data$image2 === void 0 ? void 0 : _data$image2.tablet) + " 768w, " + (data === null || data === void 0 ? void 0 : (_data$image3 = data.image) === null || _data$image3 === void 0 ? void 0 : _data$image3.desktop) + " 1280w",
    src: data === null || data === void 0 ? void 0 : (_data$image4 = data.image) === null || _data$image4 === void 0 ? void 0 : _data$image4.mobile,
    alt: data === null || data === void 0 ? void 0 : (_data$image5 = data.image) === null || _data$image5 === void 0 ? void 0 : _data$image5.alt,
    className: "w-full"
  })));
};
BannerResponsiveImage.defaultProps = {
  data: {
    image: DefaultImage,
    action: DefaultAction
  }
};
BannerResponsiveImage.human = {
  nl: '',
  fr: '',
  en: ''
};
BannerResponsiveImage.preview = BannerResponsiveImage;

var BannerTwoBlocks = function BannerTwoBlocks(_ref) {
  var block1_text = _ref.block1_text,
    block1_action = _ref.block1_action,
    block2_text = _ref.block2_text,
    block2_action = _ref.block2_action,
    context = _ref.context;
  var _useIsMobile = useIsMobile(),
    isMobile = _useIsMobile.isMobile;
  if (isMobile) {
    return /*#__PURE__*/React.createElement("div", {
      className: "container mx-auto my-5"
    }, /*#__PURE__*/React.createElement(ActionLink, {
      action: block1_action,
      context: context,
      className: "p-10 pb-30 bg-secondary-four text-secondary-five flex items-center justify-end leading-24 " + (block1_action.type !== '' ? 'cursor-pointer' : ''),
      style: {
        borderTopLeftRadius: 50
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1"
    }, /*#__PURE__*/React.createElement(MarkupText, {
      text: block1_text,
      context: context
    })), block1_action.type !== '' && /*#__PURE__*/React.createElement("i", {
      className: "fal fa-long-arrow-right font-normal text-20 ml-8"
    })), /*#__PURE__*/React.createElement(ActionLink, {
      action: block2_action,
      context: context,
      className: "p-10 bg-secondary-two pb-30 text-white flex items-center justify-end leading-24 -mt-20 " + (block2_action.type !== '' ? 'cursor-pointer' : ''),
      style: {
        borderTopLeftRadius: 50,
        borderBottomRightRadius: 50
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1"
    }, /*#__PURE__*/React.createElement(MarkupText, {
      text: block2_text,
      context: context
    })), block2_action.type !== '' && /*#__PURE__*/React.createElement("i", {
      className: "fal fa-long-arrow-right font-normal text-20 ml-8"
    })));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "flex-row items-center justify-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container mx-auto my-10 grid-cols-2 grid gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col bg-secondary-four rounded-4 p-10 justify-end leading-24"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 mb-2"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: block1_text,
    context: context
  })), block1_action.type !== '' && /*#__PURE__*/React.createElement(ActionLink, {
    action: block1_action,
    context: context,
    className: "primary-button mt-4"
  }, block1_action.title, " ", /*#__PURE__*/React.createElement("i", {
    className: "fal fa-long-arrow-right ml-2 font-normal"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col bg-secondary-two rounded-4 p-10 font-secondary text-white leading-24"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 mb-2"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: block2_text,
    context: context
  })), block2_action.type !== '' && /*#__PURE__*/React.createElement(ActionLink, {
    action: block2_action,
    context: context,
    className: "ternary-button mt-4"
  }, block2_action.title, " ", /*#__PURE__*/React.createElement("i", {
    className: "fal fa-long-arrow-right ml-2 font-normal"
  })))));
};
BannerTwoBlocks.defaultProps = {
  block1_text: DefaultText,
  block1_image: DefaultImage,
  block1_action: DefaultAction,
  block2_text: DefaultText,
  block2_action: DefaultAction,
  block3_text: DefaultText,
  block3_action: DefaultAction
};
BannerTwoBlocks.human = {
  nl: '',
  fr: '',
  en: ''
};
BannerTwoBlocks.preview = BannerTwoBlocks;

var BannerUspWithQuotes = function BannerUspWithQuotes(_ref) {
  var _quotes$currentQuoteI, _quotes$currentQuoteI2, _quotes$currentQuoteI3, _quotes$currentQuoteI4, _quotes$currentQuoteI5, _quotes$currentQuoteI6;
  var title = _ref.title,
    usps = _ref.usps,
    quotes = _ref.quotes,
    videos = _ref.videos,
    context = _ref.context;
  var _useState = useState(0),
    currentQuoteIndex = _useState[0],
    setCurrentQuoteIndex = _useState[1];
  var _useState2 = useState(false),
    isPlaying = _useState2[0],
    setIsPlaying = _useState2[1];
  var _useState3 = useState(false),
    isHovering = _useState3[0],
    setIsHovering = _useState3[1];
  var _useWindowDimensions = useWindowDimensions(),
    width = _useWindowDimensions.width;
  var videoRef = useRef();
  var changeDuration = 10;
  useEffect(function () {
    var interval = setInterval(function () {
      var max = quotes.length - 1;
      if (currentQuoteIndex === max) {
        setCurrentQuoteIndex(0);
      } else {
        setCurrentQuoteIndex(currentQuoteIndex + 1);
      }
    }, changeDuration * 1000);
    return function () {
      return clearInterval(interval);
    };
  }, [currentQuoteIndex]);
  var video = head(videos);
  var onVideoPlay = function onVideoPlay() {
    setIsPlaying(true);
    if (videoRef && videoRef.current) {
      videoRef.current.play();
    }
  };
  var onVideoPause = function onVideoPause() {
    setIsPlaying(false);
    if (videoRef && videoRef.current) {
      videoRef.current.pause();
    }
  };
  var handleHover = function handleHover() {
    setIsHovering(!isHovering);
  };
  var calculateHeight = function calculateHeight() {
    var height = 350;
    if (width < 768) height = 'auto';
    if (width > 768) height = 260;
    if (width > 1024) height = 340;
    if (width > 1280) height = 395;
    if (width > 1440) height = 495;
    return height;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "container mx-auto"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "mb-5 md:mb-16"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: title,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-y-4 gap-x-2 w-full mb-5 md:mb-12"
  }, map(usps, function (usp, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: "usp-" + i
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center mb-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center mr-2",
      style: {
        width: 36
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: usp.icon + " text-secondary-two text-20"
    })), /*#__PURE__*/React.createElement("div", {
      className: "text-15 text-primary w-full truncate font-secondary"
    }, usp.title)), usp.text && /*#__PURE__*/React.createElement("div", {
      className: "paragraph-default text-left"
    }, /*#__PURE__*/React.createElement(MarkupText, {
      text: usp.text,
      context: context
    })));
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-3 gap-4 overflow-hidden",
    style: {
      height: calculateHeight()
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative col-span-2",
    style: {
      height: calculateHeight()
    },
    onMouseEnter: function onMouseEnter() {
      return handleHover();
    },
    onMouseLeave: function onMouseLeave() {
      return handleHover();
    }
  }, !isPlaying && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center absolute left-0 top-0 right-0 bottom-0 z-50",
    onClick: function onClick() {
      return onVideoPlay();
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fab fa-youtube text-white cursor-pointer",
    style: {
      fontSize: 60
    }
  })), isPlaying && isHovering && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center absolute left-0 top-0 right-0 bottom-0 z-50",
    onClick: function onClick() {
      return onVideoPause();
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-pause-circle text-white cursor-pointer",
    style: {
      fontSize: 60
    }
  })), video && /*#__PURE__*/React.createElement("video", {
    width: "100%",
    muted: false,
    autoPlay: false,
    loop: true,
    playsinline: true,
    ref: videoRef
  }, /*#__PURE__*/React.createElement("source", {
    src: video + '#t=0.001',
    type: "video/mp4"
  }))), quotes.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block quotes relative",
    role: "img",
    "aria-label": (_quotes$currentQuoteI = quotes[currentQuoteIndex]) === null || _quotes$currentQuoteI === void 0 ? void 0 : (_quotes$currentQuoteI2 = _quotes$currentQuoteI.image) === null || _quotes$currentQuoteI2 === void 0 ? void 0 : _quotes$currentQuoteI2.alt,
    title: (_quotes$currentQuoteI3 = quotes[currentQuoteIndex]) === null || _quotes$currentQuoteI3 === void 0 ? void 0 : (_quotes$currentQuoteI4 = _quotes$currentQuoteI3.image) === null || _quotes$currentQuoteI4 === void 0 ? void 0 : _quotes$currentQuoteI4.alt,
    style: {
      backgroundImage: "url(" + ((_quotes$currentQuoteI5 = quotes[currentQuoteIndex]) === null || _quotes$currentQuoteI5 === void 0 ? void 0 : (_quotes$currentQuoteI6 = _quotes$currentQuoteI5.image) === null || _quotes$currentQuoteI6 === void 0 ? void 0 : _quotes$currentQuoteI6.desktop) + ")",
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      height: calculateHeight()
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center absolute text-white bottom-0 left-0 right-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center bg-secondary-two mb-2 rounded-full",
    style: {
      width: 40,
      height: 40
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-quote-left text-white"
  })), /*#__PURE__*/React.createElement("div", {
    className: "px-10 pb-10"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: quotes[currentQuoteIndex].quote,
    context: context
  }), quotes[currentQuoteIndex].name && - /*#__PURE__*/React.createElement("span", {
    className: "text-16 font-primary"
  }, quotes[currentQuoteIndex].name))))));
};
BannerUspWithQuotes.defaultProps = {
  title: DefaultTitleActionAndItems,
  quotes: [],
  usps: []
};
BannerUspWithQuotes.human = {
  nl: '',
  fr: '',
  en: ''
};
BannerUspWithQuotes.preview = function () {
  return /*#__PURE__*/React.createElement("div", null, " USP with quotes");
};

var Paragraph = function Paragraph(_ref) {
  var text = _ref.text,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "container mx-auto flex leading-24 my-7 md:my-12",
    style: {
      minHeight: 30
    }
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: text,
    context: context
  }));
};
Paragraph.human = {
  nl: '',
  fr: '',
  en: ''
};
Paragraph.preview = Paragraph;

var Banner = function Banner(_ref) {
  var primary_action = _ref.primary_action,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      minHeight: 50
    }
  }, "Test action", /*#__PURE__*/React.createElement(ActionLink, {
    action: _extends({}, primary_action.action, {
      title: primary_action.title
    }),
    context: context
  }));
};
Banner.defaultProps = {
  title: DefaultTitle,
  text: DefaultText,
  primary_action: DefaultAction,
  secondary_action: DefaultAction
};
Banner.human = {
  nl: 'Banner black',
  fr: '',
  en: ''
};
Banner.preview = Banner;

var Breadcrumbs = function Breadcrumbs(_ref) {
  var languages = ['en', 'fr', 'nl'];
  var paths = [{
    key: 'home',
    url: '/'
  }];
  if (hasWindow()) {
    var subs = window.location.pathname.split('/');
    forEach(subs, function (sub) {
      if (sub !== '' && !includes(languages, sub)) {
        paths.push({
          key: sub,
          url: "/" + sub
        });
      }
    });
  }
  var handleClick = function handleClick(i, path) {
    if (i < paths.length - 1) {
      window.location = path;
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex container mx-auto font-secondary font-extralight mt-4",
    style: {
      color: '#34424866'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, map(paths.filter(function (p) {
    return !languages.includes(p.key.toLowerCase());
  }), function (path, i) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center space-x-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "" + (i < paths.length - 1 ? 'cursor-pointer' : ''),
      onClick: function onClick() {
        return handleClick(i, path.url);
      }
    }, capitalize(path.key)), i < paths.length - 1 && /*#__PURE__*/React.createElement("i", {
      className: "far fa-chevron-right pr-2 font-extralight text-12"
    }));
  })));
};
Breadcrumbs.defaultProps = {};
Breadcrumbs.human = {
  nl: '',
  fr: '',
  en: ''
};
Breadcrumbs.preview = Breadcrumbs;

var Default = function Default() {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", null, "Empty template for customer"));
};
Default.human = {
  nl: '',
  fr: '',
  en: ''
};
Default.preview = Default;

var logoAutralis = "logo-autralis-white~KrmaLUaO.svg";

var useAsset = function useAsset(resource) {
  return require("/" + resource)["default"];
};
var resolveDeliveryCost = function resolveDeliveryCost(productsAndServices) {
  if (!productsAndServices) return undefined;
  return find(productsAndServices, function (product) {
    return product.code === 'delivery_cost';
  });
};

var FooterTopWay = function FooterTopWay(_ref) {
  var items = _ref.items,
    social = _ref.social,
    copyright = _ref.copyright,
    brand_logos = _ref.brand_logos,
    bottom_actions = _ref.bottom_actions,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useIsMobile = useIsMobile(),
    isMobile = _useIsMobile.isMobile;
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-secondary-four"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full py-9"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container mx-auto text-white pb-0 md:pb-9 border-none md:border-b md:border-secondary-eight"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row md:justify-between"
  }, map(items, function (item, i) {
    var bottomSpace = isMobile && (i === 1 || i > 0 && i % 3 === 0) ? 'mb-4' : '';
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ActionLink, {
      key: "footer-item-" + i,
      action: item,
      context: context,
      className: "paragraph-default text-center md:text-left text-secondary-five cursor-pointer hover:text-secondary-two hover:underline " + bottomSpace
    }));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center md:justify-between md:flex-col 3xl:flex-row container mx-auto mt-4 md:mt-9"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden md:flex 3xl:mr-2"
  }, map(brand_logos, function (item, i) {
    var isLast = brand_logos.length - 1 === i;
    var logoUrl = item && item.image && typeof item.image === 'object' ? item.image.desktop : item;
    var logoAlt = item && item.image && typeof item.image === 'object' ? item.image.alt : 'ALT';
    return /*#__PURE__*/React.createElement("div", {
      key: "brand-logo-" + i,
      className: "" + (isLast ? 'mr-0' : 'mr-9'),
      style: {
        height: 40
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: logoUrl,
      alt: logoAlt,
      style: {
        maxHeight: '100%'
      }
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col 3xl:flex-row paragraph-default text-secondary-five xl:mt-5 3xl:mt-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mr-1"
  }, t('Follow us'), ":"), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, map(social, function (s, i) {
    return /*#__PURE__*/React.createElement(ExternalLink, {
      context: context,
      url: s.url,
      className: "mr-3"
    }, /*#__PURE__*/React.createElement("i", {
      className: DefaultSocialMediaIcons[s.type]
    }), ' ');
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center bg-secondary-three w-full py-9 md:py-0",
    style: {
      height: isMobile ? 'auto' : 50
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col-reverse md:flex-row justify-center md:justify-between items-center container mx-auto text-white font-normal"
  }, /*#__PURE__*/React.createElement(ExternalLink, {
    context: context,
    style: {
      height: 15
    },
    className: "mr-5 md:mr-0 mt-4 md:mt-0",
    url: "https://www.autralis.com"
  }, /*#__PURE__*/React.createElement("img", {
    src: useAsset(logoAutralis),
    alt: "autralis",
    style: {
      height: 15
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, map(bottom_actions, function (action, i) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ActionLink, {
      action: action,
      context: context,
      className: "hover:underline cursor-pointer"
    }), /*#__PURE__*/React.createElement("div", {
      className: "ml-4 mr-4"
    }, "|"));
  }), /*#__PURE__*/React.createElement(MarkupText, {
    text: copyright,
    context: context
  })))));
};
FooterTopWay.defaultProps = {};
FooterTopWay.human = {
  nl: 'Footer',
  fr: 'Footer',
  en: 'Footer'
};
FooterTopWay.preview = FooterTopWay;

var FavoriteBtn = function FavoriteBtn(_ref) {
  var onClick = _ref.onClick,
    totalFavoritesCount = _ref.totalFavoritesCount;
  return /*#__PURE__*/React.createElement("div", {
    className: "relative cursor-pointer",
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 30
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: (totalFavoritesCount > 0 ? 'fas fa-heart' : 'far fa-heart') + " text-secondary-two text-28"
  })));
};
var FavoriteBtn$1 = baseMenuFavoritesBtn(FavoriteBtn);

var LanguagePicker = function LanguagePicker(_ref) {
  var availableLanguages = _ref.availableLanguages,
    currentLanguage = _ref.currentLanguage,
    onLanguageChanged = _ref.onLanguageChanged;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex h-full"
  }, map(availableLanguages, function (language) {
    var isSelected = language.code === currentLanguage;
    return /*#__PURE__*/React.createElement("div", {
      className: "p-3 md:p-0 flex items-center justify-center cursor-pointer uppercase " + (isSelected ? 'bg-secondary-two text-white' : 'text-secondary-five'),
      onClick: function onClick() {
        return onLanguageChanged(language.code);
      },
      style: {
        minWidth: 36
      }
    }, language.code);
  }));
};
var LanguagePicker$1 = baseLanguagePicker(LanguagePicker, true);

var HeaderNavigation = function HeaderNavigation(_ref) {
  var _context$availableLan;
  var links = _ref.links,
    wrapperClasses = _ref.wrapperClasses,
    showSublinks = _ref.showSublinks,
    context = _ref.context;
  var _useState = useState(null),
    activeLink = _useState[0],
    setActiveLink = _useState[1];
  var _useIsMobile = useIsMobile(),
    isMobile = _useIsMobile.isMobile,
    isTablet = _useIsMobile.isTablet;
  var promotionTitle = 'Top deals';
  var renderSublinks = function renderSublinks(subLinks) {
    return /*#__PURE__*/React.createElement("div", {
      className: "absolute border border-black px-6 pt-6 pb-5 z-40 text-white hidden md:flex flex-col",
      style: {
        top: 20,
        minWidth: 200,
        width: 'max-content',
        backgroundColor: 'rgba(0, 0, 0, 0.8'
      }
    }, subLinks.map(function (subLink, i) {
      return /*#__PURE__*/React.createElement(ActionLink, {
        key: subLink.title + "-" + i,
        action: subLink,
        context: context,
        className: "mb-2 hover:text-gray-400 cursor-pointer"
      });
    }));
  };
  var rootLinks = links.filter(function (link) {
    return link.level === 0;
  });
  if (isMobile || isTablet) {
    return rootLinks.map(function (rootLink, i) {
      var isLast = rootLinks.length - 1 === i;
      return /*#__PURE__*/React.createElement(ActionLink, {
        key: rootLink.id,
        action: rootLink,
        context: context,
        className: "flex relative mb-3 " + (isLast ? 'pl-1 md:pl-3' : 'px-1 md:px-3 mr-10') + " " + wrapperClasses
      });
    });
  }
  var getPaths = function getPaths() {
    var languages = ['en', 'fr', 'nl'];
    var paths = [];
    if (hasWindow()) {
      var subs = window.location.pathname.split('/');
      forEach(subs, function (sub) {
        if (sub !== '' && !includes(languages, sub)) {
          paths.push({
            key: sub,
            url: "/" + sub
          });
        }
      });
    }
    return paths;
  };
  var checkIfActive = function checkIfActive(url) {
    var paths = getPaths();
    var pathKey = '';
    var key = head(filter(config.urls, function (value, key) {
      return value === url;
    }));
    if (key) {
      pathKey = config.urlsMultiLanguage[key] ? config.urlsMultiLanguage[key][context.culture] : '';
    }
    return filter(paths, function (p) {
      return p.key === pathKey;
    }).length > 0;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center w-full h-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center  h-full"
  }, rootLinks.map(function (rootLink, i) {
    var subLinks = showSublinks ? links.filter(function (link) {
      return link.level === 1 && link.parent === rootLink.id;
    }) : [];
    var isActive = checkIfActive(rootLink.url);
    var isLast = rootLinks.length - 1 === i;
    return /*#__PURE__*/React.createElement("div", {
      key: rootLink.id,
      className: "flex items-center h-full relative mb-3 md:mb-0 border-t-4 " + (isLast ? 'mr-0' : 'mr-16') + " " + (isActive && rootLink.title !== promotionTitle ? ' border-secondary-two' : 'border-transparent') + " " + wrapperClasses,
      onMouseEnter: function onMouseEnter() {
        return setActiveLink(rootLink.id);
      },
      onMouseLeave: function onMouseLeave() {
        return setActiveLink(null);
      }
    }, /*#__PURE__*/React.createElement(ActionLink, {
      action: rootLink,
      context: context,
      className: "flex cursor-pointer font-semibold text-15 " + (rootLink.title == promotionTitle ? 'text-secondary-two' : 'text-secondary-three hover:text-secondary-two')
    }, /*#__PURE__*/React.createElement(React.Fragment, null, rootLink.title, subLinks.length > 0 && /*#__PURE__*/React.createElement("i", {
      className: "fas fa-angle-down text-secondary-three ml-2 ",
      style: {
        marginTop: 5
      }
    }))), subLinks.length > 0 && activeLink === rootLink.id && renderSublinks(subLinks));
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex space-x-4"
  }, context.favorites && /*#__PURE__*/React.createElement(FavoriteBtn$1, {
    context: context
  }), ((_context$availableLan = context.availableLanguages) === null || _context$availableLan === void 0 ? void 0 : _context$availableLan.length) > 1 && /*#__PURE__*/React.createElement(LanguagePicker$1, {
    context: context
  })));
};
HeaderNavigation.defaultProps = {
  links: [],
  wrapperClasses: '',
  showSublinks: true
};

var HamburgerMenu = function HamburgerMenu(_ref) {
  var render = _ref.render,
    color = _ref.color;
  var _useState = useState(false),
    hamburgerOpen = _useState[0],
    setHamburgerOpen = _useState[1];
  useEffect(function () {
    var root = document.getElementById('root');
    var body = document.getElementsByTagName('BODY')[0];
    if (hamburgerOpen) {
      if (root) root.classList.add('overflow-hidden');
      if (body) body.classList.add('overflow-hidden');
    }
    if (!hamburgerOpen) {
      if (root && root.classList.contains('overflow-hidden')) root.classList.remove('overflow-hidden');
      if (body && body.classList.contains('overflow-hidden')) body.classList.remove('overflow-hidden');
    }
  }, [hamburgerOpen]);
  return /*#__PURE__*/React.createElement("div", {
    className: "flex self-center h-full justify-center items-center relative"
  }, /*#__PURE__*/React.createElement("div", {
    id: "nav-icon",
    className: hamburgerOpen ? 'open' : '',
    onClick: function onClick() {
      return setHamburgerOpen(!hamburgerOpen);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: color
  }), /*#__PURE__*/React.createElement("span", {
    className: color
  }), /*#__PURE__*/React.createElement("span", {
    className: color
  })), /*#__PURE__*/React.createElement(Fade, {
    right: true,
    when: hamburgerOpen,
    duration: 500
  }, render(hamburgerOpen, function () {
    return setHamburgerOpen(false);
  }, function () {
    return setHamburgerOpen(true);
  })));
};
HamburgerMenu.defaultProps = {
  color: 'bg-black'
};

var height = 60;
var HeaderMobile = function HeaderMobile(_ref) {
  var _logo$image, _logo$image2, _logo$image3, _logo$image4, _logo$image5;
  var logo = _ref.logo,
    links = _ref.links,
    context = _ref.context;
  var _useTranslation = useTranslation();
  var rootLinks = filter(links, function (link) {
    return link.level === 0;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-white border-b border-gray-400 sticky-header ",
    style: {
      height: height
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between container mx-auto h-full"
  }, /*#__PURE__*/React.createElement(ActionLink, {
    action: logo === null || logo === void 0 ? void 0 : logo.action,
    context: context,
    className: "flex items-center justify-center mr-5 bg-primary-transparent"
  }, /*#__PURE__*/React.createElement("img", {
    srcSet: (logo === null || logo === void 0 ? void 0 : (_logo$image = logo.image) === null || _logo$image === void 0 ? void 0 : _logo$image.mobile) + " 300w, " + (logo === null || logo === void 0 ? void 0 : (_logo$image2 = logo.image) === null || _logo$image2 === void 0 ? void 0 : _logo$image2.tablet) + " 768w, " + (logo === null || logo === void 0 ? void 0 : (_logo$image3 = logo.image) === null || _logo$image3 === void 0 ? void 0 : _logo$image3.desktop) + " 1280w",
    src: logo === null || logo === void 0 ? void 0 : (_logo$image4 = logo.image) === null || _logo$image4 === void 0 ? void 0 : _logo$image4.mobile,
    alt: logo === null || logo === void 0 ? void 0 : (_logo$image5 = logo.image) === null || _logo$image5 === void 0 ? void 0 : _logo$image5.alt,
    style: {
      maxHeight: height - 20
    },
    className: "cursor-pointer"
  })), /*#__PURE__*/React.createElement(HamburgerMenu, {
    color: "bg-primary",
    render: function render(isOpen, onMenuClose, onMenuOpen) {
      var _context$availableLan;
      return /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col p-6 fixed h-screen right-0 left-0 bg-white text-primary " + (!isOpen && 'hidden'),
        style: {
          top: 60,
          minWidth: 280,
          zIndex: 99999
        }
      }, rootLinks.length > 0 && rootLinks.map(function (rootLink, i) {
        return /*#__PURE__*/React.createElement("div", {
          key: "root-link-" + i
        }, /*#__PURE__*/React.createElement(ActionLink, {
          action: rootLink,
          context: context,
          className: "flex relative pb-5 mb-5 -mx-6 px-6 paragraph-bold border-b border-gray-200 text-16"
        }, rootLink.title));
      }), /*#__PURE__*/React.createElement("div", {
        className: "flex items-center justify-between w-full paragraph-bold text-16 mt-5"
      }, context.favorites && /*#__PURE__*/React.createElement(FavoriteBtn$1, {
        context: context
      }), ((_context$availableLan = context.availableLanguages) === null || _context$availableLan === void 0 ? void 0 : _context$availableLan.length) > 1 && /*#__PURE__*/React.createElement(LanguagePicker$1, {
        context: context
      })));
    }
  })));
};

var HeaderTopWay = function HeaderTopWay(_ref) {
  var logo = _ref.logo,
    links = _ref.links,
    top_links = _ref.top_links,
    context = _ref.context;
  useEffect(function () {
    if (hasDocument()) {
      var el = head(document.getElementsByClassName('desktop-header'));
      if (el !== null && el !== void 0 && el.parentNode) {
        el === null || el === void 0 ? void 0 : el.parentNode.classList.add('sticky', 'top-0', 'w-full', 'bg-white', 'z-50');
      }
    }
  }, []);
  var renderMobileContent = function renderMobileContent() {
    return /*#__PURE__*/React.createElement(Sticky, {
      top: 0,
      activeClass: "w-full",
      innerZ: 100
    }, /*#__PURE__*/React.createElement(HeaderMobile, {
      links: links,
      logo: logo,
      context: context
    }));
  };
  var renderDesktopContent = function renderDesktopContent() {
    var _logo$image, _logo$image2, _logo$image3, _logo$image4, _logo$image5;
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col w-full sticky-header bg-white border-b border-secondary-eight items-start justify-start"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex bg-secondary-four px-5 xl:px-0 w-full",
      style: {
        height: 30
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center container mx-auto font-secondary text-14 text-secondary-five font-semibold"
    }, map(top_links, function (link, i) {
      var isLast = top_links.length - 1 === i;
      if (isLast) {
        return /*#__PURE__*/React.createElement("div", {
          className: "flex-1 flex justify-end"
        }, /*#__PURE__*/React.createElement(ActionLink, {
          key: "header-link-" + i,
          action: link,
          context: context,
          className: "flex cursor-pointer hover:underline"
        }));
      }
      return /*#__PURE__*/React.createElement(ActionLink, {
        key: "header-link-" + i,
        action: link,
        context: context,
        className: "flex cursor-pointer hover:underline mr-7"
      });
    }))), /*#__PURE__*/React.createElement("div", {
      className: "flex z-50 w-full",
      style: {
        height: 80
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "container mx-auto"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center header-sticky bg-transparent w-full",
      style: {
        height: 80
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-1/4 flex items-center justify-start",
      style: {
        height: 80
      }
    }, /*#__PURE__*/React.createElement(ActionLink, {
      action: logo === null || logo === void 0 ? void 0 : logo.action,
      context: context
    }, /*#__PURE__*/React.createElement("img", {
      srcSet: (logo === null || logo === void 0 ? void 0 : (_logo$image = logo.image) === null || _logo$image === void 0 ? void 0 : _logo$image.mobile) + " 300w, " + (logo === null || logo === void 0 ? void 0 : (_logo$image2 = logo.image) === null || _logo$image2 === void 0 ? void 0 : _logo$image2.tablet) + " 768w, " + (logo === null || logo === void 0 ? void 0 : (_logo$image3 = logo.image) === null || _logo$image3 === void 0 ? void 0 : _logo$image3.desktop) + " 1280w",
      src: logo === null || logo === void 0 ? void 0 : (_logo$image4 = logo.image) === null || _logo$image4 === void 0 ? void 0 : _logo$image4.mobile,
      alt: logo === null || logo === void 0 ? void 0 : (_logo$image5 = logo.image) === null || _logo$image5 === void 0 ? void 0 : _logo$image5.alt,
      style: {
        maxHeight: 75
      },
      className: "cursor-pointer"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1 justify-start h-full items-center font-secondary font-normal"
    }, /*#__PURE__*/React.createElement(HeaderNavigation, {
      context: context,
      links: links,
      wrapperClasses: "text-primary"
    }))))));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "block 2xl:hidden"
  }, renderMobileContent()), /*#__PURE__*/React.createElement("div", {
    className: "hidden 2xl:flex desktop-header 2xl:sticky 2xl:top-0 bg-white z-50"
  }, renderDesktopContent()));
};
HeaderTopWay.defaultProps = {
  logo: DefaultImage,
  links: DefaultLinks,
  top_links: DefaultLinks
};
HeaderTopWay.human = {
  nl: 'Header',
  fr: 'Header',
  en: 'Header'
};
HeaderTopWay.preview = HeaderTopWay;

var Privacy = function Privacy(_ref) {
  var text = _ref.text,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center py-5 md:py-20"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container relative z-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: text,
    context: context
  })))));
};
Privacy.defaultProps = {
  text: DefaultText
};
Privacy.human = {
  nl: '',
  fr: '',
  en: ''
};
Privacy.preview = function () {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center py-5 md:py-20"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container relative z-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center"
  }, "Privacybeleid"))));
};

var Separator = function Separator() {
  return /*#__PURE__*/React.createElement("div", {
    className: "container mx-auto my-5 xl:my-16"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: 2
    },
    className: "bg-secondary-four"
  }));
};
Separator.human = {
  nl: '',
  fr: '',
  en: ''
};
Separator.preview = Separator;

var CookieBanner = function CookieBanner(_ref) {
  var view = _ref.view,
    viewTypes = _ref.viewTypes,
    analyticsAccepted = _ref.analyticsAccepted,
    onAcceptAll = _ref.onAcceptAll,
    onShowSettings = _ref.onShowSettings,
    onAnalyticsChanged = _ref.onAnalyticsChanged,
    onSaveSettings = _ref.onSaveSettings,
    onPrivacyClick = _ref.onPrivacyClick,
    location = _ref.location,
    visible = _ref.visible;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var renderBanner = function renderBanner() {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col md:flex-row justify-between items-center container mx-auto"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1 font-secondary"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hidden md:flex items-center justify-center mr-4"
    }, /*#__PURE__*/React.createElement("i", {
      className: "fad fa-cookie-bite text-4xl "
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col"
    }, /*#__PURE__*/React.createElement("div", null, t('This website uses cookies to improve your experience.')), /*#__PURE__*/React.createElement("div", null, t('Click'), /*#__PURE__*/React.createElement("span", {
      className: "underline ml-1 mr-1 cursor-pointer outline-none",
      onClick: onPrivacyClick
    }, t('here')), /*#__PURE__*/React.createElement("span", null, t('to see how cookies work and why we use them.'))))), /*#__PURE__*/React.createElement("div", {
      className: "ml-0 md:ml-5 mt-5 md:mt-0"
    }, /*#__PURE__*/React.createElement("button", {
      className: "primary-button mr-2",
      onClick: onAcceptAll
    }, t('Accept')), /*#__PURE__*/React.createElement("button", {
      className: "primary-button",
      onClick: onShowSettings
    }, t('Settings'))));
  };
  var renderSettings = function renderSettings() {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1 items-center flex-col md:flex-row container mx-auto"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col flex-1 w-full md-4/5"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex w-4/5 mb-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "mr-2"
    }, /*#__PURE__*/React.createElement(Switch, {
      disabled: true,
      checked: true,
      onColor: "#00AFFF",
      width: 40,
      height: 20
    })), /*#__PURE__*/React.createElement("div", {
      className: "font-secondary"
    }, /*#__PURE__*/React.createElement("div", {
      className: "font-semibold"
    }, t('Necessary cookies')), /*#__PURE__*/React.createElement("div", {
      className: ""
    }, t('Some cookies are required for basic functionalities. The website will not work properly without it, so they are active by default and cannot be disabled.')))), /*#__PURE__*/React.createElement("div", {
      className: "flex w-4/5"
    }, /*#__PURE__*/React.createElement("div", {
      className: "mr-2"
    }, /*#__PURE__*/React.createElement(Switch, {
      onChange: function onChange(checked) {
        return onAnalyticsChanged(checked);
      },
      checked: analyticsAccepted,
      onColor: "#00AFFF",
      width: 40,
      height: 20
    })), /*#__PURE__*/React.createElement("div", {
      className: "font-secondary"
    }, /*#__PURE__*/React.createElement("div", {
      className: "font-semibold"
    }, t('Analytics cookies')), /*#__PURE__*/React.createElement("div", {
      className: ""
    }, t('Analytics cookies help us improve this website by collecting information and behavior.'))))), /*#__PURE__*/React.createElement("div", {
      className: "ml-0 md:ml-5 mt-5 md:mt-0"
    }, /*#__PURE__*/React.createElement("button", {
      className: "primary-button",
      onClick: onSaveSettings
    }, t('Save'))));
  };
  var borderClassName = 'border-t';
  if (location === 'top') {
    borderClassName = "border-b";
  }
  var positionClassName = location === 'top' ? 'top-0' : 'bottom-0';
  var hideClassName = location === 'top' ? '-translate-y-full' : 'translate-y-full';
  return /*#__PURE__*/React.createElement("div", {
    id: "cookies-container",
    className: "flex flex-col py-5 px-5 fixed left-0 right-0 bg-white transform transition-all duration-300 " + positionClassName + " " + borderClassName + " " + (visible ? 'translate-y-0' : hideClassName),
    style: {
      zIndex: 99999
    }
  }, view === viewTypes.banner && renderBanner(), view === viewTypes.settings && renderSettings());
};
var CookieBanner$1 = baseCookieBanner(CookieBanner);

var FinanceBanner = function FinanceBanner(_ref) {
  var Content = _ref.Content,
    onAcceptLegal = _ref.onAcceptLegal,
    visible = _ref.visible,
    location = _ref.location;
  var _useWindowDimensions = useWindowDimensions(),
    width = _useWindowDimensions.width;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    if (width > 0 && width <= 768) {
      toggleBodyScroll(visible ? 'hidden' : 'scroll');
    }
  }, [visible, width]);
  var enableBodyScroll = function enableBodyScroll() {
    toggleBodyScroll('scroll');
  };
  var toggleBodyScroll = function toggleBodyScroll(type) {
    if (document && width > 0 && width <= 768) {
      document.body.style.overflow = type;
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "fixed left-0 right-0 " + location + "-0 text-white py-8",
    style: {
      zIndex: 9999999,
      backgroundColor: 'rgba(0, 0, 0, 0.9)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container flex flex-col md:flex-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-80 overflow-y-scroll md:h-auto mr-0 md:mr-5 finance-scrollbar scrollbar-snap-y"
  }, Content), /*#__PURE__*/React.createElement("div", {
    className: "flex items-start flex-none mt-5 md:mt-3"
  }, /*#__PURE__*/React.createElement("button", {
    className: "primary-button",
    onClick: function onClick() {
      onAcceptLegal();
      enableBodyScroll();
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-check mr-2"
  }), t('Accept')))));
};
var FinanceBanner$1 = baseFinancingBanner(FinanceBanner);

var FinancingTextBlock = function FinancingTextBlock(_ref) {
  var Content = _ref.Content,
    loading = _ref.loading;
  if (loading) {
    return /*#__PURE__*/React.createElement(LoadingIndicator$1, null);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mr-1"
  }, "*"), Content);
};
var FinancingTextBlock$1 = baseFinancingContent(FinancingTextBlock);

var SeoBlockAndText = function SeoBlockAndText(_ref) {
  var text = _ref.text,
    items = _ref.items,
    context = _ref.context;
  var _useState = useState(''),
    activeTab = _useState[0],
    setActiveTab = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useIsMobile = useIsMobile(),
    isMobile = _useIsMobile.isMobile;
  var cleanTitle = function cleanTitle(title) {
    return title.toLowerCase().replace(' ', '_');
  };
  if (isMobile) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1 flex-col container mx-auto mb-5 md:mb-12"
    }, /*#__PURE__*/React.createElement("div", {
      className: "mb-10"
    }, /*#__PURE__*/React.createElement(MarkupText, {
      text: text,
      context: context
    })), /*#__PURE__*/React.createElement("div", {
      className: "font-secondary"
    }, map(items, function (item, i) {
      var isLast = items.length - 1 === i;
      var isActive = cleanTitle(item.title) === activeTab;
      return /*#__PURE__*/React.createElement("div", {
        key: "seo-item-" + i,
        className: ""
      }, /*#__PURE__*/React.createElement("h5", {
        className: "flex justify-between items-center font-secondary font-normal cursor-pointer text-primary p-3 px-6 border-secondary-light " + (isLast && !isActive ? 'border-t border-b' : 'border-t'),
        onClick: function onClick() {
          return setActiveTab(isActive ? '' : cleanTitle(item.title));
        }
      }, item.title, " ", /*#__PURE__*/React.createElement("i", {
        className: "far fa-angle-down text-secondary-two"
      })), isActive && /*#__PURE__*/React.createElement("div", {
        className: "px-6 " + (isActive ? 'border-b border-secondary-light' : '')
      }, /*#__PURE__*/React.createElement("h6", {
        className: "flex mb-2 cursor-pointer text-primary-light hover:underline"
      }, /*#__PURE__*/React.createElement(ActionLink, {
        action: item.action
      }, t('Alle'))), map(item.items, function (subItem, i2) {
        return /*#__PURE__*/React.createElement("h6", {
          key: "block_item_" + i + "_" + i2,
          className: "flex mb-2 cursor-pointer text-primary-light hover:underline"
        }, /*#__PURE__*/React.createElement(ActionLink, {
          action: subItem.action
        }, subItem.title));
      })));
    })));
  }
  var gridClass = items.length < 6 ? "grid-cols-" + items.length : 'grid-cols-6';
  var mapText = function mapText(text) {
    var mapped;
    if (text.toLowerCase().includes('audi') && text.toLowerCase().startsWith('audi')) {
      mapped = text.toLowerCase().replace('audi', '');
    } else {
      if (text.toLowerCase().includes('volkswagen') && text.toLowerCase().startsWith('volkswagen')) {
        mapped = text.toLowerCase().replace('volkswagen', '');
      } else {
        if (text.toLowerCase().includes('seat') && text.toLowerCase().startsWith('seat')) {
          mapped = text.toLowerCase().replace('seat', '');
        } else {
          if (text.toLowerCase().includes('skoda') && text.toLowerCase().startsWith('skoda')) {
            mapped = text.toLowerCase().replace('skoda', '');
          } else {
            if (text.toLowerCase().includes('dcc') && text.toLowerCase().startsWith('dcc')) {
              mapped = text.toLowerCase().replace('dcc', '');
            } else {
              mapped = text;
            }
          }
        }
      }
    }
    return mapped;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 flex-col container mx-auto mb-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-10"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: text,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid " + gridClass + " gap-4 mb-6 font-secondary"
  }, map(items, function (item, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: "block_" + i,
      className: "mb-10"
    }, /*#__PURE__*/React.createElement("h5", {
      className: "flex mb-2 font-normal cursor-pointer text-secondary-three font-semibold font-secondary"
    }, /*#__PURE__*/React.createElement(ActionLink, {
      action: _extends({}, item.action, {
        title: item.title
      }),
      context: context
    })), map(item.items, function (subItem, i2) {
      var mappedText = mapText(subItem.title);
      return /*#__PURE__*/React.createElement("h6", {
        key: "block_item_desktop_" + i + "_" + i2,
        className: "flex mb-2 cursor-pointer text-secondary-two hover:underline capitalize"
      }, /*#__PURE__*/React.createElement(ActionLink, {
        action: _extends({}, subItem.action, {
          title: subItem.title
        }),
        context: context
      }));
    }));
  })));
};
SeoBlockAndText.defaultProps = {
  items: [_extends({}, DefaultSeoBlock), _extends({}, DefaultSeoBlock), _extends({}, DefaultSeoBlock), _extends({}, DefaultSeoBlock)]
};
SeoBlockAndText.human = {
  nl: '',
  fr: '',
  en: ''
};
SeoBlockAndText.preview = SeoBlockAndText;

var SeoGenericMakeModelBlockAndText = function SeoGenericMakeModelBlockAndText(_ref) {
  var text = _ref.text,
    items = _ref.items,
    context = _ref.context;
  var _useState = useState(''),
    activeTab = _useState[0],
    setActiveTab = _useState[1];
  var _useIsMobile = useIsMobile(),
    isMobile = _useIsMobile.isMobile;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var cleanTitle = function cleanTitle(title) {
    return title.toLowerCase().replace(' ', '_');
  };
  if (isMobile) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1 flex-col container mx-auto mb-5 md:mb-12"
    }, /*#__PURE__*/React.createElement("div", {
      className: "mb-10"
    }, /*#__PURE__*/React.createElement(MarkupText, {
      text: text,
      context: context
    })), /*#__PURE__*/React.createElement("div", {
      className: "font-secondary"
    }, map(items, function (item, i) {
      var isLast = items.length - 1 === i;
      var isActive = cleanTitle(item.title) === activeTab;
      return /*#__PURE__*/React.createElement("div", {
        key: "seo-item-" + i,
        className: ""
      }, /*#__PURE__*/React.createElement("h5", {
        className: "flex justify-between items-center font-secondary font-normal cursor-pointer text-primary p-3 px-6 border-secondary-light " + (isLast && !isActive ? 'border-t border-b' : 'border-t'),
        onClick: function onClick() {
          return setActiveTab(isActive ? '' : cleanTitle(item.title));
        }
      }, item.title, " ", /*#__PURE__*/React.createElement("i", {
        className: "far fa-angle-down text-secondary-two"
      })), isActive && /*#__PURE__*/React.createElement("div", {
        className: "px-6 " + (isActive ? 'border-b border-secondary-light' : '')
      }, /*#__PURE__*/React.createElement("h6", {
        className: "flex mb-2 cursor-pointer text-primary-light hover:underline"
      }, /*#__PURE__*/React.createElement(ActionLink, {
        action: item.action
      }, t('Alle'))), map(item.items, function (subItem, i2) {
        return /*#__PURE__*/React.createElement("h6", {
          key: "block_item_" + i + "_" + i2,
          className: "flex mb-2 cursor-pointer text-primary-light hover:underline"
        }, /*#__PURE__*/React.createElement(ActionLink, {
          action: subItem.action
        }, subItem.title));
      })));
    })));
  }
  var gridClass = items.length < 6 ? "grid-cols-" + items.length : 'grid-cols-6';
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 flex-col container mx-auto mb-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-10"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: text,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid " + gridClass + " gap-4 mb-6 font-secondary"
  }, map(items, function (item, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: "block_" + i,
      className: "mb-10"
    }, /*#__PURE__*/React.createElement("h5", {
      className: "flex mb-2 font-normal cursor-pointer text-secondary-three font-semibold font-secondary"
    }, /*#__PURE__*/React.createElement(ActionLink, {
      action: item.action,
      context: context
    })), map(item.items, function (subItem, i2) {
      return /*#__PURE__*/React.createElement("h6", {
        key: "block_item_desktop_" + i + "_" + i2,
        className: "flex mb-2 cursor-pointer text-secondary-two hover:underline capitalize"
      }, /*#__PURE__*/React.createElement(ActionLink, {
        action: subItem.action,
        context: context
      }));
    }));
  })));
};
SeoGenericMakeModelBlockAndText.defaultProps = {
  items: [_extends({}, DefaultSeoBlock), _extends({}, DefaultSeoBlock), _extends({}, DefaultSeoBlock), _extends({}, DefaultSeoBlock)]
};
SeoGenericMakeModelBlockAndText.human = {
  nl: '',
  fr: '',
  en: ''
};
SeoGenericMakeModelBlockAndText.preview = SeoGenericMakeModelBlockAndText;

var SeoMakeBlockComponent = function SeoMakeBlockComponent(_ref) {
  var _data$image, _data$image2, _data$image3, _data$image4, _data$image5;
  var make_text = _ref.make_text,
    model_text = _ref.model_text,
    data = _ref.data,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "container my-7 md:mb-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mt-7 mb-5 md:mt-16 md:mb-10"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: make_text,
    context: context
  })), /*#__PURE__*/React.createElement("img", {
    srcSet: (data === null || data === void 0 ? void 0 : (_data$image = data.image) === null || _data$image === void 0 ? void 0 : _data$image.mobile) + " 300w, " + (data === null || data === void 0 ? void 0 : (_data$image2 = data.image) === null || _data$image2 === void 0 ? void 0 : _data$image2.tablet) + " 768w, " + (data === null || data === void 0 ? void 0 : (_data$image3 = data.image) === null || _data$image3 === void 0 ? void 0 : _data$image3.desktop) + " 1280w",
    src: data === null || data === void 0 ? void 0 : (_data$image4 = data.image) === null || _data$image4 === void 0 ? void 0 : _data$image4.mobile,
    alt: data === null || data === void 0 ? void 0 : (_data$image5 = data.image) === null || _data$image5 === void 0 ? void 0 : _data$image5.alt,
    className: "w-full h-full object-center object-contain"
  }), /*#__PURE__*/React.createElement("div", {
    className: "mt-7 mb-5 md:mt-16 md:mb-12"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: model_text,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-2 md:grid-cols-5 lg:grid-cols-6 gap-4"
  }, map(data.models, function (model) {
    return /*#__PURE__*/React.createElement(ActionLink, {
      action: model.action,
      context: context,
      className: "flex flex-1 relative cursor-pointer hover:underline"
    }, /*#__PURE__*/React.createElement("img", {
      src: model.image ? model.image : undefined,
      className: "rounded-lg",
      style: {
        objectFit: 'contain'
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "bg-secondary-two text-white font-secondary font-normal absolute bottom-0 left-0 rounded-tr-lg pl-4 pr-4 pt-2 pb-2",
      style: {
        maxHeight: 150
      }
    }, model.name));
  })));
};
SeoMakeBlockComponent.defaultProps = {
  make_text: DefaultText,
  model_text: DefaultText,
  data: _extends({}, DefaultSeoMakeBlock)
};
SeoMakeBlockComponent.human = {
  nl: '',
  fr: '',
  en: ''
};
SeoMakeBlockComponent.preview = SeoMakeBlockComponent;

var VehiclesSeoBlock = function VehiclesSeoBlock(_ref) {
  var context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "container mx-auto flex leading-24 my-7 md:my-12",
    style: {
      minHeight: 30
    }
  }, context.data && context.data.pageText && /*#__PURE__*/React.createElement(MarkupText, {
    text: JSON.parse(context.data.pageText),
    context: context
  }), !context.data || !context.data.pageText && /*#__PURE__*/React.createElement("p", null, "No seo text block ?"));
};
VehiclesSeoBlock.human = {
  nl: '',
  fr: '',
  en: ''
};
VehiclesSeoBlock.preview = VehiclesSeoBlock;

var NoResultsBanner = function NoResultsBanner() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "container mx-auto w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex self-center bg-orange-100 w-1/2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-16 bg-orange-200 flex items-center justify-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-4"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fad fa-info"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "w-auto text-gray-800 text-lg items-center p-4"
  }, /*#__PURE__*/React.createElement("p", {
    className: "leading-tight"
  }, t('You have no any vehicles to compare.'))))));
};

var VehicleFavoriteBtn = function VehicleFavoriteBtn(_ref) {
  var isFavorite = _ref.isFavorite,
    updateFavorite = _ref.updateFavorite;
  var _useState = useState(false),
    isHovering = _useState[0],
    setIsHovering = _useState[1];
  var handleClick = function handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    updateFavorite();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center absolute " + (isFavorite ? 'bg-secondary-two bg-opacity-100' : 'bg-white bg-opacity-50') + " w-8 h-8 rounded-full cursor-pointer text-secondary",
    onClick: handleClick,
    onMouseEnter: function onMouseEnter() {
      setIsHovering(true);
    },
    onMouseLeave: function onMouseLeave() {
      setIsHovering(false);
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa-heart " + (isFavorite ? 'fas text-white' : '') + " " + (isHovering ? 'fas' : 'far') + " text-16",
    style: {
      marginTop: 4,
      textShadow: '0 0 2px rgba(0, 0, 0, 0.15)'
    }
  }));
};
var VehicleFavoriteBtn$1 = baseFavoriteBtn(VehicleFavoriteBtn);

var MiniCompareBar = function MiniCompareBar(_ref) {
  var vehicles = _ref.vehicles,
    displayBar = _ref.displayBar;
  return /*#__PURE__*/React.createElement("div", {
    className: "fixed w-full container left-0 bg-white border-b border-secondary-eight z-10 transition duration-500 ease-in-out transform " + (displayBar ? 'translate-y-0' : '-translate-y-full'),
    style: {
      top: getStickiesOffset()
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:block"
  }), map(vehicles, function (vehicle, i) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center py-2"
    }, /*#__PURE__*/React.createElement("img", {
      src: vehicle.images[0].uri,
      alt: vehicle.make + " " + vehicle.model,
      className: "hidden md:block h-10"
    }), /*#__PURE__*/React.createElement("div", {
      className: "truncate md:px-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "truncate text-xs font-semibold text-secondary-two"
    }, vehicle.make, " ", vehicle.model), /*#__PURE__*/React.createElement("div", {
      className: "text-base font-bold text-secondary mt-1"
    }, formatPrice(vehicle.price))));
  })));
};

var CompareSkeleton = function CompareSkeleton(_ref) {
  var grid = _ref.grid;
  var _useState = useState(0),
    cols = _useState[0],
    setCols = _useState[1];
  var _useState2 = useState(375),
    headerCardHeight = _useState2[0],
    setHeaderCardHeight = _useState2[1];
  var _useWindowDimensions = useWindowDimensions(),
    width = _useWindowDimensions.width;
  useEffect(function () {
    if (width > 0) {
      if (width >= 768 && width < 1280) {
        setCols(3);
        setHeaderCardHeight(365);
      } else if (width >= 1280) {
        setCols(4);
        setHeaderCardHeight(375);
      } else {
        setCols(2);
        setHeaderCardHeight(365);
      }
    }
  }, [width]);
  var groups = 2;
  var fields = 10;
  if (cols === 0) {
    return /*#__PURE__*/React.createElement("div", {
      className: "hidden"
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: grid + " gap-4 relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:flex items-center justify-end w-full h-full",
    style: {
      height: headerCardHeight
    }
  }), times(cols, function (item) {
    return /*#__PURE__*/React.createElement("div", {
      key: item,
      className: "bg-gray-200 animate-pulse",
      style: {
        height: headerCardHeight
      }
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-full mt-6"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: 2
    },
    className: "bg-gray-200 w-full"
  })), /*#__PURE__*/React.createElement("div", {
    className: "" + grid
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:flex flex-1 flex-col"
  }, times(groups, function (item) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "py-6"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-gray-200 animate-pulse h-5"
    })), times(fields, function (option) {
      return /*#__PURE__*/React.createElement("div", {
        className: "flex py-2 border-b border-r border-gray-200"
      }, /*#__PURE__*/React.createElement("div", {
        className: "w-full mr-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "bg-gray-200 animate-pulse h-2 w-1/3"
      })));
    }));
  })), times(cols, function (item) {
    var isFirstCol = item === 0;
    return /*#__PURE__*/React.createElement(Fade$1, null, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1 flex-col"
    }, times(groups, function (group) {
      return /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col"
      }, /*#__PURE__*/React.createElement("div", {
        className: "py-6"
      }, /*#__PURE__*/React.createElement("div", {
        className: (isFirstCol ? 'opacity-100 lg:opacity-0' : 'opacity-0') + " "
      }, /*#__PURE__*/React.createElement("div", {
        className: "bg-gray-200 animate-pulse h-5"
      }))), times(fields, function (option) {
        return /*#__PURE__*/React.createElement("div", {
          className: "py-2 pr-4 pl-0 lg:pr-4 lg:pl-4 border-b border-gray-200"
        }, /*#__PURE__*/React.createElement("div", {
          className: "block lg:hidden mb-1 " + (isFirstCol ? 'opacity-100' : 'opacity-0') + " lg:opacity-0"
        }, /*#__PURE__*/React.createElement("div", {
          className: "bg-gray-200 animate-pulse h-5"
        })), /*#__PURE__*/React.createElement("div", {
          className: "bg-gray-200 animate-pulse h-2 w-1/3"
        }));
      }));
    })));
  })));
};

var Compare = function Compare(_ref) {
  var vehicles = _ref.vehicles,
    loading = _ref.loading,
    compareFields = _ref.compareFields,
    compareGroups = _ref.compareGroups,
    hasNext = _ref.hasNext,
    hasPrev = _ref.hasPrev,
    onNext = _ref.onNext,
    onPrev = _ref.onPrev,
    context = _ref.context,
    compareRemoveVehicle = _ref.compareRemoveVehicle;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useScrollPosition = useScrollPosition(),
    scrollPosition = _useScrollPosition.scrollPosition;
  var _useState = useState(false),
    displayMiniBar = _useState[0],
    setDisplayMiniBar = _useState[1];
  var horizontalLineRef = useRef();
  var grid = 'grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-5';
  useEffect(function () {
    var _horizontalLineRef$cu;
    setDisplayMiniBar(scrollPosition > (horizontalLineRef === null || horizontalLineRef === void 0 ? void 0 : (_horizontalLineRef$cu = horizontalLineRef.current) === null || _horizontalLineRef$cu === void 0 ? void 0 : _horizontalLineRef$cu.offsetTop) - getStickiesOffset());
  }, [scrollPosition]);
  if (loading) {
    return /*#__PURE__*/React.createElement(CompareSkeleton, {
      grid: grid
    });
  }
  if ((vehicles === null || vehicles === void 0 ? void 0 : vehicles.length) === 0) {
    return /*#__PURE__*/React.createElement("div", {
      className: "min-h-screen"
    }, /*#__PURE__*/React.createElement(NoResultsBanner, null));
  }
  var renderArrows = function renderArrows() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "container -mt-10 " + grid + " gap-4 absolute top-1/2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hidden lg:block"
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1 flex-col items-start justify-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: (hasPrev ? 'cursor-pointer' : 'opacity-0') + " flex items-center justify-center rounded-full h-10 w-10 -ml-4 md:-ml-5 text-white bg-secondary-two",
      onClick: hasPrev ? onPrev : function () {
        return null;
      },
      style: {
        zIndex: 2
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "fal fa-arrow-left text-white"
    })), hasNext && /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center rounded-full h-10 w-10 ml-5 text-white bg-secondary-two cursor-pointer absolute -right-4 md:-right-5",
      onClick: onNext,
      style: {
        zIndex: 2
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "fal fa-arrow-right text-white"
    })))));
  };
  var renderVehicleCards = function renderVehicleCards() {
    return /*#__PURE__*/React.createElement("div", {
      className: "container " + grid + " gap-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hidden lg:block"
    }), map(vehicles, function (vehicle, i) {
      return /*#__PURE__*/React.createElement("div", {
        className: "flex flex-1 flex-col"
      }, /*#__PURE__*/React.createElement("div", {
        className: "relative"
      }, /*#__PURE__*/React.createElement("img", {
        src: vehicle.images[0].uri,
        alt: vehicle.make + " " + vehicle.model
      }), /*#__PURE__*/React.createElement("div", {
        className: "absolute md:hidden",
        style: {
          top: 8,
          right: 10
        },
        onClick: function onClick() {
          return compareRemoveVehicle(vehicle.reference);
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fal fa-times text-secondary text-20"
      })), /*#__PURE__*/React.createElement("div", {
        className: "hidden md:block absolute cursor-pointer",
        style: {
          top: 15,
          right: 20
        },
        onClick: function onClick() {
          return compareRemoveVehicle(vehicle.reference);
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fal fa-times text-secondary text-20"
      })), context.favorites && /*#__PURE__*/React.createElement("div", {
        className: "hidden md:block absolute",
        style: {
          top: 10,
          right: 75
        }
      }, /*#__PURE__*/React.createElement(VehicleFavoriteBtn$1, {
        reference: vehicle.reference,
        context: context
      }))), /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col text-left pt-4"
      }, /*#__PURE__*/React.createElement("div", {
        className: "truncate paragraph-large font-semibold text-secondary-two"
      }, vehicle.make, " ", vehicle.model), /*#__PURE__*/React.createElement("div", {
        className: "paragraph-small truncate"
      }, " ", vehicle.version), /*#__PURE__*/React.createElement("div", {
        className: "text-lg font-bold text-secondary mt-1"
      }, formatPrice(vehicle.price))));
    }));
  };
  var renderSpecifications = function renderSpecifications() {
    return /*#__PURE__*/React.createElement("div", {
      className: "container " + grid
    }, /*#__PURE__*/React.createElement("div", {
      className: "hidden lg:flex flex-1 flex-col"
    }, map(orderBy(compareGroups, ['key'], ['desc']), function (item) {
      var options = filter(compareFields, function (cf) {
        return cf.group === item.key;
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col"
      }, /*#__PURE__*/React.createElement("div", {
        className: "paragraph-large text-secondary-two font-semibold pt-6 pb-4"
      }, item.label(t)), map(options, function (option) {
        return /*#__PURE__*/React.createElement("div", {
          className: "flex py-2 paragraph-default font-semibold text-primary border-b border-r border-secondary-eight"
        }, option.label(t));
      }));
    })), map(vehicles, function (vehicle, i) {
      var isFirstCol = i === 0;
      return /*#__PURE__*/React.createElement("div", {
        className: "flex flex-1 flex-col"
      }, map(orderBy(compareGroups, ['key'], ['desc']), function (item, i) {
        var options = filter(compareFields, function (cf) {
          return cf.group === item.key;
        });
        return /*#__PURE__*/React.createElement("div", {
          className: "flex flex-col"
        }, /*#__PURE__*/React.createElement("div", {
          className: "paragraph-large text-secondary-two font-semibold pt-6 pb-4"
        }, /*#__PURE__*/React.createElement("span", {
          className: (isFirstCol ? 'opacity-100 lg:opacity-0' : 'opacity-0') + " "
        }, item.label(t))), map(options, function (option) {
          var _option$value, _option$value$props;
          return /*#__PURE__*/React.createElement("div", {
            className: "paragraph-default text-primary trauncate py-2 pr-0 pl-0 lg:pr-4 lg:pl-4 border-b lg:border-r border-secondary-eight"
          }, /*#__PURE__*/React.createElement("div", {
            className: "block lg:hidden truncate paragraph-default font-semibold text-primary mb-1 " + (isFirstCol ? 'opacity-100' : 'opacity-0') + " lg:opacity-0"
          }, option.label(t)), /*#__PURE__*/React.createElement("div", {
            className: "truncate " + (((_option$value = option.value(vehicle)) === null || _option$value === void 0 ? void 0 : (_option$value$props = _option$value.props) === null || _option$value$props === void 0 ? void 0 : _option$value$props.className) === 'fal fa-check' ? 'text-secondary-two' : '')
          }, option.label(t) === 'Mileage' ? formatNumber(option.value(vehicle)) + ' km' : option.value(vehicle)));
        }));
      }));
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement(MiniCompareBar, {
    vehicles: vehicles,
    displayBar: displayMiniBar
  }), /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, renderArrows(), renderVehicleCards()), /*#__PURE__*/React.createElement("div", {
    className: "w-full mt-6"
  }, /*#__PURE__*/React.createElement("div", {
    ref: horizontalLineRef,
    style: {
      height: 1
    },
    className: "bg-secondary-eight w-full"
  })), renderSpecifications());
};
var Compare$1 = baseCompare(Compare);

var VehicleCompare = function VehicleCompare(_ref) {
  var references = _ref.references,
    onDelete = _ref.onDelete,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center container mx-auto",
    style: {
      minHeight: 200
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center my-5 w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mx-auto w-full vehicle-compare overflow-x-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col-reverse md:flex-col"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-28 md:text-40 font-semibold text-primary mb-8"
  }, t('Compare vehicles')))), /*#__PURE__*/React.createElement("div", {
    className: "w-full vehicle-compare-wrapper"
  }, /*#__PURE__*/React.createElement(Compare$1, {
    context: context,
    references: references,
    onDelete: onDelete
  }))))));
};

var VehicleCompareBanner = function VehicleCompareBanner(_ref) {
  var totalVehiclesInCompare = _ref.totalVehiclesInCompare,
    navigateCompare = _ref.navigateCompare;
  var _useIsMobile = useIsMobile(),
    isMobile = _useIsMobile.isMobile;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center fixed left-0 md:left-auto right-0 ",
    style: {
      zIndex: 99999,
      bottom: -1
    }
  }, isMobile && /*#__PURE__*/React.createElement("div", {
    className: "w-full flex",
    style: {
      boxShadow: '0px 1px 10px 2px #9e9e9e'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-secondary-two p-2 w-full text-18 text-white cursor-pointer relative",
    onClick: navigateCompare
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-4 flex items-center justify-between"
  }, /*#__PURE__*/React.createElement("div", null, t('Compare vehicles'), " (", totalVehiclesInCompare, ")"), /*#__PURE__*/React.createElement("i", {
    className: "far fa-arrow-right",
    style: {
      marginTop: 5
    }
  })))), !isMobile && /*#__PURE__*/React.createElement("div", {
    className: "container flex justify-end"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-secondary-two p-3 text-18 text-white rounded-tl-10 cursor-pointer relative",
    onClick: navigateCompare
  }, totalVehiclesInCompare > 0 && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center absolute bg-secondary-two",
    style: {
      width: 30,
      height: 30,
      top: -15,
      left: -15,
      borderRadius: 30
    }
  }, totalVehiclesInCompare), /*#__PURE__*/React.createElement("div", {
    className: "p-2 flex items-center justify-center"
  }, /*#__PURE__*/React.createElement("span", null, t('Compare vehicles')), /*#__PURE__*/React.createElement("i", {
    className: "far fa-arrow-right ml-2"
  })))));
};
var VehicleCompareBanner$1 = baseCompareBanner(VehicleCompareBanner);

var _initialFormData$1;
var FormFields$1 = {
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phone: 'phone',
  message: 'message',
  privacy: 'privacy'
};
var initialFormData$1 = (_initialFormData$1 = {}, _initialFormData$1[FormFields$1.firstName] = '', _initialFormData$1[FormFields$1.lastName] = '', _initialFormData$1[FormFields$1.email] = '', _initialFormData$1[FormFields$1.phone] = '', _initialFormData$1[FormFields$1.message] = '', _initialFormData$1[FormFields$1.privacy] = false, _initialFormData$1);
var validator$1 = function validator(data, t) {
  var errors = {};
  if (!hasValue(data.firstName)) {
    errors[FormFields$1.firstName] = t('First name is required.');
  }
  if (!hasValue(data.lastName)) {
    errors[FormFields$1.lastName] = t('Last name is required.');
  }
  if (!hasValue(data.email)) {
    errors[FormFields$1.email] = t('Email address is required.');
  } else if (!isValidEmail(data.email)) {
    errors[FormFields$1.email] = t('Email address is not valid.');
  }
  if (!hasValue(data.phone)) {
    errors[FormFields$1.phone] = t('Phone is required.');
  }
  if (data.privacy === false) {
    errors[FormFields$1.privacy] = '';
  }
  return errors;
};
var submitDataMapper$1 = function submitDataMapper(formData, additionalData, context) {
  return {
    first_name: formData.firstName,
    last_name: formData.lastName,
    email: formData.email,
    phone: formData.phone,
    message: formData.message,
    privacy: formData.privacy,
    vehicle: {
      id: additionalData.vehicle.id,
      reference: additionalData.vehicle.reference,
      identification: additionalData.vehicle.identification,
      vehicleUrl: window.location.href
    },
    financial: additionalData.financialData ? {
      price: additionalData.financialData.price,
      deposit: additionalData.financialData.deposit,
      months: additionalData.financialData.months,
      financePrice: additionalData.financialData.financePrice
    } : {}
  };
};
var VehicleOfferForm = function VehicleOfferForm(_ref) {
  var data = _ref.data,
    submit = _ref.submit,
    submitting = _ref.submitting,
    submitSuccess = _ref.submitSuccess,
    submitError = _ref.submitError,
    validationErrors = _ref.validationErrors,
    setFormValue = _ref.setFormValue,
    navigatePrivacy = _ref.navigatePrivacy,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("form", {
    id: "offer-form",
    action: "",
    onSubmit: submit,
    className: "relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center w-full text-gray-800 mb-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-18 text-primary font-semibold"
  }, t('Request free offer')), /*#__PURE__*/React.createElement("i", {
    className: "fal fa-times text-xl cursor-pointer",
    onClick: onClose
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-full font-secondary mb-10"
  }, t('Send us your details and we will make you a nice proposal!')), validationErrors && validationErrors['result'] && /*#__PURE__*/React.createElement("div", {
    className: "mb-4 px-5 md:px-0",
    style: {
      minHeight: 32
    }
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: validationErrors['result']
  })), submitError && submitError !== '' && /*#__PURE__*/React.createElement("div", {
    className: "mb-4 px-5 md:px-0",
    style: {
      minHeight: 32
    }
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: submitError
  })), submitSuccess && /*#__PURE__*/React.createElement("div", {
    className: "px-5 md:px-0 absolute",
    style: {
      top: 40,
      right: '0.75rem',
      left: '0.75rem'
    }
  }, /*#__PURE__*/React.createElement(SuccessIndicator, {
    success: t('Your request has been sent!')
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex mb-5"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 md:mb-0 mr-1",
    inputClass: "rounded-10",
    label: t('First name'),
    placeholder: "John",
    value: data.firstName,
    onChange: function onChange(value) {
      return setFormValue(FormFields$1.firstName, value);
    },
    errorText: validationErrors[FormFields$1.firstName],
    required: true
  }), /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 md:mb-0 ml-1",
    inputClass: "rounded-10",
    label: t('Last name'),
    placeholder: "Doe",
    value: data.lastName,
    onChange: function onChange(value) {
      return setFormValue(FormFields$1.lastName, value);
    },
    errorText: validationErrors[FormFields$1.lastName],
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: " mb-5"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full mb-2 md:mb-0",
    inputClass: "rounded-10",
    label: t('Email address'),
    placeholder: "john.doe@gmail.com",
    value: data.email,
    onChange: function onChange(value) {
      return setFormValue(FormFields$1.email, value);
    },
    errorText: validationErrors[FormFields$1.email],
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: " mb-5"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full mb-2 md:mb-0",
    inputClass: "rounded-10",
    label: t('Phone'),
    placeholder: "0486 12 34 56",
    value: data.phone,
    onChange: function onChange(value) {
      return setFormValue(FormFields$1.phone, value);
    },
    errorText: validationErrors[FormFields$1.phone],
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-6"
  }, /*#__PURE__*/React.createElement(TextAreaField, {
    containerClass: "md:w-full md:mb-0",
    inputClass: "rounded-10",
    label: t('Message'),
    placeholder: t('I am interested in purchasing this car and would like to know if it is still available?'),
    value: data.message,
    heightClass: "h-24",
    onChange: function onChange(value) {
      return setFormValue(FormFields$1.message, value);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-primary font-secondary flex  " + (validationErrors['privacy'] !== undefined ? 'text-red-400' : '')
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: data.privacy,
    onChange: function onChange(e) {
      return setFormValue(FormFields$1.privacy, e.target.checked);
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "mr-1 ml-2 " + (validationErrors['privacy'] !== undefined ? 'text-red-400' : '')
  }, t('I agree to the'), " "), /*#__PURE__*/React.createElement("span", {
    className: "underline cursor-pointer " + (validationErrors['privacy'] !== undefined ? 'text-red-400' : ''),
    onClick: function onClick() {
      return navigatePrivacy();
    }
  }, t('privacy terms')), ".")), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end font-secondary"
  }, /*#__PURE__*/React.createElement("button", {
    className: "primary-button",
    type: "submit",
    disabled: submitting
  }, submitting ? t('Sending...') : t('Send'))));
};
var VehicleOfferForm$1 = baseDealerContactForm(DealerContactTypes.vehicleOffer, initialFormData$1, validator$1, submitDataMapper$1, VehicleOfferForm);

var _initialFormData$2;
var FormFields$2 = {
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phone: 'phone',
  message: 'message',
  privacy: 'privacy'
};
var initialFormData$2 = (_initialFormData$2 = {}, _initialFormData$2[FormFields$2.firstName] = '', _initialFormData$2[FormFields$2.lastName] = '', _initialFormData$2[FormFields$2.email] = '', _initialFormData$2[FormFields$2.phone] = '', _initialFormData$2[FormFields$2.message] = '', _initialFormData$2[FormFields$2.privacy] = false, _initialFormData$2);
var validator$2 = function validator(data, t) {
  var errors = {};
  if (!hasValue(data.firstName)) {
    errors[FormFields$2.firstName] = t('First name is required.');
  }
  if (!hasValue(data.lastName)) {
    errors[FormFields$2.lastName] = t('Last name is required.');
  }
  if (!hasValue(data.email)) {
    errors[FormFields$2.email] = t('Email address is required.');
  } else if (!isValidEmail(data.email)) {
    errors[FormFields$2.email] = t('Email address is not valid.');
  }
  if (!hasValue(data.phone)) {
    errors[FormFields$2.phone] = t('Phone is required.');
  }
  if (data.privacy === false) {
    errors[FormFields$2.privacy] = '';
  }
  return errors;
};
var submitDataMapper$2 = function submitDataMapper(formData, additionalData, context) {
  return {
    first_name: formData.firstName,
    last_name: formData.lastName,
    email: formData.email,
    phone: formData.phone,
    message: formData.message,
    privacy: formData.privacy,
    vehicle: {
      id: additionalData.vehicle.id,
      reference: additionalData.vehicle.reference,
      identification: additionalData.vehicle.identification,
      vehicleUrl: window.location.href
    },
    financial: additionalData.financialData ? {
      price: additionalData.financialData.price,
      deposit: additionalData.financialData.deposit,
      months: additionalData.financialData.months,
      financePrice: additionalData.financialData.financePrice
    } : {}
  };
};
var VehicleAppointment = function VehicleAppointment(_ref) {
  var data = _ref.data,
    submit = _ref.submit,
    submitting = _ref.submitting,
    submitSuccess = _ref.submitSuccess,
    submitError = _ref.submitError,
    validationErrors = _ref.validationErrors,
    setFormValue = _ref.setFormValue,
    navigatePrivacy = _ref.navigatePrivacy,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("form", {
    id: "appointment-form",
    action: "",
    onSubmit: submit,
    className: "relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center w-full text-gray-800 mb-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-18 text-secondary-three font-semibold"
  }, t('Make an appointment')), /*#__PURE__*/React.createElement("i", {
    className: "fal fa-times text-xl cursor-pointer",
    onClick: onClose
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-full font-secondary mb-10"
  }, t('Send us your details and we will contact you!')), validationErrors && validationErrors['result'] && /*#__PURE__*/React.createElement("div", {
    className: "mb-4 px-5 md:px-0",
    style: {
      minHeight: 32
    }
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: validationErrors['result']
  })), submitError && submitError !== '' && /*#__PURE__*/React.createElement("div", {
    className: "mb-4 px-5 md:px-0",
    style: {
      minHeight: 32
    }
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: submitError
  })), submitSuccess && /*#__PURE__*/React.createElement("div", {
    className: "px-5 md:px-0 absolute",
    style: {
      top: 40,
      right: '0.75rem',
      left: '0.75rem'
    }
  }, /*#__PURE__*/React.createElement(SuccessIndicator, {
    success: t('Your request has been sent!')
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex mb-5"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full font-secondary md:w-1/2 md:mb-0 mr-1",
    inputClass: "rounded-4",
    label: t('First name'),
    placeholder: "John",
    value: data.firstName,
    onChange: function onChange(value) {
      return setFormValue(FormFields$2.firstName, value);
    },
    errorText: validationErrors[FormFields$2.firstName],
    required: true
  }), /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full font-secondary md:w-1/2 md:mb-0 ml-1",
    inputClass: "rounded-4",
    label: t('Last name'),
    placeholder: "Doe",
    value: data.lastName,
    onChange: function onChange(value) {
      return setFormValue(FormFields$2.lastName, value);
    },
    errorText: validationErrors[FormFields$2.lastName],
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: " mb-5"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full font-secondary mb-2 md:mb-0",
    inputClass: "rounded-4",
    label: t('Email address'),
    placeholder: "john.doe@gmail.com",
    value: data.email,
    onChange: function onChange(value) {
      return setFormValue(FormFields$2.email, value);
    },
    errorText: validationErrors[FormFields$2.email],
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: " mb-5"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full font-secondary mb-2 md:mb-0",
    inputClass: "rounded-4",
    label: t('Phone'),
    placeholder: "0486 12 34 56",
    value: data.phone,
    onChange: function onChange(value) {
      return setFormValue(FormFields$2.phone, value);
    },
    errorText: validationErrors[FormFields$2.phone],
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-6"
  }, /*#__PURE__*/React.createElement(TextAreaField, {
    containerClass: "font-secondary md:w-full md:mb-0",
    inputClass: "rounded-4",
    label: t('Message'),
    placeholder: t('I want to make an appointment to see this vehicle'),
    value: data.message,
    heightClass: "h-24",
    onChange: function onChange(value) {
      return setFormValue(FormFields$2.message, value);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-primary font-secondary flex  " + (validationErrors['privacy'] !== undefined ? 'text-red-400' : '')
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: data.privacy,
    onChange: function onChange(e) {
      return setFormValue(FormFields$2.privacy, e.target.checked);
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "mr-1 ml-2 " + (validationErrors['privacy'] !== undefined ? 'text-red-400' : '')
  }, t('I agree to the'), " "), /*#__PURE__*/React.createElement("span", {
    className: "underline cursor-pointer " + (validationErrors['privacy'] !== undefined ? 'text-red-400' : ''),
    onClick: function onClick() {
      return navigatePrivacy();
    }
  }, t('privacy terms')), ".")), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end"
  }, /*#__PURE__*/React.createElement("button", {
    className: "primary-button",
    type: "submit",
    disabled: submitting
  }, submitting ? t('Sending...') : t('Send'))));
};
var VehicleAppointmentForm = baseDealerContactForm(DealerContactTypes.vehicleInformation, initialFormData$2, validator$2, submitDataMapper$2, VehicleAppointment);

var logoAudi = "audi~bnPFtJdH.png";

var logoAudiApprovedPlus = "audi-approved-plus~hzgJlDJc.png";

var logoMyWay = "my-way~EgcihScs.png";

var logoCarPass = "carpass_green~PIRedrvg.png";

var forms = {
  offer: {
    type: 'offer',
    id: 'topm-offer-form'
  },
  testDrive: {
    type: 'testDrive',
    id: 'topm-test-drive'
  },
  appointment: {
    type: 'appointment',
    id: 'topm-appointment'
  }
};
var labelMapper = {
  'AUDI SUV Sport': {
    label: 'Audi Sport',
    logo: logoAudi
  },
  'AUDI Sport': {
    label: 'Audi Sport',
    logo: logoAudi
  },
  audi_approved_plus: {
    label: 'Audi Approved plus',
    logo: logoAudiApprovedPlus
  },
  Demonstration: {
    label: 'Demo',
    logo: ''
  },
  'VOLKSWAGEN Commercial': {
    label: '',
    logo: ''
  },
  'MyWay (VW, Skoda, Audi, Seat)': {
    label: 'My Way',
    logo: logoMyWay
  }
};
var DetailsRight = function DetailsRight(_ref) {
  var vehicle = _ref.vehicle,
    context = _ref.context,
    bottomReached = _ref.bottomReached,
    financingRate = _ref.financingRate,
    onFinancingUpdate = _ref.onFinancingUpdate;
  var _useState = useState(0),
    financePrice = _useState[0],
    setFinancePrice = _useState[1];
  var _useState2 = useState(''),
    activeForm = _useState2[0],
    setActiveForm = _useState2[1];
  var _useState3 = useState(0),
    deposit = _useState3[0],
    setDeposit = _useState3[1];
  var _useState4 = useState(0),
    monthsDuration = _useState4[0],
    setMonthsDuration = _useState4[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var financingEnabled = context.financing;
  var reservation = context.reservation;
  var monthMarks = {};
  var depositMarks = {};
  var _useIsMobile = useIsMobile(),
    isMobile = _useIsMobile.isMobile;
  var financeRates = vehicle && vehicle.financeRates ? vehicle.financeRates : [];
  var deposits = sortBy(financeRates.map(function (fr) {
    return parseInt(fr.deposit);
  }).filter(function (value, index, self) {
    return self.indexOf(value) === index;
  }));
  var months = sortBy(financeRates.map(function (fr) {
    return parseInt(fr.months);
  }).filter(function (value, index, self) {
    return self.indexOf(value) === index;
  }));
  forEach(months, function (value) {
    var _Object$assign;
    return monthMarks = Object.assign(monthMarks, (_Object$assign = {}, _Object$assign[value] = '', _Object$assign));
  });
  forEach(deposits, function (value) {
    var _Object$assign2;
    return depositMarks = Object.assign(depositMarks, (_Object$assign2 = {}, _Object$assign2[value] = '', _Object$assign2));
  });
  var isNew = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.categoryKey) === 'new';
  var deliveryCost = resolveDeliveryCost(vehicle === null || vehicle === void 0 ? void 0 : vehicle.productsAndServices);
  var isDeliveryCostVisible = !isNew && deliveryCost;
  var resolveDeliveryCostText = function resolveDeliveryCostText() {
    return t('Exclusive delivery cost') + " " + formatPriceByCulture(deliveryCost === null || deliveryCost === void 0 ? void 0 : deliveryCost.priceIncl, {
      culture: context.culture
    }) + " " + t('VAT incl.');
  };
  var getWarrantyLabel = function getWarrantyLabel() {
    var warranty = undefined;
    if (vehicle.labelsV2.some(function (l) {
      return l.warrantyData !== null;
    })) {
      try {
        warranty = head(filter(vehicle.labelsV2, function (l) {
          return l.warrantyData !== null;
        }));
      } catch (e) {}
    }
    return warranty;
  };
  var warranty = getWarrantyLabel();
  useEffect(function () {
    if (financingRate) {
      setDeposit(financingRate.deposit);
      setMonthsDuration(financingRate.months);
    }
  }, [vehicle]);
  useEffect(function () {
    onFinancingUpdate(deposit, monthsDuration);
  }, [deposit, monthsDuration]);
  useEffect(function () {
    if (financingRate) {
      setFinancePrice(financingRate.monthlyPrice);
    }
  }, [financingRate]);
  var formatOfferPrice = function formatOfferPrice(price) {
    return "\u20AC " + price.toLocaleString('nl-NL', {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2
    });
  };
  var getDepositTotal = function getDepositTotal() {
    var depositTotal = deposit / 100 * vehicle.price;
    return formatOfferPrice(depositTotal);
  };
  var renderOnlyTotalPrice = function renderOnlyTotalPrice() {
    var hidePrice = vehicle.sold || vehicle.reserved;
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-start justify-start w-full font-primary text-secondary-two " + (hidePrice ? 'blurry' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "mr-2 text-32"
    }, formatPrice(vehicle.price), isDeliveryCostVisible && /*#__PURE__*/React.createElement("span", {
      className: "text-secondary-five text-10 leading-none",
      style: {
        marginLeft: 1
      }
    }, "[1]")), /*#__PURE__*/React.createElement("div", {
      className: "text-15"
    }, t('incl VAT')));
  };
  var renderBothPrices = function renderBothPrices() {
    var hidePrice = vehicle.sold || vehicle.reserved;
    var fontSize = formatPrice(vehicle.price).length > 8 || formatPrice(vehicle.monthlyPrice).length > 8 ? 'text-24' : 'text-28';
    return /*#__PURE__*/React.createElement("div", {
      className: "flex w-full"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col items-start justify-center font-primary text-secondary-three mr-5 " + (hidePrice ? 'blurry' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-start justify-start " + fontSize
    }, formatPrice(vehicle.price), isDeliveryCostVisible && /*#__PURE__*/React.createElement("span", {
      className: "text-10 text-secondary-five leading-none",
      style: {
        marginLeft: 1
      }
    }, "[1]")), /*#__PURE__*/React.createElement("div", {
      className: "text-10"
    }, "(", t('incl VAT'), ")")), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col flex-1 items-start justify-center font-primary text-secondary-two pl-5 border-l border-secondary-eight with-financing " + (hidePrice ? 'blurry' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col " + fontSize
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex"
    }, /*#__PURE__*/React.createElement(Fade, {
      spy: financePrice,
      duration: 200
    }, formatPrice(financePrice), isDeliveryCostVisible ? /*#__PURE__*/React.createElement("span", {
      className: "text-10 text-secondary-five leading-none",
      style: {
        marginLeft: 1
      }
    }, "[1, 2, 3]") : /*#__PURE__*/React.createElement("span", {
      className: "text-10 text-secondary-five leading-none",
      style: {
        marginLeft: 1
      }
    }, "[2]"))), /*#__PURE__*/React.createElement("div", {
      className: "flex items-end mb-1 text-10"
    }, /*#__PURE__*/React.createElement("span", {
      className: "font-semibold mr-1"
    }, t('monthly')), " ", /*#__PURE__*/React.createElement("span", {
      className: "text-10"
    }, "(", t('incl VAT'), ")"), ' '))));
  };
  var renderButtonsMobile = function renderButtonsMobile() {
    return /*#__PURE__*/React.createElement(Fade, {
      spy: bottomReached,
      className: "z-50"
    }, /*#__PURE__*/React.createElement("div", {
      className: bottomReached ? 'hidden' : 'fixed',
      style: {
        left: '1.25rem',
        right: '1.25rem',
        bottom: 75,
        zIndex: 1
      }
    }, /*#__PURE__*/React.createElement("button", {
      className: "px-4 py-3 inline-block items-center bg-secondary-two font-secondary font-normal text-white rounded-4 mb-4 w-full font-semibold",
      onClick: function onClick() {
        return setActiveForm(forms.offer.type);
      },
      style: {
        minHeight: 48
      }
    }, t('Receive a free quote'), " ", /*#__PURE__*/React.createElement("i", {
      className: "fal fa-long-arrow-right ml-2 font-normal",
      style: {
        marginTop: 2
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex"
    }, /*#__PURE__*/React.createElement("button", {
      className: "px-4 py-3 inline-block items-center bg-white border border-secondary-three font-secondary font-normal text-secondary-three font-semibold rounded-4 w-full",
      onClick: function onClick() {
        return setActiveForm(forms.appointment.type);
      },
      style: {
        minHeight: 48
      }
    }, t('Make appointment')), reservation && /*#__PURE__*/React.createElement("button", {
      className: "px-4 py-3 inline-block items-center bg-white border border-secondary-three font-secondary font-normal text-secondary-three font-semibold rounded-4 w-full ml-4",
      onClick: function onClick() {
        return navigateInternalPage(context, context.defaultPageNames.vehicleReservation, "vehicle=" + vehicle.reference);
      }
    }, t('Reservation')))));
  };
  var getWarrantyLogo = function getWarrantyLogo(logo) {
    switch (logo) {
      case 'my-way.png':
        return logoMyWay;
      case 'audi-approved-plus.png':
        return logoAudiApprovedPlus;
      default:
        return '';
    }
  };
  if (activeForm === forms.offer.type) {
    var financialData = {
      price: formatOfferPrice(vehicle.price),
      deposit: deposit,
      months: monthsDuration,
      financePrice: formatOfferPrice(financePrice)
    };
    return /*#__PURE__*/React.createElement("div", {
      id: forms.offer.id,
      className: "flex flex-1 flex-col "
    }, /*#__PURE__*/React.createElement(Fade, {
      duration: 500
    }, /*#__PURE__*/React.createElement("div", {
      className: "top-0 right-0 bottom-0 left-0 z-10"
    }, /*#__PURE__*/React.createElement(VehicleOfferForm$1, {
      data: {
        vehicle: vehicle,
        financialData: financialData
      },
      context: context,
      handlePrivacy: function handlePrivacy() {
        return navigateInternalPage(context, context.defaultPageNames.privacy, null, null, true);
      },
      onClose: function onClose() {
        return setActiveForm('');
      }
    }))));
  }
  if (activeForm === forms.appointment.type) {
    var _financialData = {
      price: formatOfferPrice(vehicle.price),
      deposit: deposit,
      months: monthsDuration,
      financePrice: formatOfferPrice(financePrice)
    };
    return /*#__PURE__*/React.createElement("div", {
      id: forms.appointment.id,
      className: "flex flex-1 flex-col "
    }, /*#__PURE__*/React.createElement(Fade, {
      duration: 500
    }, /*#__PURE__*/React.createElement("div", {
      className: "top-0 right-0 bottom-0 left-0 z-10"
    }, /*#__PURE__*/React.createElement(VehicleAppointmentForm, {
      data: {
        vehicle: vehicle,
        financialData: _financialData
      },
      context: context,
      handlePrivacy: function handlePrivacy() {
        return navigateInternaPage(context, context.defaultPageNames.privacy, null, null, true);
      },
      onClose: function onClose() {
        return setActiveForm('');
      }
    }))));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col pb-5 mb-5 border-b border-secondary-eight",
    style: {
      minHeight: isMobile ? 60 : 80
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, !financingEnabled && renderOnlyTotalPrice(), financingEnabled && vehicle.monthlyPrice > 0 ? renderBothPrices() : renderOnlyTotalPrice()), isDeliveryCostVisible && /*#__PURE__*/React.createElement("div", {
    className: "flex items-start gap-1 mt-2 md:mt-0"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-secondary-five text-10"
  }, "[1]"), /*#__PURE__*/React.createElement("div", {
    className: "text-secondary-five text-12 leading-18 font-regular"
  }, resolveDeliveryCostText())), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap items-center mt-3"
  }, vehicle.carpass && vehicle.carpass !== '' && /*#__PURE__*/React.createElement("a", {
    href: vehicle.carpass,
    className: "mt-2 mr-2",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement("img", {
    className: "cursor-hand",
    src: require("/" + logoCarPass)["default"],
    style: {
      width: 95
    },
    alt: "carpass"
  })), vehicle.vatRegime && /*#__PURE__*/React.createElement("div", {
    className: "font-secondary text-14 text-secondary-five bg-secondary-four rounded-4 px-2 py-1 mr-2 mt-2",
    style: {
      whiteSpace: 'nowrap'
    }
  }, t('VAT deductible')), vehicle.labelsV2 && vehicle.labelsV2.length > 0 && map(filter(vehicle.labels), function (label, i) {
    var mappedLabel = labelMapper[label];
    var isLast = vehicle.labels.length - 1 === i;
    if (mappedLabel) {
      if (mappedLabel.label || mappedLabel.logo) {
        return /*#__PURE__*/React.createElement("div", {
          className: "flex items-center bg-secondary-four rounded-4 px-2 py-1 mt-2 " + (isLast ? '' : 'mr-2')
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex items-center"
        }, mappedLabel.logo && /*#__PURE__*/React.createElement("img", {
          src: require("/" + mappedLabel.logo)["default"],
          alt: "Logo",
          className: "mr-1",
          style: {
            height: 14
          }
        }), mappedLabel.label && /*#__PURE__*/React.createElement("span", {
          className: "text-14 font-secondary text-secondary-five",
          style: {
            whiteSpace: 'nowrap'
          }
        }, mappedLabel.label)));
      }
    }
  }))), financingEnabled && financingRate && /*#__PURE__*/React.createElement("div", {
    className: 'mb-5'
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-start justify-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-15 text-secondary-five mb-5 leading-none"
  }, t('Calculate your financing plan')), /*#__PURE__*/React.createElement("span", {
    className: "text-secondary-five text-10 leading-none",
    style: {
      marginLeft: 1
    }
  }, "[2]")), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-start md:flex-row md:items-center lg:flex-col lg:items-start mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex paragraph-bold font-(se)condary font-semibold mr-0 md:mr-2 lg:mr-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mr-1"
  }, t('Deposit'), ":"), /*#__PURE__*/React.createElement("div", null, getDepositTotal())), /*#__PURE__*/React.createElement(Slider, {
    min: parseInt(min(deposits)),
    max: parseInt(max(deposits)),
    defaultValue: parseInt(deposit),
    value: parseInt(deposit),
    step: null,
    marks: depositMarks,
    dotStyle: {
      display: 'none'
    },
    onChange: function onChange(newDeposit) {
      setDeposit(newDeposit);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "w-full flex justify-end text-sm mt-2 text-gray-600"
  }, deposit, " %")), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-start md:flex-row md:items-center lg:flex-col lg:items-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-bold font-secondary font-semibold mr-0 md:mr-2 lg:mr-0"
  }, t('Financing duration in months')), /*#__PURE__*/React.createElement(Slider, {
    min: parseInt(min(months)),
    max: parseInt(max(months)),
    defaultValue: parseInt(monthsDuration),
    value: parseInt(monthsDuration),
    step: null,
    marks: monthMarks,
    dotStyle: {
      display: 'none'
    },
    onChange: function onChange(newMonths) {
      setMonthsDuration(newMonths);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "w-full flex justify-end text-sm mt-2 text-gray-600"
  }, monthsDuration, " ", t('months')))), /*#__PURE__*/React.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "block md:hidden"
  }, renderButtonsMobile()), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col flex-wrap -mx-2"
  }, /*#__PURE__*/React.createElement("button", {
    className: "primary-button mb-2 ml-2",
    onClick: function onClick() {
      return setActiveForm(forms.offer.type);
    }
  }, t('Receive a free quote')), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    className: "button draw-border mb-2 ml-2",
    onClick: function onClick() {
      return setActiveForm(forms.appointment.type);
    }
  }, t('Make appointment')), reservation && /*#__PURE__*/React.createElement("button", {
    className: "button draw-border mb-2 ml-2",
    onClick: function onClick() {
      return navigateInternalPage(context, context.defaultPageNames.vehicleReservation, "vehicle=" + vehicle.reference);
    }
  }, t('Reservation')))))), warranty && /*#__PURE__*/React.createElement("div", {
    className: "mt-5 pt-5 border-t border-secondary-eight"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-20 font-primary text-primary mb-3"
  }, t('Warranty')), (warranty.name || warranty.logo) && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center bg-secondary-four rounded-4 px-2 py-1 mb-3"
  }, warranty.logo && /*#__PURE__*/React.createElement("img", {
    src: useAsset(getWarrantyLogo(warranty.logo)),
    alt: "Logo",
    className: "mr-2",
    style: {
      height: 25
    }
  }), warranty.name && /*#__PURE__*/React.createElement("span", {
    className: "font-secondary text-14 text-secondary-five"
  }, warranty.name)), warranty.warrantyData && map(warranty.warrantyData, function (w) {
    return /*#__PURE__*/React.createElement("div", {
      className: "text-15 font-primary text-primary"
    }, /*#__PURE__*/React.createElement("i", {
      className: "far fa-check mr-2"
    }), w);
  })));
};

var MAX_EQUIPMENTS_HEIGHT = 150;
var EQUIPMENTS_ID = 'my-way-equipments-top';
var Equipments = function Equipments(_ref) {
  var vehicle = _ref.vehicle;
  var _useState = useState(MAX_EQUIPMENTS_HEIGHT),
    maxEquipmentsHeight = _useState[0],
    setMaxEquipmentsHeight = _useState[1];
  var _useState2 = useState(false),
    equipmentsExpanded = _useState2[0],
    setEquipmentsExpanded = _useState2[1];
  var _useState3 = useState(''),
    activeGroup = _useState3[0],
    setActiveGroup = _useState3[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var equipmentsRef = useRef();
  var filteredEquipments = filter(vehicle.equipments, function (eq) {
    return eq.group_key !== 'Pros' && eq.group_key !== 'Cons';
  });
  useEffect(function () {
    if (vehicle) {
      if (equipmentsRef && equipmentsRef.current) {
        setMaxEquipmentsHeight(equipmentsRef.current.scrollHeight);
      }
    }
  }, [vehicle]);
  var scrollToElement = function scrollToElement(id) {
    var elem = document.getElementById(id);
    if (elem) {
      var yOffset = getStickiesOffset();
      var y = elem.getBoundingClientRect().top + window.pageYOffset - yOffset;
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }
  };
  var toggleEquipments = function toggleEquipments() {
    if (equipmentsExpanded) {
      scrollToElement(EQUIPMENTS_ID);
    }
    setEquipmentsExpanded(!equipmentsExpanded);
  };
  var renderEquipments = function renderEquipments() {
    var distinctOptionGroups = uniq(map(filteredEquipments, function (eq) {
      return eq.group_key;
    }));
    var showExpandButton = maxEquipmentsHeight > MAX_EQUIPMENTS_HEIGHT;
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col md:flex-row container mx-auto relative"
    }, /*#__PURE__*/React.createElement("div", {
      id: EQUIPMENTS_ID,
      className: "absolute top-0 opacity-0"
    }), /*#__PURE__*/React.createElement("div", {
      className: "w-full md:w-1/4 mr-5"
    }, /*#__PURE__*/React.createElement("h2", {
      className: ""
    }, t('Equipment'))), /*#__PURE__*/React.createElement("div", {
      className: "w-full md:w-3/4"
    }, /*#__PURE__*/React.createElement("div", {
      ref: equipmentsRef,
      className: "vehicle-options grid grid-cols-4 gap-x-4 gap-y-8 flex flex-wrap relative overflow-hidden cursor-pointer",
      style: {
        height: equipmentsExpanded ? maxEquipmentsHeight : MAX_EQUIPMENTS_HEIGHT
      },
      onClick: function onClick() {
        return toggleEquipments();
      }
    }, map(distinctOptionGroups, function (group, index) {
      var options = map(filter(filteredEquipments, function (eq) {
        return eq.group_key === group;
      }), function (opt) {
        return opt.value;
      });
      var group_label = group;
      try {
        group_label = find(filteredEquipments, function (eq) {
          return eq.group_key === group;
        }).group;
      } catch (e) {}
      var visibleOptions = options;
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "flex flex-col flex-1"
      }, /*#__PURE__*/React.createElement("div", {
        className: "paragraph-default text-primary font-semibold mb-2"
      }, group_label), /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col"
      }, map(visibleOptions.sort(), function (option, i) {
        var isLast = visibleOptions.length - 1 === i;
        return /*#__PURE__*/React.createElement("div", {
          key: "option-" + i,
          className: "paragraph-default w-full capitalize truncate text-secondary-three " + (isLast ? '' : 'mb-1 md:mb-2')
        }, option);
      })));
    }), !equipmentsExpanded && /*#__PURE__*/React.createElement("div", {
      className: "absolute bottom-0 left-0 right-0",
      style: {
        height: 58,
        background: 'transparent linear-gradient(180deg, #FFFFFF00 0%, #FFFFFF 100%) 0% 0% no-repeat padding-box'
      }
    })), showExpandButton && /*#__PURE__*/React.createElement("div", {
      className: "flex justify-end font-semibold font-secondary text-secondary-two mt-5 cursor-pointer",
      onClick: function onClick() {
        return toggleEquipments();
      }
    }, !equipmentsExpanded && /*#__PURE__*/React.createElement("div", null, t('More equipment'), /*#__PURE__*/React.createElement("i", {
      className: "far fa-arrow-down ml-2"
    })), equipmentsExpanded && /*#__PURE__*/React.createElement("div", null, t('Less equipment'), " ", /*#__PURE__*/React.createElement("i", {
      className: "far fa-arrow-up ml-2"
    })))));
  };
  var cleanGroupLabelName = function cleanGroupLabelName(label) {
    return label.toLowerCase().replace(' ', '_');
  };
  var renderEquipmentsMobile = function renderEquipmentsMobile() {
    var distinctOptionGroups = uniq(map(filteredEquipments, function (eq) {
      return eq.group_key;
    }));
    return /*#__PURE__*/React.createElement("div", {
      className: "container mx-auto px-5"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "mb-4"
    }, t('Equipment')), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col md:flex-row flex-wrap overflow-hidden"
    }, map(distinctOptionGroups, function (group, index) {
      var options = map(filter(filteredEquipments, function (eq) {
        return eq.group_key === group;
      }), function (opt) {
        return opt.value;
      });
      var group_label = group;
      try {
        group_label = find(filteredEquipments, function (eq) {
          return eq.group_key === group;
        }).group;
      } catch (e) {}
      var isLast = distinctOptionGroups.length - 1 === index;
      var isActive = activeGroup === cleanGroupLabelName(group_label);
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "flex flex-col flex-1 w-full py-3 px-6 " + (isLast && !isActive ? 'border-t border-b' : 'border-t'),
        onClick: function onClick() {
          return setActiveGroup(isActive ? '' : cleanGroupLabelName(group_label));
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex justify-between font-secondary text-primary font-semibold " + (isActive ? 'mb-3' : '')
      }, group_label, " ", /*#__PURE__*/React.createElement("i", {
        className: (isActive ? 'far fa-angle-up' : 'far fa-angle-down') + " text-secondary-two"
      })), isActive && /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col"
      }, map(options.sort(), function (option, i) {
        return /*#__PURE__*/React.createElement("div", {
          key: "option-" + i,
          className: "w-full capitalize truncate truncate text-secondary-three mt-2"
        }, option);
      })));
    })));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "block md:hidden"
  }, renderEquipmentsMobile()), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block"
  }, renderEquipments()));
};

var ImageViewerAndThumbnails = function ImageViewerAndThumbnails(_ref) {
  var images = _ref.images,
    currentIndex = _ref.currentIndex,
    handleChangeIndex = _ref.handleChangeIndex,
    onImageClick = _ref.onImageClick,
    onContentLoad = _ref.onContentLoad;
  var _useWindowDimensions = useWindowDimensions(),
    width = _useWindowDimensions.width;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var calculateThumbsWidth = function calculateThumbsWidth() {
    var thumbsColWidth = 160;
    if (width >= 1024 && width < 1476) thumbsColWidth = 80;
    return thumbsColWidth;
  };
  var getThumbs = function getThumbs() {
    var thumbs = [];
    forEach(images, function (image, i) {
      thumbs.push(/*#__PURE__*/React.createElement("div", {
        className: "cursor-pointer flex w-full"
      }, /*#__PURE__*/React.createElement("img", {
        src: image,
        alt: "Img",
        title: "Img",
        className: "w-full rounded-10"
      })));
    });
    return thumbs;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "hidden xl:block relative mr-4",
    style: {
      width: calculateThumbsWidth()
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "image-viewer-thumbnails"
  }, /*#__PURE__*/React.createElement(ImageThumbnails, {
    type: "vertical",
    currentIndex: currentIndex,
    items: getThumbs(),
    onItemClick: function onItemClick(index) {
      return handleChangeIndex(index);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center cursor-pointer text-primary font-secondary",
    onClick: onImageClick,
    style: {
      height: 66
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "far fa-search-plus mr-2"
  }), " ", t('All pictures'))), /*#__PURE__*/React.createElement(ImageViewer, {
    images: images,
    currentIndex: currentIndex,
    renderArrows: function renderArrows(handlePrevClick, handleNextClick, currentIndex) {
      return /*#__PURE__*/React.createElement("div", {
        className: "text-white block z-50"
      }, currentIndex > 0 && /*#__PURE__*/React.createElement("div", {
        className: "bg-black opacity-50 hover:opacity-75 opacity:bg-black flex items-center justify-center cursor-pointer z-20 absolute left-0 rounded-r-4",
        style: {
          width: 40,
          height: 60,
          top: '50%',
          transform: 'translateY(-50%)'
        },
        onClick: function onClick(e) {
          return handlePrevClick();
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fal fa-chevron-left text-3xl"
      })), currentIndex < images.length - 1 && /*#__PURE__*/React.createElement("div", {
        className: "bg-black opacity-50 hover:opacity-75 opacity:bg-black flex items-center justify-center cursor-pointer z-20 absolute right-0 rounded-l-4",
        style: {
          width: 40,
          height: 60,
          top: '50%',
          transform: 'translateY(-50%)'
        },
        onClick: function onClick(e) {
          return handleNextClick(e);
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fal fa-chevron-right text-3xl"
      })));
    },
    onCurrentIndexChanged: function onCurrentIndexChanged(index) {
      return handleChangeIndex(index);
    },
    onClick: onImageClick,
    onContentLoad: onContentLoad
  }));
};
var ImageViewerAndThumbnails$1 = baseImageViewerAndThumbnails(ImageViewerAndThumbnails);

var renderSpecification = function renderSpecification() {
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-start mb-2 md:mb-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-6 w-32 mb-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse ml-0 h-6 w-40"
  })));
};
var DetailsRightSkeleton = function DetailsRightSkeleton() {
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-0 py-2 md:px-50px md:py-50px lg:px-30px lg:py-30px lg2:px-50px lg2:py-50px mb-8 md:shadow-bs-myway"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title flex w-full mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-8 w-40 mr-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-8 w-40"
  })), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-8 w-56"
  }), /*#__PURE__*/React.createElement("div", {
    className: "w-full h-0.5 my-5 bg-gray-200"
  }), /*#__PURE__*/React.createElement("div", {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-3 h-6 w-56 bg-gray-200 animate-pulse "
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-start md:flex-row md:items-center lg:flex-col lg:items-start mb-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-4 w-56 bg-gray-200 animate-pulse mr-0 md:mr-2 lg:mr-0 mb-2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-3 w-full bg-gray-200 animate-pulse"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-start md:flex-row md:items-center lg:flex-col lg:items-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-4 w-56 bg-gray-200 animate-pulse mr-0 md:mr-2 lg:mr-0 mb-2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-3 w-full bg-gray-200 animate-pulse"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full mt-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-12 w-40 mb-2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-8 w-30 mr-3"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-8 w-30"
  })))));
};
var VehicleSkeleton = function VehicleSkeleton(_ref) {
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex py-7 px-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-4 w-20 md:w-40 mr-7"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-4 w-10 md:w-20 mr-4"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-4 w-10 md:w-20 mr-4"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-4 w-10 md:w-20"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col xl:flex-row px-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full xl:w-2/3 mr-5 flex-col-reverse md:flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row justify-between mb-5 px-0 w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title flex flex-col w-full md:w-3/4 pr-1 mt-5 md:mt-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-12 w-32 mb-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-8 w-80"
  })), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:flex flex-col items-end justify-center w-1/4 pl-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-6 w-32 mb-3"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse w-32 h-6"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex overflow-hidden image-viewer-thumbnails"
  }, /*#__PURE__*/React.createElement("div", {
    className: "space-y-2 hidden md:flex md:flex-col mr-4",
    style: {
      width: 150
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      height: 150
    },
    className: "bg-gray-200 animate-pulse"
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      height: 150
    },
    className: "bg-gray-200 animate-pulse"
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      height: 150
    },
    className: "bg-gray-200 animate-pulse"
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      height: 150
    },
    className: "bg-gray-200 animate-pulse"
  })), /*#__PURE__*/React.createElement("div", {
    className: "h-full w-full bg-gray-200 animate-pulse"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "w-full xl:w-1/3 rounded-10 xl:border border-transparent md:border-secondary-eight py-0 xl:py-5 px-0 sm:px-5 md:px-0 md:mt-5 xl:px-5 xl:mt-0"
  }, /*#__PURE__*/React.createElement(DetailsRightSkeleton, null))), /*#__PURE__*/React.createElement("div", {
    className: "pt-7 md:pt-16"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row "
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-1/4 mr-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-4 md:mb-0 h-10 bg-gray-200 animate-pulse"
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-3/4 grid grid-cols-2 md:grid-cols-4 xl:grid-cols-5 gap-2 md:gap-x-2 md:gap-y-8 font-secondary"
  }, times(10, function (item) {
    return renderSpecification();
  })))), /*#__PURE__*/React.createElement("div", {
    className: "container border-none md:border-solid border-b border-secondary-eight my-7 md:my-16"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row "
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-1/4 mr-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-4 md:mb-0 h-10 bg-gray-200 animate-pulse"
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-3/4 grid grid-cols-2 md:grid-cols-4 xl:grid-cols-5 gap-2 md:gap-x-2 md:gap-y-8 font-secondary"
  }, times(10, function (item) {
    return renderSpecification();
  }))), /*#__PURE__*/React.createElement("div", {
    className: "container border-none md:border-solid border-b border-secondary-eight my-7 md:my-16"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row "
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-1/4 mr-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-4 md:mb-0 h-10 bg-gray-200 animate-pulse"
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-3/4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative font-secondary "
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-4 w-80 bg-gray-200 animate-pulse mb-2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-4 w-64 bg-gray-200 animate-pulse mb-2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-4 w-32 bg-gray-200 animate-pulse"
  }))))));
};

var mapVehicleImagesForViewer = function mapVehicleImagesForViewer(images) {
  var isArray = images instanceof Array;
  return isArray ? images.map(function (img) {
    return img.uri;
  }) : [images.uri];
};
var VEHICLE_QUERY = "query Vehicle ($reference: String!) {\n  vehicle (reference: $reference) {\n        id\n        reference\n        vin\n        identification\n\n        make\n        model\n        modelFamily\n        version\n        firstRegistrationMonth\n        firstRegistrationYear\n        mileage\n        doors\n        seats\n        kw\n        hp\n        engineCc\n        co2\n        euroNorm\n        interiorColor\n        exteriorColor\n\n        category\n        body\n        fuel\n        gearbox\n\n        images\n        images360\n        equipments\n        comments\n        financeRates\n        leaseRates\n\n        price\n        brutoPrice\n        monthlyPrice\n        sold\n        carpass\n        warranty\n        vatRegime\n\n        reserved\n        dealer {\n          name\n          address\n          postal\n          city\n          tel\n          contactUrl\n        }\n        labelsV2 {\n          key\n          name\n          logo\n          warrantyData\n        }\n        \n        makeKey\n        makeFamilyKey\n        modelKey        \n        modelFamilyKey\n        bodyKey\n        gearboxKey\n        categoryKey\n        fuelKey\n        exteriorColorKey\n        interiorColorKey\n        interiorUpholsteryKey\n        productsAndServices {\n          code\n          offeringType\n          name\n          priceIncl\n          priceExcl\n          description\n        }        \n  }\n}";
var COMMENTS_HEIGHT = 100;
var VehicleDetail = function VehicleDetail(_ref) {
  var _vehicle$dealer, _vehicle$dealer3;
  var vehicle = _ref.vehicle,
    vehiclePdfUrl = _ref.vehiclePdfUrl,
    loading = _ref.loading,
    error = _ref.error,
    context = _ref.context;
  var _useState = useState(''),
    top = _useState[0],
    setTop = _useState[1];
  var _useState2 = useState(0),
    windowHeight = _useState2[0],
    setWindowHeight = _useState2[1];
  var _useState3 = useState(undefined),
    financingRate = _useState3[0],
    setFinancingRate = _useState3[1];
  var _useState4 = useState(COMMENTS_HEIGHT),
    maxCommentHeight = _useState4[0],
    setMaxCommentHeight = _useState4[1];
  var _useState5 = useState(false),
    remarksExpanded = _useState5[0],
    setRemarksExpanded = _useState5[1];
  var _useState6 = useState(false);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useScrollPosition = useScrollPosition(),
    scrollPosition = _useScrollPosition.scrollPosition;
  var bottomRef = useRef();
  var commentRef = useRef();
  var equipmentsRef = useRef();
  var bottomReached = scrollPosition > top - windowHeight / 2;
  var financingEnabled = context.financing;
  var financeRates = vehicle && vehicle.financeRates && vehicle.financeRates.length > 0 ? vehicle.financeRates : [];
  useEffect(function () {
    if (!loading && bottomRef && bottomRef.current) {
      setTop(bottomRef.current.offsetTop);
      setWindowHeight(window.innerHeight);
    }
  }, [loading]);
  useEffect(function () {
    if (vehicle && financeRates.length > 0) {
      var defaultRate = find(financeRates, function (fr) {
        return fr["default"];
      });
      if (defaultRate) {
        setFinancingRate(defaultRate);
      }
    }
  }, [vehicle]);
  useEffect(function () {
    if (!loading && vehicle) {
      if (commentRef && commentRef.current) {
        setMaxCommentHeight(commentRef.current.scrollHeight);
      }
      if (equipmentsRef && equipmentsRef.current) {
        setMaxEquipmentsHeight(equipmentsRef.current.scrollHeight);
      }
    }
  }, [loading, vehicle]);
  var onFinancingUpdate = function onFinancingUpdate(deposit, months) {
    if (vehicle && financeRates.length > 0) {
      var newRate = find(financeRates, function (fr) {
        return parseInt(fr.deposit) === parseInt(deposit) && parseInt(fr.months) === parseInt(months);
      });
      if (newRate) {
        setFinancingRate(newRate);
      }
    }
  };
  var renderSpecification = function renderSpecification(icon, label, value, supValue) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col items-start mb-2 md:mb-0"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col items-start font-primary"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-secondary-three mb-1 text-14"
    }, label), /*#__PURE__*/React.createElement("div", {
      className: "text-secondary-two font-normal ml-0 text-18"
    }, value, " ", supValue && /*#__PURE__*/React.createElement("sup", null, supValue))));
  };
  var scrollToElement = function scrollToElement(id) {
    var elem = document.getElementById(id);
    if (elem) {
      var yOffset = getStickiesOffset();
      var y = elem.getBoundingClientRect().top + window.pageYOffset - yOffset;
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }
  };
  var toggleComments = function toggleComments() {
    if (remarksExpanded) {
      scrollToElement('comments-top');
    }
    setRemarksExpanded(!remarksExpanded);
  };
  var renderComments = function renderComments() {
    var showExpandButton = maxCommentHeight > COMMENTS_HEIGHT;
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col md:flex-row container mx-auto px-5 md:px-0 relative"
    }, /*#__PURE__*/React.createElement("div", {
      id: "comments-top",
      className: "absolute top-0 opacity-0"
    }), /*#__PURE__*/React.createElement("div", {
      className: "w-full md:w-1/4"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "mb-4 md:mb-0"
    }, t('Description'))), /*#__PURE__*/React.createElement("div", {
      className: "w-full md:w-3/4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "relative font-secondary " + (showExpandButton ? 'cursor-pointer' : ''),
      onClick: function onClick() {
        showExpandButton ? toggleComments() : null;
      }
    }, /*#__PURE__*/React.createElement("div", {
      ref: commentRef,
      className: "vehicle-comment overflow-hidden",
      style: {
        height: !remarksExpanded ? COMMENTS_HEIGHT : maxCommentHeight
      },
      dangerouslySetInnerHTML: {
        __html: b64DecodeUnicode(vehicle.comments)
      }
    }), !remarksExpanded && showExpandButton && /*#__PURE__*/React.createElement("div", {
      className: "absolute bottom-0 left-0 right-0",
      style: {
        height: 20,
        background: 'rgba(255, 255, 255, 0.6)'
      }
    })), showExpandButton && /*#__PURE__*/React.createElement("div", {
      className: "flex justify-end font-semibold font-secondary text-secondary-two mt-5 cursor-pointer",
      onClick: function onClick() {
        return toggleComments();
      }
    }, !remarksExpanded && /*#__PURE__*/React.createElement("div", null, t('Show description'), /*#__PURE__*/React.createElement("i", {
      className: "far fa-arrow-down ml-2"
    })), remarksExpanded && /*#__PURE__*/React.createElement("div", null, t('Hide description'), /*#__PURE__*/React.createElement("i", {
      className: "far fa-arrow-up ml-2"
    })))));
  };
  if (loading) {
    return /*#__PURE__*/React.createElement(VehicleSkeleton, {
      context: context
    });
  }
  if (error) {
    return /*#__PURE__*/React.createElement("div", {
      className: "container mx-auto "
    }, /*#__PURE__*/React.createElement(ErrorIndicator, {
      error: error
    }));
  }
  if (!vehicle) {
    return /*#__PURE__*/React.createElement(ErrorIndicator, {
      error: t('The fetched vehicles is empty.')
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "w-full mb-7 md:mb-16"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container mx-auto mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col xl:flex-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex w-full xl:w-2/3 mr-5 flex-col-reverse md:flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row justify-between mb-5 px-0"
  }, /*#__PURE__*/React.createElement(InternalLink, {
    context: context,
    className: "block md:hidden my-5 text-primary-light cursor-pointer font-secondary",
    page: context.defaultPageNames.vehicles
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("i", {
    className: "far fa-arrow-left mr-2"
  }), t('Back to overview'))), /*#__PURE__*/React.createElement("div", {
    className: "title flex flex-col w-full md:w-3/4 pr-1"
  }, /*#__PURE__*/React.createElement("h1", {
    className: " w-full truncate mb-2 md:mb-0"
  }, vehicle.make, " ", vehicle.model), /*#__PURE__*/React.createElement("div", {
    className: "text-18 md:text-20 font-primary text-secondary-three w-full truncate"
  }, vehicle.version)), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:flex flex-col items-end justify-center w-1/4 pl-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-14 font-primary text-secondary-five mb-3"
  }, t('Reference'), ": ", vehicle.identification), /*#__PURE__*/React.createElement("div", {
    className: "text-secondary-three w-full truncate text-right font-secondary " + (vehicle !== null && vehicle !== void 0 && (_vehicle$dealer = vehicle.dealer) !== null && _vehicle$dealer !== void 0 && _vehicle$dealer.contactUrl ? 'cursor-pointer' : ''),
    onClick: function onClick() {
      var _vehicle$dealer2;
      return navigateInternalPage(context, context.defaultPageNames.contact + "/" + (vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$dealer2 = vehicle.dealer) === null || _vehicle$dealer2 === void 0 ? void 0 : _vehicle$dealer2.contactUrl));
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "far fa-map-marker-alt mr-2"
  }), vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$dealer3 = vehicle.dealer) === null || _vehicle$dealer3 === void 0 ? void 0 : _vehicle$dealer3.name))), /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement(ImageViewerAndThumbnails$1, {
    images: mapVehicleImagesForViewer(vehicle.images)
  })), financingEnabled && financeRates.length > 0 && financingRate && /*#__PURE__*/React.createElement("div", {
    className: "text-left hidden xl:block 3xl:hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col mx-auto mt-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-secondary-four p-5 rounded-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "font-primary text-secondary-five",
    dangerouslySetInnerHTML: {
      __html: b64DecodeUnicode(financingRate.legal)
    }
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "w-full xl:w-1/3 rounded-10 xl:border border-transparent md:border-secondary-eight py-0 xl:py-5 px-0 sm:px-5 md:px-0 md:mt-5 xl:px-5 xl:mt-0"
  }, /*#__PURE__*/React.createElement(DetailsRight, {
    vehicle: vehicle,
    context: context,
    financingRate: financingRate,
    bottomReached: bottomReached,
    onFinancingUpdate: onFinancingUpdate
  })))), financingEnabled && financeRates.length > 0 && financingRate && /*#__PURE__*/React.createElement("div", {
    className: "text-left xl:hidden 3xl:block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col container mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-secondary-four p-5 rounded-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "font-primary text-secondary-five",
    dangerouslySetInnerHTML: {
      __html: b64DecodeUnicode(financingRate.legal)
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "pt-7 md:pt-16"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row container mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-1/4 mr-5"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "mb-4 md:mb-0"
  }, t('Characteristics'))), /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-3/4 grid grid-cols-2 md:grid-cols-4 xl:grid-cols-5 gap-2 md:gap-x-2 md:gap-y-8 font-secondary"
  }, renderSpecification('fal fa-road', t('Mileage'), formatNumber(vehicle.mileage) + " km"), renderSpecification('far fa-joystick', t('Transmission'), vehicle.gearbox), renderSpecification('far fa-gas-pump', t('Fuel type'), vehicle.fuel), renderSpecification('far fa-calendar-week', t('First registration'), vehicle.firstRegistrationMonth + "/" + vehicle.firstRegistrationYear), renderSpecification('fab fa-usb', t('Euro Emission Class'), vehicle.euroNorm), renderSpecification('fal fa-road', t('CO2 (g/km)'), vehicle.co2 + " g/km"), vehicle.exteriorColor && vehicle.exteriorColor !== '' && renderSpecification('far fa-palette', t('Body Color'), vehicle.exteriorColor), renderSpecification('fal fa-tachometer-alt-fastest', t('Power'), vehicle.hp + " pk"), renderSpecification('far fa-car-alt', t('Vehicle condition'), vehicle.category), renderSpecification('far fa-car-alt', t('Engine CC'), vehicle.engineCc + " cm", '3'), /*#__PURE__*/React.createElement("div", {
    className: "md:col-span-2 xl:col-span-1"
  }, /*#__PURE__*/React.createElement(ExternalLink, {
    context: context,
    url: vehiclePdfUrl,
    className: "hidden md:flex button draw-border items-center justify-center"
  }, t('Download vehicle sheet')))), /*#__PURE__*/React.createElement(ExternalLink, {
    context: context,
    url: vehiclePdfUrl,
    className: "flex md:hidden button draw-border items-center justify-center mt-4"
  }, t('Download vehicle sheet')))), /*#__PURE__*/React.createElement("div", {
    className: "container border-none md:border-solid border-b border-secondary-eight my-7 md:my-16"
  }), /*#__PURE__*/React.createElement(Equipments, {
    vehicle: vehicle
  }), vehicle.comments && /*#__PURE__*/React.createElement("div", {
    className: "container border-none md:border-solid border-b border-secondary-eight my-7 md:my-16"
  }), vehicle.comments && renderComments()), /*#__PURE__*/React.createElement("div", {
    ref: bottomRef
  }));
};
var Detail = baseVehicleDetail(VehicleDetail, {
  query: VEHICLE_QUERY
});

var VehicleDetailWithAdds = function VehicleDetailWithAdds(_ref) {
  var calculate_value_action = _ref.calculate_value_action,
    additional_vehicle_images = _ref.additional_vehicle_images,
    context = _ref.context,
    reference = _ref.reference,
    overridePageMetaData = _ref.overridePageMetaData,
    resolveAnalyticsData = _ref.resolveAnalyticsData;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "overflow-x-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden md:flex items-center container mx-auto py-5 mb-5 text-secondary-five font-primary text-14"
  }, /*#__PURE__*/React.createElement(InternalLink, {
    page: context.defaultPageNames.home,
    context: context,
    className: "cursor-pointer"
  }, t('Home')), ' ', /*#__PURE__*/React.createElement("i", {
    className: "fal fa-chevron-right text-xs mt-0.5 mx-2"
  }), /*#__PURE__*/React.createElement(InternalLink, {
    page: context.defaultPageNames.vehicles,
    context: context,
    className: "cursor-pointer"
  }, t('Vehicles')), ' ', /*#__PURE__*/React.createElement("i", {
    className: "fal fa-chevron-right text-xs mt-0.5 mx-2"
  }), t('Vehicle detail')), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Detail, {
    reference: reference,
    calculate_value_action: calculate_value_action,
    additional_vehicle_images: additional_vehicle_images,
    overridePageMetaData: overridePageMetaData,
    resolveAnalyticsData: resolveAnalyticsData,
    context: context
  })));
};
VehicleDetailWithAdds.defaultProps = {
  calculate_value_action: DefaultPrimaryAction,
  additional_vehicle_images: DefaultAdditionalVehicleImages
};
VehicleDetailWithAdds.human = {
  nl: '',
  fr: '',
  en: ''
};
VehicleDetailWithAdds.preview = function () {
  return /*#__PURE__*/React.createElement("div", null, "Vehicle Detail");
};

var imgDefaultVehicleCard = "vehicle-card-default-photo~JzylAAlB.jpg";

var imgSold = "sold_white~blSsHErB.svg";

var imgReserved = "reserved_white~hyHNGxBZ.svg";

var Checkbox = function Checkbox(_ref) {
  var _onClick = _ref.onClick,
    checked = _ref.checked,
    label = _ref.label,
    classNames = _ref.classNames;
  var _useState = useState(checked),
    isChecked = _useState[0],
    setIsChecked = _useState[1];
  useEffect(function () {
    setIsChecked(checked);
  }, [checked]);
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center cursor-pointer " + classNames,
    onClick: function onClick(e) {
      return _onClick(!isChecked, e);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center rounded border border-primary bg-white mr-2",
    style: {
      width: 16,
      height: 16
    }
  }, isChecked && /*#__PURE__*/React.createElement("i", {
    className: "far fa-check text-secondary-three font-bold",
    style: {
      fontSize: 12,
      marginTop: 2
    }
  })), /*#__PURE__*/React.createElement("span", {
    className: "paragraph-small text-secondary-three"
  }, label));
};
Checkbox.defaultProps = {
  checked: false,
  label: '',
  onClick: undefined,
  classNames: 'mr-10'
};

var VehicleCompareBtn = function VehicleCompareBtn(_ref) {
  var isInCompare = _ref.isInCompare,
    updateCompare = _ref.updateCompare;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Checkbox, {
    label: t('Compare'),
    onClick: function onClick(value, e) {
      e.preventDefault();
      e.stopPropagation();
      updateCompare();
    },
    checked: isInCompare,
    classNames: ""
  });
};
var VehicleCompareBtn$1 = baseCompareBtn(VehicleCompareBtn);

var overlayTypes = {
  sold: 'sold',
  reserved: 'reserved'
};
var mapVehicleImagesForViewer$1 = function mapVehicleImagesForViewer(images) {
  var isArray = images instanceof Array;
  return isArray ? images.map(function (img) {
    return img.uri + "?width=800";
  }) : [images.uri + "?width=800"];
};
var VehicleCard = function VehicleCard(_ref) {
  var _vehicle$dealer, _vehicle$dealer3;
  var vehicle = _ref.vehicle,
    cardClass = _ref.cardClass,
    styles = _ref.styles,
    context = _ref.context,
    _onClick = _ref.onClick;
  var _useState = useState(0);
  var _useState2 = useState(260),
    setImageViewerHeight = _useState2[1];
  var _useIsMobile = useIsMobile(),
    isMobile = _useIsMobile.isMobile;
  var _useState3 = useState(isMobile ? true : false),
    showArrows = _useState3[0],
    setShowArrows = _useState3[1];
  var financingEnabled = context.financing;
  var isSold = vehicle.sold;
  var isReserved = vehicle.reserved;
  var hasMonthlyPrice = vehicle.monthlyPrice > 0;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var calculateHeight = function calculateHeight() {
    var newHeight = window.innerWidth < 768 ? 220 : 260;
    setImageViewerHeight(newHeight);
  };
  useEffect(function () {
    calculateHeight();
    function handleResize() {
      calculateHeight();
    }
    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  useEffect(function () {
    setShowArrows(isMobile ? true : false);
  }, [isMobile]);
  var renderOverlay = function renderOverlay(type) {
    var icon = useAsset(imgSold);
    if (type === overlayTypes.reserved) icon = useAsset(imgReserved);
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center absolute right-0 left-0 top-0 bottom-0 z-20",
      style: {
        background: 'rgba(0, 0, 0, 0.5)'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center flex-col w-38 h-38 bg-primary rounded-full opacity-75",
      style: {
        height: 160,
        width: 160
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: icon,
      alt: t('Not available'),
      style: {
        height: 80
      }
    })));
  };
  var renderOnlyTotalPrice = function renderOnlyTotalPrice() {
    var hidePrice = isSold || isReserved;
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-start justify-start w-full font-primary text-secondary-two " + (hidePrice ? 'blurry' : ''),
      style: {
        minHeight: 48
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "mr-2 text-32"
    }, formatPrice(vehicle.price)), /*#__PURE__*/React.createElement("div", {
      className: "text-15"
    }, t('incl VAT')));
  };
  var renderBothPrices = function renderBothPrices() {
    var hidePrice = isSold || isReserved;
    var fontSize = formatPrice(vehicle.price).length > 8 || formatPrice(vehicle.monthlyPrice).length > 8 ? 'text-24' : 'text-24 md:text-28';
    return /*#__PURE__*/React.createElement("div", {
      className: "flex w-full",
      style: {
        minHeight: 48
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col items-start justify-center font-primary text-secondary-three mr-2 " + (hidePrice ? 'blurry' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "" + fontSize
    }, formatPrice(vehicle.price)), /*#__PURE__*/React.createElement("div", {
      className: "text-10"
    }, "(", t('incl VAT'), ")")), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col flex-1 items-start justify-center font-primary text-secondary-two pl-2 border-l-2 border-secondary-four with-financing " + (hidePrice ? 'blurry' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex " + fontSize
    }, /*#__PURE__*/React.createElement("div", {
      className: "mr-1"
    }, formatPrice(vehicle.monthlyPrice), "*")), /*#__PURE__*/React.createElement("div", {
      className: "flex text-10"
    }, /*#__PURE__*/React.createElement("div", {
      className: "mr-2"
    }, "/ ", t('monthly')), /*#__PURE__*/React.createElement("div", {
      className: ""
    }, "(", t('incl VAT'), ")"))));
  };
  var handleMouseEnter = function handleMouseEnter() {
    if (!isMobile) {
      setShowArrows(true);
    }
  };
  var handleMouseLeave = function handleMouseLeave() {
    if (!isMobile) {
      setShowArrows(false);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    key: vehicle.reference,
    className: cardClass + " " + (showArrows ? 'shadow' : 'shadow-inner') + " overflow-hidden border border-secondary-lightest relative " + (!isSold && !isReserved ? 'cursor-pointer' : 'cursor-default'),
    style: _extends({}, styles, {
      outline: 'none !important'
    }),
    onClick: function onClick() {
      return _onClick(vehicle);
    }
  }, isSold && renderOverlay(overlayTypes.sold), isReserved && renderOverlay(overlayTypes.reserved), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col rounded-4 flex-1 h-full "
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative rounded-tl-4 rounded-tr-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative h-full",
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, /*#__PURE__*/React.createElement(ImageViewer, {
    images: mapVehicleImagesForViewer$1(vehicle.images),
    defaultImageUrl: useAsset(imgDefaultVehicleCard),
    renderArrows: function renderArrows(handlePrevClick, handleNextClick) {
      if (!showArrows || isReserved || isSold) return /*#__PURE__*/React.createElement("div", null);
      return /*#__PURE__*/React.createElement("div", {
        className: "text-white"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex items-center justify-center cursor-pointer z-20 absolute left-0 rounded-r-4",
        style: {
          width: 40,
          height: 40,
          top: '50%',
          transform: 'translateY(-50%)',
          background: 'rgba(0,0,0,0.6)'
        },
        onClick: function onClick(e) {
          e.preventDefault();
          handlePrevClick(e);
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "far fa-arrow-left "
      })), /*#__PURE__*/React.createElement("div", {
        className: "flex items-center justify-center cursor-pointer z-20 absolute right-0 rounded-l-4",
        style: {
          width: 40,
          height: 40,
          top: '50%',
          transform: 'translateY(-50%)',
          background: 'rgba(0,0,0,0.6)'
        },
        onClick: function onClick(e) {
          e.preventDefault();
          handleNextClick(e);
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "far fa-arrow-right "
      })));
    },
    renderCounter: function renderCounter(current, total) {
      return /*#__PURE__*/React.createElement("div", {
        className: "absolute right-0 bottom-0 text-white p-2 font-secondary",
        style: {
          background: 'rgba(0,0,0,0.5)',
          borderTopLeftRadius: 4
        }
      }, current, "/", total);
    }
  })), /*#__PURE__*/React.createElement("div", null, context.favorites && /*#__PURE__*/React.createElement("div", {
    className: "absolute",
    style: {
      top: 15,
      right: 50
    }
  }, /*#__PURE__*/React.createElement(VehicleFavoriteBtn$1, {
    reference: vehicle.reference,
    context: context
  })))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col flex-1 p-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col text-left"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "truncate"
  }, vehicle.make, " ", vehicle.model), /*#__PURE__*/React.createElement("div", {
    className: "paragraph-default truncate"
  }, " ", vehicle.version)), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row my-5"
  }, !financingEnabled && renderOnlyTotalPrice(), financingEnabled && hasMonthlyPrice ? renderBothPrices() : renderOnlyTotalPrice()), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row flex-wrap text-secondary-three grid grid-cols-2 border-t-2 border-secondary-four pt-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-start mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center",
    style: {
      width: 24,
      minWidth: 24
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-mileage",
    style: {
      fontSize: 20
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "paragraph-default text-15"
  }, formatNumber(vehicle.mileage), " km")), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-start mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center",
    style: {
      width: 24,
      minWidth: 24
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-transmission",
    style: {
      fontSize: 20
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "paragraph-default capitalize truncate text-15"
  }, vehicle.gearbox)), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center",
    style: {
      width: 24,
      minWidth: 24
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-fuel",
    style: {
      fontSize: 20
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "paragraph-default capitalize truncate text-15"
  }, vehicle.fuel)), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center",
    style: {
      width: 24,
      minWidth: 24
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-registration",
    style: {
      fontSize: 20
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "paragraph-default capitalize truncate text-15"
  }, vehicle.firstRegistrationYear))), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between w-full mt-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row items-center text-secondary-three hover:text-secondary-two " + (context.vehicleCompare ? 'w-3/5' : 'w-full')
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-left",
    style: {
      width: 18,
      minWidth: 18
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-map-marker-alt",
    style: {
      fontSize: 12
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "paragraph-default text-left w-full capitalize truncate underline " + (vehicle !== null && vehicle !== void 0 && (_vehicle$dealer = vehicle.dealer) !== null && _vehicle$dealer !== void 0 && _vehicle$dealer.contactUrl ? 'cursor-pointer' : ''),
    onClick: function onClick(e) {
      var _vehicle$dealer2;
      e.preventDefault();
      e.stopPropagation();
      navigateInternalPage(context, context.defaultPageNames.contact + "/" + (vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$dealer2 = vehicle.dealer) === null || _vehicle$dealer2 === void 0 ? void 0 : _vehicle$dealer2.contactUrl));
    }
  }, vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$dealer3 = vehicle.dealer) === null || _vehicle$dealer3 === void 0 ? void 0 : _vehicle$dealer3.name)), context.vehicleCompare && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-end w-2/5"
  }, /*#__PURE__*/React.createElement(VehicleCompareBtn$1, {
    reference: vehicle.reference,
    context: context
  }))))));
};
VehicleCard.defaultProps = {
  cardClass: 'vehicle-card',
  styles: {
    marginBottom: '2%'
  },
  specsInTwoCols: false
};
var VehicleCard$1 = baseVehicleCard(VehicleCard);

var VehicleCardSkeleton = function VehicleCardSkeleton(_ref) {
  var options = _ref.options,
    showAnimation = _ref.showAnimation;
  var defaultOptions = {
    width: hasWindow() ? window.innerWidth < 768 ? window.innerWidth - 60 : 330 : 300,
    height: 536
  };
  var opt = _extends({}, defaultOptions, options);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: opt.width,
      height: opt.height
    },
    className: (showAnimation ? 'animate-pulse' : '') + " overflow-hidden border border-secondary-lightest relative shadow rounded-4"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: 246
    },
    className: "relative bg-gray-200 mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute w-10 h-10 rounded-full bg-white",
    style: {
      top: 15,
      right: 15
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "px-4 mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-6 bg-gray-200 mb-2 w-2/3"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-4 bg-gray-200 w-full"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex px-4 space-x-2 my-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-1/2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-6 bg-gray-200 mb-2 w-3/4"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-4 bg-gray-200 w-1/3"
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-1/2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-6 bg-gray-200 mb-2 w-3/4"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-4 bg-gray-200 w-1/3"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-2 px-4 mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-start mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-4 h-4 bg-gray-200 mr-2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-4 bg-gray-200 w-2/5"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-start mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-4 h-4 bg-gray-200 mr-2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-4 bg-gray-200 w-2/5"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-start "
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-4 h-4 bg-gray-200 mr-2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-4 bg-gray-200 w-2/5"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-4 h-4 bg-gray-200 mr-2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "h-4 bg-gray-200 w-2/5"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between w-full mt-2 px-4 border-t border-gray-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-1/2  flex flex-row items-center py-6 border-r border-gray-100 pr-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-4 bg-gray-200 w-full"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center w-1/2 py-6 pl-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-4 bg-gray-200 w-full"
  }))));
};
VehicleCardSkeleton.defaultProps = {
  options: {},
  showAnimation: true
};

var VehicleFavoritesOverview = function VehicleFavoritesOverview(_ref) {
  var vehicles = _ref.vehicles,
    loading = _ref.loading,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var totalSkeletons = 3;
  if (loading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4 py-4"
    }, times(totalSkeletons, function (item) {
      return /*#__PURE__*/React.createElement(VehicleCardSkeleton, {
        key: "skeleton-favorite-" + item
      });
    }));
  }
  if (!loading && vehicles.length < 1) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col mb-5"
    }, /*#__PURE__*/React.createElement("div", {
      className: "inline-block md:flex items-center",
      style: {
        lineHeight: 2
      }
    }, t('Look for your favorite cars within our assortment'), /*#__PURE__*/React.createElement("span", {
      className: "bg-gray-50 mx-1 rounded-full px-2 py-1"
    }, /*#__PURE__*/React.createElement("i", {
      className: "fal fa-heart"
    })), t('and keep them in this list.')), /*#__PURE__*/React.createElement("div", {
      className: "inline-block"
    }, /*#__PURE__*/React.createElement(InternalLink, {
      page: context.defaultPageNames.vehicles,
      className: "primary-button inline-block mt-5",
      context: context
    }, t('Assortment of second-hand cars.'))));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 gap-4"
  }, map(vehicles, function (vehicle) {
    return /*#__PURE__*/React.createElement(VehicleCard$1, {
      key: "vehicle-desktop-" + (vehicle === null || vehicle === void 0 ? void 0 : vehicle.reference),
      vehicle: vehicle,
      context: context
    });
  })));
};
var VehicleFavoritesOverview$1 = baseFavoriteVehicles(VehicleFavoritesOverview);

var VehicleFavorites = function VehicleFavorites(_ref) {
  var context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (context.builder) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "mb-5 text-24 md:text-32 text-secondary font-bold"
    }, t('Your favorite vehicles')), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4 py-4"
    }, times(3, function (item) {
      return /*#__PURE__*/React.createElement(VehicleCardSkeleton, {
        key: "skeleton-favorite-" + item,
        showAnimation: false
      });
    })));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "container py-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-5 text-24 md:text-32 text-secondary font-bold"
  }, t('Your favorite vehicles')), /*#__PURE__*/React.createElement(VehicleFavoritesOverview$1, {
    context: context
  }));
};
VehicleFavorites.defaultProps = {};
VehicleFavorites.human = {
  nl: 'Favorite vehicles',
  fr: 'Favorite vehicles',
  en: 'Favorite vehicles'
};
VehicleFavorites.preview = function () {
  return /*#__PURE__*/React.createElement("div", null, "FavoriteVehicles");
};

var ReservationStep = function ReservationStep(_ref) {
  var index = _ref.index,
    step = _ref.step,
    title = _ref.title,
    content = _ref.content,
    completedContent = _ref.completedContent;
  var STEP_IDLE = 0;
  var STEP_ACTIVE = 1;
  var STEP_COMPLETED = 2;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(STEP_IDLE),
    stepState = _useState[0],
    setStepState = _useState[1];
  useEffect(function () {
    calculateStepState();
  }, [step]);
  var calculateStepState = function calculateStepState() {
    if (index === step) {
      return setStepState(STEP_ACTIVE);
    }
    if (index < step) {
      return setStepState(STEP_COMPLETED);
    }
    return setStepState(STEP_IDLE);
  };
  var styles = {
    idle: {
      container: 'bg-secondary-eight',
      step: 'md:text-secondary-eight md:border md:border-secondary-eight',
      title: 'md:text-secondary-five'
    },
    active: {
      container: 'bg-secondary-two',
      step: 'bg-secondary-two',
      title: 'md:text-secondary-two'
    },
    completed: {
      container: 'bg-secondary',
      step: 'bg-secondary',
      title: 'md:text-secondary'
    }
  };
  var getStepStyle = function getStepStyle() {
    if (stepState === STEP_ACTIVE) {
      return styles.active;
    }
    if (stepState === STEP_COMPLETED) {
      return styles.completed;
    }
    return styles.idle;
  };
  var renderStepHeader = function renderStepHeader() {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex w-full py-2 md:py-0 items-center md:bg-transparent rounded text-white text-base md:text-xl " + getStepStyle().container
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center ml-5 md:ml-0 mr-5 md:rounded-full md:h-10 md:w-10 md:border-primary md:mr-8 text-base font-bold md:font-normal " + getStepStyle().step
    }, stepState === STEP_COMPLETED ? /*#__PURE__*/React.createElement("i", {
      className: "fal fa-check"
    }) : index), /*#__PURE__*/React.createElement("div", {
      className: "truncate text-white font-bold " + getStepStyle().title
    }, t(title)));
  };
  var renderStepContent = function renderStepContent() {
    return /*#__PURE__*/React.createElement("div", {
      className: "md:border-l md:border-secondary-eight md:ml-5 md:pl-5 mt-5"
    }, /*#__PURE__*/React.createElement("div", {
      className: "md:ml-8"
    }, content));
  };
  var renderStepComplete = function renderStepComplete() {
    return /*#__PURE__*/React.createElement("div", {
      className: "md:ml-5 md:pl-5 mt-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "md:ml-8"
    }, completedContent));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, renderStepHeader(), stepState === STEP_ACTIVE && renderStepContent(), stepState === STEP_COMPLETED && renderStepComplete());
};

var _initialFormData$3;
var FormFields$3 = {
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phone: 'phone',
  mailings: 'mailings',
  tradeVehicle: 'tradeVehicle'
};
var initialFormData$3 = (_initialFormData$3 = {}, _initialFormData$3[FormFields$3.firstName] = '', _initialFormData$3[FormFields$3.lastName] = '', _initialFormData$3[FormFields$3.email] = '', _initialFormData$3[FormFields$3.phone] = '', _initialFormData$3[FormFields$3.mailings] = false, _initialFormData$3[FormFields$3.tradeVehicle] = false, _initialFormData$3);
var validator$3 = function validator(data, t) {
  var errors = {};
  if (!hasValue(data.firstName)) {
    errors[FormFields$3.firstName] = t('First name is required.');
  }
  if (!hasValue(data.lastName)) {
    errors[FormFields$3.lastName] = t('Last name is required.');
  }
  if (!hasValue(data.email)) {
    errors[FormFields$3.email] = t('Email address is required.');
  } else if (!isValidEmail(data.email)) {
    errors[FormFields$3.email] = t('Email address is not valid.');
  }
  if (!hasValue(data.phone)) {
    errors[FormFields$3.phone] = t('Phone is required.');
  } else if (!isPhoneValid(data.phone)) {
    errors[FormFields$3.phone] = t('Phone number not valid.');
  }
  return errors;
};
var UserForm = function UserForm(_ref) {
  var data = _ref.data,
    setFormValue = _ref.setFormValue,
    submit = _ref.submit,
    submitting = _ref.submitting,
    submitError = _ref.submitError,
    validationErrors = _ref.validationErrors,
    error = _ref.error;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col flex-1 relative h-full justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-default mb-8"
  }, t('Tell us a little bit more about yourself. We need this information to be able to put the car aside for you.')), submitError && /*#__PURE__*/React.createElement("div", {
    className: "-mt-3 mb-5"
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: submitError
  })), error && /*#__PURE__*/React.createElement("div", {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: error
  })), /*#__PURE__*/React.createElement("form", {
    action: "",
    onSubmit: submit,
    className: "flex flex-col mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row mb-6 text-16"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 px-0 mr-0 md:mr-4 mb-6 md:mb-0 font-primary",
    inputClass: "rounded-4",
    label: t('First name'),
    placeholder: "John",
    value: data.firstName,
    onChange: function onChange(value) {
      return setFormValue(FormFields$3.firstName, value);
    },
    errorText: validationErrors[FormFields$3.firstName]
  }), /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 px-0 font-primary",
    inputClass: "rounded-4",
    label: t('Last name'),
    placeholder: "Doe",
    value: data.lastName,
    onChange: function onChange(value) {
      return setFormValue(FormFields$3.lastName, value);
    },
    errorText: validationErrors[FormFields$3.lastName]
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row mb-6 text-16"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 px-0 mr-0 md:mr-4 mb-6 md:mb-0 font-primary",
    inputClass: "rounded-4",
    type: "email",
    label: t('Email address'),
    placeholder: "john.doe@gmail.com",
    value: data.email,
    onChange: function onChange(value) {
      return setFormValue(FormFields$3.email, value);
    },
    errorText: validationErrors[FormFields$3.email]
  }), /*#__PURE__*/React.createElement(InputField, {
    containerClass: "w-full md:w-1/2 px-0 font-primary",
    inputClass: "rounded-4",
    label: t('Phone'),
    placeholder: "0486 32 12 45",
    value: data.phone,
    onChange: function onChange(value) {
      return setFormValue(FormFields$3.phone, value);
    },
    errorText: validationErrors[FormFields$3.phone]
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-2 flex items-center"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: data.tradeVehicle !== undefined ? data.tradeVehicle : false,
    classNames: "mr-0",
    onClick: function onClick(value) {
      return setFormValue(FormFields$3.tradeVehicle, value);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "paragraph-small mr-1 ml-2 "
  }, t('I have a car that I may wish to exchange.'))), /*#__PURE__*/React.createElement("div", {
    className: "paragraph-small",
    style: {
      marginLeft: 32
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-1"
  }, t('We take over all cars.'), " ", t('The acquisition amount will be deducted'), "."))), /*#__PURE__*/React.createElement("div", {
    className: "flex w-full px-0"
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "primary-button"
  }, submitting ? /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement(LoadingIndicator, {
    extraSmall: true,
    color: "white"
  })) : /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, t('Next')))))));
};
var UserForm$1 = baseReservationWizardUserForm(initialFormData$3, validator$3, UserForm);

var ReservationUserInformation = function ReservationUserInformation(props) {
  var reservation = props.reservation,
    step = props.step,
    reservationLoading = props.reservationLoading,
    reservationError = props.reservationError,
    onNext = props.onNext;
  var _useTranslation = useTranslation();
  if (reservationLoading) {
    return /*#__PURE__*/React.createElement(LoadingIndicator$1, null);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center"
  }, /*#__PURE__*/React.createElement(Fade, {
    spy: step,
    duration: 10
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col-reverse md:flex-row px-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative w-full mr-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex h-full"
  }, /*#__PURE__*/React.createElement(UserForm$1, {
    data: reservation.data,
    onSubmit: onNext,
    submitting: reservationLoading,
    error: reservationError
  })))))));
};

var ReservationUserInformationConfirmed = function ReservationUserInformationConfirmed(props) {
  var reservation = props.reservation;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-default text-secondary-five flex mb-2 items-center"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-user-tag text-12 mr-2 w-6"
  }), /*#__PURE__*/React.createElement("div", {
    className: ""
  }, reservation.data.firstName, " ", reservation.data.lastName)), /*#__PURE__*/React.createElement("div", {
    className: "paragraph-default text-secondary-five flex items-center mb-2 "
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-envelope text-12 mr-2 w-6"
  }), /*#__PURE__*/React.createElement("div", {
    className: ""
  }, reservation.data.email)), /*#__PURE__*/React.createElement("div", {
    className: "paragraph-default text-secondary-five flex items-center mb-2 "
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-phone text-12 mr-2 w-6"
  }), /*#__PURE__*/React.createElement("div", {
    className: ""
  }, reservation.data.phone)));
};

var ReservationPayment = function ReservationPayment(props) {
  var settings = props.settings,
    loading = props.loading,
    onNext = props.onNext,
    reservation = props.reservation;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (loading) {
    return /*#__PURE__*/React.createElement(LoadingIndicator$1, null);
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "text-lg font-bold mb-6"
  }, t('This car is almost yours!')), /*#__PURE__*/React.createElement("div", null, t('Dont worry, we will put this car aside for you immediately after payment.'), /*#__PURE__*/React.createElement("sup", null, "1,2")), /*#__PURE__*/React.createElement("div", null, t('You can Pick up the car within'), /*#__PURE__*/React.createElement("span", {
    className: "font-bold"
  }, ' ', settings.days, " ", t('reservation days'))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row items-start md:items-center justify-between bg-secondary-four rounded-4 mt-8 p-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-lg font-bold"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inline"
  }, t('Reservation cost'), " "), /*#__PURE__*/React.createElement("span", {
    className: "inline text-secondary-two"
  }, "\u20AC ", settings.deposit, " "), /*#__PURE__*/React.createElement("span", {
    className: "inline text-secondary-two text-12"
  }, "(", t('incl. 21% VAT'), ")")), settings.paymentLogos && settings.paymentLogos.length > 0 && settings.paymentLogos.some(function (pl) {
    return pl !== '';
  }) && /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap -ml-1"
  }, settings.paymentLogos.filter(function (pl) {
    return pl !== '';
  }).map(function (paymentLogo, i) {
    return /*#__PURE__*/React.createElement("img", {
      key: i,
      src: paymentLogo,
      alt: "Payment",
      style: {
        maxHeight: 45
      },
      className: "ml-1 mt-2"
    });
  }))), (reservation === null || reservation === void 0 ? void 0 : reservation.paymentStatus) === 'cancelled' && /*#__PURE__*/React.createElement("div", {
    className: "mt-5"
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: t('Payment has failed.')
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-start w-full mt-8"
  }, /*#__PURE__*/React.createElement("button", {
    className: "primary-button",
    onClick: onNext
  }, loading ? /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement(LoadingIndicator$1, {
    extraSmall: true,
    color: "white"
  })) : /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, t('Pay')))), /*#__PURE__*/React.createElement("div", {
    className: "text-xs text-secondary-five mt-8"
  }, /*#__PURE__*/React.createElement("sup", null, "1"), " ", t('The reservation cost will be deducted from the purchase of the car or from financing.')), /*#__PURE__*/React.createElement("div", {
    className: "text-xs text-secondary-five mb-10"
  }, /*#__PURE__*/React.createElement("sup", null, "2"), " ", t('The reservation fee will'), /*#__PURE__*/React.createElement("strong", null, " ", t('not be refunded'), " "), " ", t('if you cancel the purchase and/or make the purchase after the'), " ", t('reservation days'), "."));
};

var ReservationCompleted = function ReservationCompleted(props) {
  var settings = props.settings,
    loading = props.loading;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (loading) {
    return /*#__PURE__*/React.createElement(LoadingIndicator$1, null);
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "text-lg font-bold mb-6"
  }, t('Reservation completed.')), /*#__PURE__*/React.createElement("div", null, t('Check your mailbox, a confirmation email has been sent.')), /*#__PURE__*/React.createElement("div", {
    className: "mb-6"
  }, ' ', t('The car will be ready for you for the next'), " ", settings.days, " ", t('days'), "."), /*#__PURE__*/React.createElement("div", {
    className: "text-lg font-bold"
  }, t('We look forward to meeting you in our showroom.')));
};

var ReservationStepper = function ReservationStepper(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var step = props.step;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col flex-1 py-8"
  }, /*#__PURE__*/React.createElement(ReservationStep, {
    index: 1,
    step: step,
    title: t('Your information'),
    content: /*#__PURE__*/React.createElement(ReservationUserInformation, props),
    completedContent: /*#__PURE__*/React.createElement(ReservationUserInformationConfirmed, props)
  }), /*#__PURE__*/React.createElement(ReservationStep, {
    index: 2,
    step: step,
    title: t('Payment'),
    content: /*#__PURE__*/React.createElement(ReservationPayment, props),
    completedContent: /*#__PURE__*/React.createElement("div", {
      className: "text-secondary-five"
    }, "We have received your payment.")
  }), /*#__PURE__*/React.createElement(ReservationStep, {
    index: 3,
    step: step,
    title: t('Confirmation'),
    content: /*#__PURE__*/React.createElement(ReservationCompleted, props)
  }));
};

var VehicleBlock = function VehicleBlock(_ref) {
  var vehicle = _ref.vehicle,
    onClick = _ref.onClick;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "reservation-vehicle w-full"
  }, /*#__PURE__*/React.createElement("img", {
    className: "w-full rounded-t-4",
    src: vehicle.images[0].uri,
    alt: vehicle.make + " " + vehicle.model
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col p-5"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-primary font-bold mb-1 truncate"
  }, vehicle.make, " ", vehicle.model), /*#__PURE__*/React.createElement("div", {
    className: "text-left text-secondary-five text-sm capitalize truncate"
  }, " ", vehicle.version), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center font-bold text-sm mt-5 hover:text-secondary-two cursor-pointer",
    onClick: onClick
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-arrow-right pr-2 no-underline"
  }), /*#__PURE__*/React.createElement("span", {
    className: "hover:underline"
  }, t('View details')))));
};

var PaymentBlock = function PaymentBlock(_ref) {
  var settings = _ref.settings;
  var _useState = useState(false),
    showDescription = _useState[0],
    setShowDescription = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "p-5 font-bold flex justify-between"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "inline"
  }, t('Reservation cost'), " "), /*#__PURE__*/React.createElement("span", {
    className: "inline text-secondary-two"
  }, "\u20AC ", settings.deposit, " "), /*#__PURE__*/React.createElement("span", {
    className: "inline text-secondary-two text-12"
  }, "(", t('incl. 21% VAT'), ")")), /*#__PURE__*/React.createElement("i", {
    className: "fal fa-question-circle ml-1 cursor-pointer hidden lg:block justify-self-end",
    style: {
      marginTop: 5
    },
    onClick: function onClick() {
      return setShowDescription(!showDescription);
    }
  })), /*#__PURE__*/React.createElement(Fade$1, {
    when: showDescription,
    duration: 100,
    collapse: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative text-xs px-5 pb-5"
  }, t('Deposit on your purchase.'), /*#__PURE__*/React.createElement("br", null), t('We do not to sell the car to third parties during'), " ", settings.days, " ", t('days'), ".")));
};

var ReservationWizard = function ReservationWizard(props) {
  var vehicleReference = props.vehicleReference,
    vehicle = props.vehicle,
    loading = props.loading,
    loadingError = props.loadingError,
    error = props.error,
    settings = props.settings,
    context = props.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (vehicleReference === '') {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex container mx-auto w-full min-h-screen"
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-12"
    }));
  }
  if (!loading && loadingError) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex container mx-auto w-full min-h-screen"
    }, /*#__PURE__*/React.createElement(ErrorIndicator, {
      error: error
    }));
  }
  if (loading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex container mx-auto w-full min-h-screen"
    }, /*#__PURE__*/React.createElement(LoadingIndicator$1, null));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "container px-5 mt-6 flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex w-full flex-col flex-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-default"
  }, t('Avoid someone getting ahead of you.'), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h2", {
    className: "font-bold"
  }, t('We reserve this car'), /*#__PURE__*/React.createElement("span", {
    className: "text-secondary-two"
  }, ' ', settings.days, " ", t('days for you'), "."))), /*#__PURE__*/React.createElement("div", {
    className: "flex md:hidden flex-col w-full px-5 sm:w-1/2 sm:self-center bg-secondary-four rounded-4 mt-5"
  }, /*#__PURE__*/React.createElement(VehicleBlock, {
    vehicle: vehicle,
    onClick: function onClick() {
      navigateInternalPage(context, context.defaultPageNames.vehicleDetail, "reference=" + (vehicle.reference ? vehicle.reference : vehicleReference));
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "px-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-secondary-eight w-full",
    style: {
      height: 1
    }
  })), /*#__PURE__*/React.createElement(PaymentBlock, {
    settings: settings
  })), /*#__PURE__*/React.createElement(ReservationStepper, props)), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:flex flex-col ml-8 w-1/3 xl:w-1/4 self-start rounded-4 border border-secondary-eight"
  }, /*#__PURE__*/React.createElement(VehicleBlock, {
    vehicle: vehicle,
    onClick: function onClick() {
      navigateInternalUrl(context, vehicle.url);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "px-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-secondary-eight w-full",
    style: {
      height: 1
    }
  })), /*#__PURE__*/React.createElement(PaymentBlock, {
    settings: settings
  }))));
};
var ReservationWizard$1 = baseReservationWizard(ReservationWizard);

var VehicleReservation = function VehicleReservation(_ref) {
  var payment_logos = _ref.payment_logos,
    vehicle = _ref.vehicle,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ReservationWizard$1, {
    paymentLogos: payment_logos,
    vehicleReference: vehicle,
    context: context
  }));
};

var SelectBox = function SelectBox(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    options = _ref.options,
    isDisabled = _ref.isDisabled,
    className = _ref.className,
    placeholder = _ref.placeholder,
    isLoading = _ref.isLoading,
    isMulti = _ref.isMulti,
    customComponents = _ref.customComponents,
    closeMenuOnSelect = _ref.closeMenuOnSelect;
  var DropdownIndicator = function DropdownIndicator(props) {
    return components.DropdownIndicator && /*#__PURE__*/React.createElement(components.DropdownIndicator, props, /*#__PURE__*/React.createElement("i", {
      className: (props.selectProps.menuIsOpen ? 'fas fa-angle-up' : 'fas fa-angle-down') + " text-secondary-two"
    }));
  };
  var formatGroupLabel = function formatGroupLabel(data) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
      className: "font-secondary font-semibold text-primary text-12"
    }, "- ", data.label));
  };
  var Components = customComponents ? _extends({
    DropdownIndicator: DropdownIndicator
  }, customComponents) : {
    DropdownIndicator: DropdownIndicator
  };
  return /*#__PURE__*/React.createElement(Select, {
    value: value,
    onChange: onChange,
    options: options,
    classNamePrefix: "dcc-select",
    className: "text-14 font-secondary text-primary " + className,
    components: Components,
    formatGroupLabel: formatGroupLabel,
    isDisabled: isDisabled,
    placeholder: placeholder,
    isLoading: isLoading,
    closeMenuOnSelect: closeMenuOnSelect,
    isMulti: isMulti,
    styles: {
      indicatorSeparator: function indicatorSeparator(styles) {
        return {
          display: 'none'
        };
      },
      indicatorContainer: function indicatorContainer(styles) {
        return {
          marginTop: '1px'
        };
      }
    }
  });
};
SelectBox.defaultProps = {
  value: null,
  options: [],
  isDisabled: false,
  className: '',
  placeholder: 'Select...',
  isLoading: false,
  customComponents: null,
  isMulti: false,
  closeMenuOnSelect: true
};

var GenericSelect = function GenericSelect(_ref) {
  var placeHolder = _ref.placeHolder,
    items = _ref.items,
    values = _ref.values,
    handleFilterChanged = _ref.handleFilterChanged;
  var options = orderBy(map(items, function (item) {
    return {
      value: item.key,
      label: item.text
    };
  }), ['label']);
  var valuesLabels = map(filter(options, function (option) {
    return includes(values, option.value);
  }), function (item) {
    return item.label;
  });
  var valueLabel = valuesLabels.length > 0 ? {
    label: valuesLabels.join(', ')
  } : '';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectBox, {
    value: valueLabel,
    options: options,
    placeholder: placeHolder,
    closeMenuOnSelect: false,
    customComponents: {
      Option: function Option(_ref2) {
        var innerProps = _ref2.innerProps,
          isDisabled = _ref2.isDisabled,
          data = _ref2.data;
        var isSelected = includes(values, data.value);
        return !isDisabled ? /*#__PURE__*/React.createElement("div", innerProps, /*#__PURE__*/React.createElement("div", {
          className: "flex flex-row py-1 hover:bg-gray-100 cursor-pointer hover:text-primary ml-5",
          onClick: function onClick() {
            return handleFilterChanged(data);
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex items-center"
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex items-center justify-center rounded border border-primary mr-2",
          style: {
            height: 16,
            width: 16
          }
        }, isSelected && /*#__PURE__*/React.createElement("i", {
          className: "far fa-check text-secondary-two font-bold",
          style: {
            fontSize: 10,
            marginTop: 2
          }
        }))), /*#__PURE__*/React.createElement("div", {
          className: "flex flex-row justify-between flex-1 relative  font-secondary " + (isSelected ? 'text-secondary-two' : 'text-secondary-three')
        }, /*#__PURE__*/React.createElement("div", {
          className: "capitalize"
        }, data.label)))) : null;
      }
    },
    isLoading: false
  }));
};

var MakesFilter = function MakesFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-secondary font-semibold text-primary mb-2 mt-5"
  }, t('Make')), /*#__PURE__*/React.createElement(GenericSelect, {
    placeHolder: t('All'),
    items: orderBy(data, ['priority', 'text'], ['desc', 'asc']),
    values: value,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasCriteriaWithValue(data.value)) {
        criteriaDelete(data.value);
      } else {
        criteriaAdd(data.value);
      }
    }
  }));
};
var MakesFilter$1 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.make, MakesFilter);

var ModelsFilter = function ModelsFilter(_ref) {
  var allData = _ref.allData,
    criteria = _ref.criteria,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var makes = allData.makes;
  var makeOptions = makes ? makes.map(function (make) {
    return {
      value: make.key,
      label: make.text
    };
  }) : [];
  var makeFilters = map(filter(criteria, function (f) {
    return f.type === SearchAgentCriteriaTypes.make;
  }), function (m) {
    return m.value;
  });
  var makesInFilters = filter(makes, function (m) {
    return includes(makeFilters, m.key);
  });
  var modelOptions = map(makesInFilters, function (make) {
    return {
      value: make.key,
      label: make.text,
      options: make.models ? orderBy(map(make.models, function (model) {
        return {
          label: model.text,
          value: model.key,
          makeKey: make.key
        };
      }), ['label']) : []
    };
  });
  var modelsInFilters = groupBy(filter(criteria, function (f) {
    return f.type === SearchAgentCriteriaTypes.modelFamily;
  }), 'additional');
  var modelLabel = '';
  if (!isEmpty(modelsInFilters) && !isEmpty(makes)) {
    Object.keys(modelsInFilters).map(function (key) {
      var make = head(filter(makes, function (make) {
        return make.key === key;
      }));
      var modelString = '';
      map(modelsInFilters[key], function (m) {
        var model = find(make.models, function (model) {
          return model.key === m.value;
        });
        if (model) {
          modelString = modelString ? modelString + ", " + model.text : "" + model.text;
        }
      });
      modelLabel = modelLabel ? modelLabel + ", " + make.text + ": " + modelString : make.text + ": " + modelString;
    });
  }
  var handleFilterChanged = function handleFilterChanged(model) {
    if (hasCriteriaWithValue(model.value)) {
      criteriaDelete(model.value, {
        additional: model.makeKey
      });
    } else {
      criteriaAdd(model.value, {
        additional: model.makeKey
      });
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-xsmall font-semibold text-primary mb-2 mt-5"
  }, t('Model')), /*#__PURE__*/React.createElement(SelectBox, {
    value: modelLabel ? {
      label: modelLabel
    } : '',
    options: orderBy(modelOptions, ['label']),
    closeMenuOnSelect: false,
    placeholder: t('All'),
    customComponents: {
      Option: function Option(_ref2) {
        var innerProps = _ref2.innerProps,
          isDisabled = _ref2.isDisabled,
          data = _ref2.data;
        var isSelected = find(filter(criteria, function (f) {
          return f.type === SearchAgentCriteriaTypes.modelFamily;
        }), function (f) {
          return f.value === data.value;
        });
        return !isDisabled ? /*#__PURE__*/React.createElement("div", innerProps, /*#__PURE__*/React.createElement("div", {
          className: "flex flex-row py-1 cursor-pointer hover:text-primary ml-5 text-secondary-four",
          onClick: function onClick() {
            return handleFilterChanged(data);
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex items-center"
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex items-center justify-center rounded border mr-2 " + (isSelected ? 'bg-secondary-one border-secondary-one' : 'border-primary'),
          style: {
            height: 16,
            width: 16
          }
        }, isSelected && /*#__PURE__*/React.createElement("i", {
          className: "far fa-check text-white",
          style: {
            fontSize: 10,
            marginTop: 2
          }
        }))), /*#__PURE__*/React.createElement("div", {
          className: "flex flex-row justify-between flex-1 relative  font-secondary " + (isSelected ? 'text-secondary-two' : 'text-secondary-three')
        }, /*#__PURE__*/React.createElement("div", {
          className: "capitalize"
        }, data.label)))) : null;
      }
    },
    isLoading: false
  }));
};
var ModelsFilter$1 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.modelFamily, ModelsFilter);

var BodiesFilter = function BodiesFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation();
  var onFilterChanged = function onFilterChanged(data) {
    if (hasCriteriaWithValue(data.key)) {
      criteriaDelete(data.key);
    } else {
      criteriaAdd(data.key);
    }
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center mx-auto overflow-x-auto overflow-y-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-nowrap",
    style: {
      width: 'min-content'
    }
  }, map(orderBy(data, ['priority', 'text']), function (bt, i) {
    var isSelected = includes(value, bt.key);
    var isLast = data.length - 1 === i;
    return /*#__PURE__*/React.createElement("div", {
      key: "BodyType" + i,
      onClick: function onClick() {
        return onFilterChanged(bt);
      },
      className: "rounded-10 border " + (isSelected ? 'border-primary' : 'border-secondary-lightest') + " hover:border-primary cursor-pointer " + (isLast ? '' : 'mr-4'),
      style: {
        width: 110,
        height: 110,
        borderRadius: 22,
        boxShadow: '0px 3px 3px #0000000D'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col items-center justify-center outline-none text-primary py-6"
    }, /*#__PURE__*/React.createElement("i", {
      className: bt.icon + " px-6 ",
      style: {
        fontSize: 29
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "mt-3 text-14 truncate font-secondary leading-24 w-full text-center"
    }, bt.text)));
  }))));
};
var BodyFilter = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.body, BodiesFilter);

var FuelFilter = function FuelFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-secondary font-semibold text-primary mb-2 mt-5"
  }, t('Fuel type')), /*#__PURE__*/React.createElement(GenericSelect, {
    placeHolder: t('All'),
    items: orderBy(data, ['text']),
    values: value,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasCriteriaWithValue(data.value)) {
        criteriaDelete(data.value);
      } else {
        criteriaAdd(data.value);
      }
    }
  }));
};
var FuelFilter$1 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.fuel, FuelFilter);

var GearboxFilter = function GearboxFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-secondary font-semibold text-primary mb-2 mt-5"
  }, t('Gear')), /*#__PURE__*/React.createElement(GenericSelect, {
    placeHolder: t('All'),
    items: orderBy(data, ['text']),
    values: value,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasCriteriaWithValue(data.value)) {
        criteriaDelete(data.value);
      } else {
        criteriaAdd(data.value);
      }
    }
  }));
};
var GearboxFilter$1 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.transmission, GearboxFilter);

var GenericRangeSelect = function GenericRangeSelect(_ref) {
  var placeHolderFrom = _ref.placeHolderFrom,
    placeHolderTo = _ref.placeHolderTo,
    optionsFrom = _ref.optionsFrom,
    optionsTo = _ref.optionsTo,
    value = _ref.value,
    handleFilterChanged = _ref.handleFilterChanged;
  var valueFrom = value ? {
    label: value[0] ? value[0] : ''
  } : '';
  var valueTo = value ? {
    label: value[1] ? value[1] : ''
  } : '';
  if (value && value[0]) {
    optionsTo = filter(optionsTo, function (y) {
      return y.value >= value[0];
    });
  }
  if (value && value[1]) {
    optionsFrom = filter(optionsFrom, function (y) {
      return y.value <= value[1];
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-2 w-full "
  }, /*#__PURE__*/React.createElement(SelectBox, {
    value: valueFrom,
    options: optionsFrom,
    className: "no-right-rounded no-right-border",
    placeholder: placeHolderFrom,
    isLoading: false,
    onChange: function onChange(item) {
      var start = item.value;
      var stop = value && value[1] && value[1] > item.value ? value[1] : undefined;
      handleFilterChanged([start, stop]);
    }
  }), /*#__PURE__*/React.createElement(SelectBox, {
    value: valueTo,
    options: optionsTo,
    className: "no-left-rounded",
    placeholder: placeHolderTo,
    isLoading: false,
    onChange: function onChange(item) {
      var start = value && value[0] && value[0] < item.value ? value[0] : undefined;
      var stop = item.value;
      handleFilterChanged([start, stop]);
    }
  }));
};

var YearFilter = function YearFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaUpdate = _ref.criteriaUpdate;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var yearsFrom = range(data.min, data.max + 1).map(function (item) {
    return {
      value: item,
      label: item
    };
  });
  var yearsTo = range(data.min, data.max + 1).map(function (item) {
    return {
      value: item,
      label: item
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-secondary font-semibold text-primary mb-2 mt-5"
  }, t('First registration')), /*#__PURE__*/React.createElement(GenericRangeSelect, {
    placeHolderFrom: t('From'),
    placeHolderTo: t('To'),
    optionsFrom: orderBy(yearsFrom, ['value'], ['desc']),
    optionsTo: orderBy(yearsTo, ['value'], ['desc']),
    value: value && value.length > 0 ? value[0] : undefined,
    handleFilterChanged: function handleFilterChanged(range) {
      if (value.length > 0) {
        criteriaUpdate(range);
      } else {
        criteriaAdd(range);
      }
    }
  }));
};
var YearFilter$1 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.year, YearFilter);

var MileageFilter = function MileageFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaUpdate = _ref.criteriaUpdate;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var mileagesFrom = range(data.min, data.max + 1, 5000).map(function (mileage) {
    return {
      value: Math.round(mileage / 1000) * 1000,
      label: formatNumber(Math.round(mileage / 1000) * 1000) + " km"
    };
  });
  var mileagesTo = range(data.min, data.max + 1, 5000).map(function (mileage) {
    return {
      value: Math.round(mileage / 1000) * 1000,
      label: formatNumber(Math.round(mileage / 1000) * 1000) + " km"
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-secondary font-semibold text-primary mb-2 mt-5"
  }, t('Mileage')), /*#__PURE__*/React.createElement(GenericRangeSelect, {
    placeHolderFrom: t('From'),
    placeHolderTo: t('To'),
    optionsFrom: mileagesFrom,
    optionsTo: mileagesTo,
    value: value && value.length > 0 ? value[0] : undefined,
    handleFilterChanged: function handleFilterChanged(range) {
      if (value.length > 0) {
        criteriaUpdate(range);
      } else {
        criteriaAdd(range);
      }
    }
  }));
};
var MileageFilter$1 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.mileage, MileageFilter);

var DoorsFilter = function DoorsFilter(_ref) {
  var value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaUpdate = _ref.criteriaUpdate,
    criteriaDelete = _ref.criteriaDelete;
  var doorsRangeValue = value && value.length > 0 ? value[0] : undefined;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var filterExists = function filterExists(range) {
    return doorsRangeValue ? includes(doorsRangeValue, range[0]) && includes(doorsRangeValue, range[1]) : false;
  };
  var handleFilterChanged = function handleFilterChanged(range) {
    if (value.length > 0) {
      criteriaUpdate(range);
    } else {
      criteriaAdd(range);
    }
  };
  var handleRemoveFilter = function handleRemoveFilter() {
    criteriaDelete(FilterTypes.doorsRange);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-secondary font-semibold text-primary mb-2 mt-5"
  }, t('Nr. of Doors')), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-4 font-secondary text-14"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-input cursor-pointer text-center border border-primary rounded-l-10 " + (!doorsRangeValue ? 'bg-secondary-two text-white' : 'text-secondary'),
    onClick: function onClick() {
      return handleRemoveFilter();
    }
  }, t('All')), /*#__PURE__*/React.createElement("div", {
    className: "filter-input cursor-pointer text-center border-t border-b border-primary " + (filterExists([2, 3]) ? 'bg-secondary-two text-white' : 'text-secondary'),
    onClick: function onClick() {
      return handleFilterChanged([2, 3]);
    }
  }, "2/3"), /*#__PURE__*/React.createElement("div", {
    className: "filter-input cursor-pointer text-center border-t border-b border-l border-primary " + (filterExists([4, 5]) ? 'bg-secondary-two text-white' : 'text-secondary'),
    onClick: function onClick() {
      return handleFilterChanged([4, 5]);
    }
  }, "4/5"), /*#__PURE__*/React.createElement("div", {
    className: "filter-input cursor-pointer text-center border border-primary rounded-r-10 " + (filterExists([6, 7]) ? 'bg-secondary-two text-white' : 'text-secondary'),
    onClick: function onClick() {
      return handleFilterChanged([6, 7]);
    }
  }, "6/7")));
};
var DoorsFilter$1 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.doorsRange, DoorsFilter);

var GenericList = function GenericList(_ref) {
  var items = _ref.items,
    values = _ref.values,
    handleFilterChanged = _ref.handleFilterChanged,
    containerClass = _ref.containerClass,
    renderSubFilters = _ref.renderSubFilters;
  var options = orderBy(map(filter(items, function (i) {
    return i;
  }), function (item) {
    if (item) {
      return {
        value: item === null || item === void 0 ? void 0 : item.key,
        label: item === null || item === void 0 ? void 0 : item.text
      };
    }
  }), ['label']);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: containerClass
  }, map(options, function (option, i) {
    var isSelected = includes(values, option.value);
    return /*#__PURE__*/React.createElement("div", {
      key: "filter-" + option.value + "-" + i,
      className: "flex flex-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row py-0.5 cursor-pointer text-secondary-three font-normal hover:font-semibold",
      onClick: function onClick() {
        return handleFilterChanged(option);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center rounded border border-primary mr-2",
      style: {
        height: 16,
        width: 16
      }
    }, isSelected && /*#__PURE__*/React.createElement("i", {
      className: "far fa-check text-secondary-two font-bold",
      style: {
        fontSize: 10,
        marginTop: 2
      }
    }))), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row justify-between flex-1 relative font-secondary " + (isSelected ? 'font-semibold' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "capitalize"
    }, option.label))), renderSubFilters && typeof renderSubFilters === 'function' && isSelected && renderSubFilters(option));
  })));
};
GenericList.defaultProps = {
  containerClass: 'space-y-2',
  renderSubFilters: undefined
};

var CategoryFilter = function CategoryFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-secondary font-semibold text-primary mb-2 mt-5"
  }, t('Vehicle condition')), /*#__PURE__*/React.createElement(GenericList, {
    items: data,
    values: value,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasCriteriaWithValue(data.value)) {
        criteriaDelete(data.value);
      } else {
        criteriaAdd(data.value);
      }
    },
    containerClass: "flex flex-row space-x-4"
  }));
};
var CategoryFilter$1 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.category, CategoryFilter);

var VatFilter = function VatFilter(_ref) {
  var value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var handleFilterChanged = function handleFilterChanged() {
    if (hasCriteriaWithValue(true)) {
      criteriaDelete(true);
    } else {
      criteriaAdd(true);
    }
  };
  var isSelected = includes(value, true);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-secondary font-semibold text-primary mb-2 mt-5"
  }, t('VAT')), /*#__PURE__*/React.createElement("div", {
    key: "filter-vat",
    className: "flex flex-col text-gray-900 mb-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row py-1 hover:bg-gray-100 cursor-pointer hover:text-primary",
    onClick: function onClick() {
      return handleFilterChanged();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center rounded border border-primary mr-2",
    style: {
      height: 16,
      width: 16
    }
  }, isSelected && /*#__PURE__*/React.createElement("i", {
    className: "far fa-check text-secondary-two font-bold",
    style: {
      fontSize: 10,
      marginTop: 2
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row justify-between flex-1 relative text-secondary-three font-secondary " + (isSelected ? 'font-bold' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, t('VAT deductible'))))));
};
var VatFilter$1 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.vat, VatFilter);

var SeatsFilter = function SeatsFilter(_ref) {
  var value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaUpdate = _ref.criteriaUpdate,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var seatsRangeValue = value && value.length > 0 ? value[0] : undefined;
  var filterExists = function filterExists(seats) {
    return seatsRangeValue && seatsRangeValue[0] === seats ? true : false;
  };
  var handleFilterChanged = function handleFilterChanged(range) {
    if (value.length <= 0) {
      criteriaAdd(range);
    } else {
      if (hasCriteriaWithValue(range)) {
        criteriaDelete();
      } else {
        criteriaUpdate(range);
      }
    }
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "font-secondary font-semibold text-primary mb-2 mt-5"
  }, t('Nr. of Seats')), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap font-secondary text-14"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rounded-10 border " + (filterExists(2) ? 'border-primary' : 'border-secondary-lightest') + " hover:border-primary py-4 px-6 cursor-pointer mr-4 mb-4 md:mb-0",
    style: {
      width: 100,
      height: 100,
      borderRadius: 22,
      boxShadow: '0px 3px 3px #0000000D'
    },
    onClick: function onClick() {
      return handleFilterChanged([2]);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center outline-none text-primary"
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-family-small",
    style: {
      fontSize: 29
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "mt-3 text-14 truncate font-secondary leading-24 w-full text-center"
  }, "S"))), /*#__PURE__*/React.createElement("div", {
    className: "rounded-10 border " + (filterExists(3) ? 'border-primary' : 'border-secondary-lightest') + " hover:border-primary py-4 px-6 cursor-pointer mr-4 mb-4 md:mb-0",
    style: {
      width: 100,
      height: 100,
      borderRadius: 22,
      boxShadow: '0px 3px 3px #0000000D'
    },
    onClick: function onClick() {
      return handleFilterChanged([3]);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center outline-none text-primary"
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-family-medium",
    style: {
      fontSize: 29
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "mt-3 text-14 truncate font-secondary leading-24 w-full text-center"
  }, "M"))), /*#__PURE__*/React.createElement("div", {
    className: "rounded-10 border " + (filterExists(4) ? 'border-primary' : 'border-secondary-lightest') + " hover:border-primary py-4 px-6 cursor-pointer mr-4",
    style: {
      width: 100,
      height: 100,
      borderRadius: 22,
      boxShadow: '0px 3px 3px #0000000D'
    },
    onClick: function onClick() {
      return handleFilterChanged([4]);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center outline-none text-primary"
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-family-large",
    style: {
      fontSize: 29
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "mt-3 text-14 truncate font-secondary leading-24 w-full text-center"
  }, "L"))), /*#__PURE__*/React.createElement("div", {
    className: "rounded-10 border " + (filterExists(5) ? 'border-primary' : 'border-secondary-lightest') + " hover:border-primary py-4 px-6 cursor-pointer",
    style: {
      width: 100,
      height: 100,
      borderRadius: 22,
      boxShadow: '0px 3px 3px #0000000D'
    },
    onClick: function onClick() {
      return handleFilterChanged([5]);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center outline-none text-primary"
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon-family-xlarge",
    style: {
      fontSize: 29
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "mt-3 text-14 truncate font-secondary leading-24 w-full text-center"
  }, "XL")))));
};
var SeatFilter = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.seatsRange, SeatsFilter);

var EquipmentFilter = function EquipmentFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var handleFilterChanged = function handleFilterChanged(equipment) {
    if (hasCriteriaWithValue(equipment.key)) {
      criteriaDelete(equipment.key);
    } else {
      criteriaAdd(equipment.key);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-3 gap-1"
  }, map(orderBy(data, ['text']), function (eq) {
    var isSelected = includes(value, eq.key);
    return /*#__PURE__*/React.createElement("div", {
      key: "filter-eq-" + eq.key,
      className: "flex flex-col text-gray-900 mb-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row py-1 hover:bg-gray-100 cursor-pointer hover:text-primary",
      onClick: function onClick() {
        return handleFilterChanged(eq);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center rounded border border-primary mr-2",
      style: {
        height: 16,
        width: 16
      }
    }, isSelected && /*#__PURE__*/React.createElement("i", {
      className: "far fa-check text-secondary-two font-bold",
      style: {
        fontSize: 10,
        marginTop: 2
      }
    }))), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row justify-between flex-1 relative text-secondary-three font-secondary " + (isSelected ? 'font-bold' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "capitalize"
    }, eq.text), /*#__PURE__*/React.createElement("div", null, eq.value))));
  }));
};
var EquipmentFilter$1 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.equipments, EquipmentFilter);

var GenericColorList = function GenericColorList(_ref) {
  var items = _ref.items,
    values = _ref.values,
    handleFilterChanged = _ref.handleFilterChanged,
    gridClass = _ref.gridClass;
  var options = orderBy(map(items, function (item) {
    return {
      value: item.key,
      label: item.text,
      color: item.custom
    };
  }), ['label']);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: gridClass
  }, map(options, function (option) {
    var isSelected = includes(values, option.value);
    return /*#__PURE__*/React.createElement("div", {
      key: "filter-" + option.value,
      className: "flex flex-col text-gray-900 mb-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row py-1 cursor-pointer hover:text-primary",
      onClick: function onClick() {
        return handleFilterChanged(option);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center mr-2 " + (option.value === 'white' ? 'border border-secondary-five' : ''),
      style: {
        height: 16,
        width: 16,
        backgroundColor: option.color,
        borderRadius: 4
      }
    }, isSelected && /*#__PURE__*/React.createElement("i", {
      className: "far fa-check font-bold " + (option.value === 'white' ? 'text-primary' : 'text-white'),
      style: {
        fontSize: 10,
        marginTop: 2
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1 paragraph-small " + (isSelected ? 'font-semibold' : 'font-normal')
    }, /*#__PURE__*/React.createElement("div", {
      className: "capitalize"
    }, option.label))));
  })));
};
GenericColorList.defaultProps = {
  gridClass: 'grid grid-cols-2 gap-1'
};

var ExteriorColorFilter = function ExteriorColorFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-secondary font-semibold text-primary mb-2 mt-2"
  }, t('Body Color')), /*#__PURE__*/React.createElement(GenericColorList, {
    placeHolder: t('All'),
    items: orderBy(data, ['text']),
    values: value,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasCriteriaWithValue(data.value)) {
        criteriaDelete(data.value);
      } else {
        criteriaAdd(data.value);
      }
    },
    gridClass: "grid grid-cols-3 md:grid-cols-4 gap-1"
  }));
};
var ExteriorColorFilter$1 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.exteriorColor, ExteriorColorFilter);

var InteriorColorFilter = function InteriorColorFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-secondary font-semibold text-primary mb-2 mt-2"
  }, t('Interior Color')), /*#__PURE__*/React.createElement(GenericColorList, {
    placeHolder: t('All'),
    items: orderBy(data, ['text']),
    values: value,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasCriteriaWithValue(data.value)) {
        criteriaDelete(data.value);
      } else {
        criteriaAdd(data.value);
      }
    },
    gridClass: "grid grid-cols-3 md:grid-cols-4 gap-1"
  }));
};
var InteriorColorFilter$1 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.interiorColor, InteriorColorFilter);

var InteriorUpholstery = function InteriorUpholstery(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-secondary font-semibold text-primary mb-2 mt-5"
  }, t('Upholstery')), /*#__PURE__*/React.createElement(GenericList, {
    items: orderBy(data, ['text']),
    values: value,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasCriteriaWithValue(data.value)) {
        criteriaDelete(data.value);
      } else {
        criteriaAdd(data.value);
      }
    },
    containerClass: "grid grid-cols-3 md:grid-cols-4 gap-1"
  }));
};
var InteriorUpholsteryFilter = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.interiorUpholstery, InteriorUpholstery);

var initCoValue = {
  min: '',
  max: ''
};
var CO2Filter = function CO2Filter(_ref) {
  var currentValue = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaUpdate = _ref.criteriaUpdate,
    criteriaDelete = _ref.criteriaDelete;
  var activeFilter = currentValue && currentValue.length > 0 ? currentValue[0] : undefined;
  var _useState = useState(activeFilter ? {
      min: activeFilter[0],
      max: activeFilter[1]
    } : initCoValue),
    value = _useState[0],
    setValue = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var handleChange = function handleChange() {
    if (value.min !== '' || value.max !== '') {
      var range = [value.min, value.max];
      if (currentValue.length > 0) {
        criteriaUpdate(range);
      } else {
        criteriaAdd(range);
      }
    } else {
      criteriaDelete();
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-secondary font-semibold text-primary mb-2 mt-5"
  }, t('CO2 (g/km)')), /*#__PURE__*/React.createElement("div", {
    className: "flex font-secondary text-14"
  }, /*#__PURE__*/React.createElement("input", {
    className: "w-1/2 filter-input border border-primary text-14 font-secondary text-primary rounded-l-10 focus:outline-none",
    value: value.min,
    style: {
      maxHeight: 46
    },
    placeholder: t('From'),
    onChange: function onChange(e) {
      return setValue(_extends({}, value, {
        min: e.target.value
      }));
    },
    onBlur: function onBlur() {
      return handleChange();
    }
  }), /*#__PURE__*/React.createElement("input", {
    className: "w-1/2 filter-input border-t border-b border-r border-primary text-14 font-secondary text-primary rounded-r-10 focus:outline-none",
    value: value.max,
    style: {
      maxHeight: 46
    },
    placeholder: t('To'),
    onChange: function onChange(e) {
      return setValue(_extends({}, value, {
        max: e.target.value
      }));
    },
    onBlur: function onBlur() {
      return handleChange();
    }
  })));
};
var CO2Filter$1 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.co2Range, CO2Filter);

var EuroNormFilter = function EuroNormFilter(_ref) {
  var data = _ref.data,
    value = _ref.value,
    criteriaAdd = _ref.criteriaAdd,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteriaWithValue = _ref.hasCriteriaWithValue;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-secondary font-semibold text-primary mb-2 mt-5"
  }, t('Euro Emission Class')), /*#__PURE__*/React.createElement(GenericSelect, {
    placeHolder: t('All'),
    items: data,
    values: value,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasCriteriaWithValue(data.value)) {
        criteriaDelete(data.value);
      } else {
        criteriaAdd(data.value);
      }
    }
  }));
};
var EuroNormFilter$1 = baseTypedSearchAgentCriteria(SearchAgentCriteriaTypes.euroNorm, EuroNormFilter);

var getCurrentRangeForSlider = function getCurrentRangeForSlider(type, prices, monthlyPrices) {
  if (type === types.price) {
    return prices;
  } else if (type === types.monthly) {
    return monthlyPrices;
  }
};
var types = {
  price: 'price',
  monthly: 'monthly'
};
var PriceSlider = function PriceSlider(_ref) {
  var values = _ref.values,
    defaultValues = _ref.defaultValues,
    prices = _ref.prices,
    monthlyPrices = _ref.monthlyPrices,
    onChange = _ref.onChange,
    radioButtonSize = _ref.radioButtonSize,
    title = _ref.title,
    className = _ref.className;
  var _useState = useState(types.price),
    type = _useState[0],
    setType = _useState[1];
  var currentRange = getCurrentRangeForSlider(type, prices, monthlyPrices);
  var valueRange = values[type] ? values[type] : defaultValues[type] ? defaultValues[type] : undefined;
  var currentMaxPrice = valueRange ? valueRange[1] : currentRange.max;
  var _useState2 = useState(currentMaxPrice),
    displayPrice = _useState2[0],
    setDisplayPrice = _useState2[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    setDisplayPrice(currentMaxPrice);
  }, [currentMaxPrice]);
  var getDisplayPriceString = function getDisplayPriceString() {
    if (displayPrice !== currentRange.max) {
      return "\u20AC " + formatNumber(displayPrice);
    } else {
      return '-';
    }
  };
  var handleChange = function handleChange(type, value) {
    var _extends2;
    onChange(_extends({}, values, (_extends2 = {}, _extends2[type] = value, _extends2)));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, title && /*#__PURE__*/React.createElement("div", {
    className: "price-slider-title paragraph-xsmall font-semibold text-primary mb-2 mt-5"
  }, t('Price (€)')), /*#__PURE__*/React.createElement("div", {
    className: "relative font-normal font-secondary text-primary w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "price-slider-header-container flex mb-4 w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center mr-10 cursor-pointer " + (type === types.price ? 'active' : 'inactive'),
    onClick: function onClick() {
      return setType(types.price);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "rounded-full border border-primary p-1 mr-2",
    style: {
      height: radioButtonSize,
      width: radioButtonSize
    }
  }, type === types.price && /*#__PURE__*/React.createElement("div", {
    className: "rounded-full bg-secondary-two h-full w-full"
  })), /*#__PURE__*/React.createElement("span", {
    className: "text-primary"
  }, t('Total'))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center cursor-pointer " + (type === types.monthly ? 'active' : 'inactive'),
    onClick: function onClick() {
      return setType(types.monthly);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "rounded-full border border-primary p-1 mr-2",
    style: {
      height: radioButtonSize,
      width: radioButtonSize
    }
  }, type === types.monthly && /*#__PURE__*/React.createElement("div", {
    className: "rounded-full bg-secondary-two h-full w-full"
  })), /*#__PURE__*/React.createElement("span", {
    className: "text-primary"
  }, t('Monthly')))), /*#__PURE__*/React.createElement(Slider, {
    min: currentRange.min,
    max: currentRange.max,
    value: displayPrice,
    step: currentRange.step,
    onAfterChange: function onAfterChange(value) {
      return handleChange(type, [currentRange.min, value]);
    },
    onChange: function onChange(value) {
      setDisplayPrice(value);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "mt-2 text-primary inline-block font-secondary"
  }, type === types.price && t('Max. price'), " ", type === types.monthly && t('Max. amount'), " ", /*#__PURE__*/React.createElement("span", {
    className: "ml-2"
  }, getDisplayPriceString()))));
};
PriceSlider.defaultProps = {
  title: true,
  loading: false,
  radioButtonSize: 16,
  defaultValues: {
    price: undefined,
    monthly: undefined
  },
  className: ''
};

var PriceFilter = function PriceFilter(_ref) {
  var criteria = _ref.criteria,
    data = _ref.data,
    criteriaAdd = _ref.criteriaAdd,
    criteriaUpdate = _ref.criteriaUpdate,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteria = _ref.hasCriteria,
    radioButtonSize = _ref.radioButtonSize;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var prices = data.prices,
    monthlyPrices = data.monthlyPrices;
  var handleChange = function handleChange(type, range) {
    var typeMax = type === SearchAgentCriteriaTypes.price ? prices.max : type === SearchAgentCriteriaTypes.monthlyPrice ? monthlyPrices.max : 0;
    var rangeIsMax = range[1] === typeMax;
    if (!rangeIsMax) {
      var labelPrefix = type === SearchAgentCriteriaTypes.price ? t('Max.') : type === SearchAgentCriteriaTypes.monthlyPrice ? t('Monthly max.') : '';
      if (hasCriteria(type)) {
        criteriaUpdate(type, range);
      } else {
        criteriaAdd(type, range);
      }
    } else {
      criteriaDelete(type);
    }
  };
  var priceFilter = find(criteria, function (f) {
    return f.type === SearchAgentCriteriaTypes.price;
  });
  var monthlyFilter = find(criteria, function (f) {
    return f.type === SearchAgentCriteriaTypes.monthlyPrice;
  });
  return /*#__PURE__*/React.createElement(PriceSlider, {
    prices: prices,
    monthlyPrices: monthlyPrices,
    values: {
      price: priceFilter ? priceFilter.value : undefined,
      monthly: monthlyFilter ? monthlyFilter.value : undefined
    },
    onChange: function onChange(values) {
      if (values.price) {
        handleChange(SearchAgentCriteriaTypes.price, values.price);
      }
      if (values.monthly) {
        handleChange(SearchAgentCriteriaTypes.monthlyPrice, values.monthly);
      }
    },
    radioButtonSize: radioButtonSize
  });
};
PriceFilter.defaultProps = {
  radioButtonSize: 24
};
var PriceFilter$1 = baseSearchAgentCriteria(PriceFilter);

var labels = {
  PK: 'PK',
  KW: 'KW'
};
var initPK = {
  min: '',
  max: ''
};
var initKW = {
  min: '',
  max: ''
};
var PowerFilter = function PowerFilter(_ref) {
  var criteria = _ref.criteria,
    criteriaAdd = _ref.criteriaAdd,
    criteriaUpdate = _ref.criteriaUpdate,
    criteriaDelete = _ref.criteriaDelete,
    hasCriteria = _ref.hasCriteria;
  var _useState = useState(labels.PK),
    activeOption = _useState[0],
    setActiveOption = _useState[1];
  var _useState2 = useState(initPK),
    pk = _useState2[0],
    setPk = _useState2[1];
  var _useState3 = useState(initKW),
    kw = _useState3[0],
    setKw = _useState3[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    var pkFilters = head(filter(criteria, function (f) {
      return f.type === SearchAgentCriteriaTypes.pk;
    }));
    var kwFilters = head(filter(criteria, function (f) {
      return f.type === SearchAgentCriteriaTypes.kw;
    }));
    if (pkFilters) {
      setPk({
        min: pkFilters.value[0],
        max: pkFilters.value[1]
      });
    }
    if (kwFilters) {
      setKw({
        min: kwFilters.value[0],
        max: kwFilters.value[1]
      });
    }
  }, []);
  var powerOptions = [{
    value: labels.PK,
    label: t('hp')
  }, {
    value: labels.KW,
    label: t('kW')
  }];
  var onPkChange = function onPkChange() {
    if (pk.min !== '' || pk.max !== '') {
      var value = [pk.min, pk.max];
      if (hasCriteria(criteria, SearchAgentCriteriaTypes.pk)) {
        criteriaUpdate(SearchAgentCriteriaTypes.pk, value);
      } else {
        criteriaAdd(SearchAgentCriteriaTypes.pk, value);
      }
    } else {
      criteriaDelete(SearchAgentCriteriaTypes.pk);
    }
  };
  var onKwChange = function onKwChange() {
    if (kw.min !== '' || kw.max !== '') {
      var value = [kw.min, kw.max];
      if (hasCriteria(criteria, SearchAgentCriteriaTypes.kw)) {
        criteriaUpdate(SearchAgentCriteriaTypes.kw, value);
      } else {
        criteriaAdd(SearchAgentCriteriaTypes.kw, value);
      }
    } else {
      criteriaDelete(FilterTypes.kw);
    }
  };
  var renderPK = function renderPK() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
      className: "w-1/2 filter-input border border-primary text-14 font-secondary text-primary rounded-l-10 focus:outline-none",
      value: pk.min,
      style: {
        maxHeight: 46
      },
      placeholder: t('From'),
      onChange: function onChange(e) {
        return setPk(_extends({}, pk, {
          min: e.target.value
        }));
      },
      onBlur: function onBlur() {
        return onPkChange();
      }
    }), /*#__PURE__*/React.createElement("input", {
      className: "w-1/2 filter-input border-t border-b border-r border-primary text-14 font-secondary text-primary rounded-r-10 focus:outline-none",
      value: pk.max,
      style: {
        maxHeight: 46
      },
      placeholder: t('To'),
      onChange: function onChange(e) {
        return setPk(_extends({}, pk, {
          max: e.target.value
        }));
      },
      onBlur: function onBlur() {
        return onPkChange();
      }
    }));
  };
  var renderKW = function renderKW() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
      className: "w-1/2 filter-input border border-primary text-14 font-secondary text-primary rounded-l-10 focus:outline-none",
      value: kw.min,
      style: {
        maxHeight: 46
      },
      placeholder: t('From'),
      onChange: function onChange(e) {
        return setKw(_extends({}, kw, {
          min: e.target.value
        }));
      },
      onBlur: function onBlur() {
        return onKwChange();
      }
    }), /*#__PURE__*/React.createElement("input", {
      className: "w-1/2 filter-input border-t border-b border-r border-primary text-14 font-secondary text-primary rounded-r-10 focus:outline-none",
      value: kw.max,
      style: {
        maxHeight: 46
      },
      placeholder: t('To'),
      onChange: function onChange(e) {
        return setKw(_extends({}, kw, {
          max: e.target.value
        }));
      },
      onBlur: function onBlur() {
        return onKwChange();
      }
    }));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-secondary font-semibold text-primary mb-2 mt-5"
  }, t('Power')), /*#__PURE__*/React.createElement("div", {
    className: "flex font-secondary text-14"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-2/5 mr-2"
  }, /*#__PURE__*/React.createElement(SelectBox, {
    value: find(powerOptions, function (i) {
      return i.value === activeOption;
    }),
    options: powerOptions,
    className: "focus:outline-none",
    isLoading: false,
    onChange: function onChange(option) {
      return setActiveOption(option.value);
    }
  })), /*#__PURE__*/React.createElement(Fade, {
    spy: activeOption
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-3/5 w-full flex"
  }, activeOption === labels.PK && renderPK(), activeOption === labels.KW && renderKW()))));
};
var PowerFilter$1 = baseSearchAgentCriteria(PowerFilter);

var WishesTextArea = function WishesTextArea(_ref) {
  var value = _ref.value,
    fieldUpdate = _ref.fieldUpdate;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(TextAreaField, {
    containerClass: "appearance-none block w-full focus:outline-none focus:border-gray-300 rounded-10",
    heightClass: "h-30",
    placeholder: t('Special wishes'),
    value: value.wishes,
    onChange: function onChange(value) {
      return fieldUpdate('wishes', value);
    },
    required: false
  });
};
var WishesTextArea$1 = baseSearchAgentField(WishesTextArea);

var keys = {
  basic: 'basic',
  equipments: 'equipments',
  exterior: 'exterior',
  upholstery: 'upholstery',
  environment: 'environment',
  extra: 'extra'
};
var searchAgentCategories = [{
  key: keys.basic,
  translation: function translation(t) {
    return t('Basic specifications');
  },
  priority: 1
}, {
  key: keys.equipments,
  translation: function translation(t) {
    return t('Equipment');
  },
  priority: 2
}, {
  key: keys.exterior,
  translation: function translation(t) {
    return t('Exterior');
  },
  priority: 3
}, {
  key: keys.upholstery,
  translation: function translation(t) {
    return t('Interior');
  },
  priority: 4
}, {
  key: keys.environment,
  translation: function translation(t) {
    return t('Milieu');
  },
  priority: 5
}, {
  key: keys.extra,
  translation: function translation(t) {
    return t('Do you have any special wishes or comments?');
  },
  priority: 6
}];
var SearchAgentCriteria = function SearchAgentCriteria(_ref) {
  var context = _ref.context;
  var _useState = useState(keys.basic),
    activeCategory = _useState[0],
    setActiveCategory = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    var element = document.getElementById(activeCategory);
    if (element) {
      var headerOffset = 71;
      var bodyRect = document.body.getBoundingClientRect().top;
      var elementRect = element.getBoundingClientRect().top;
      var elementPosition = elementRect - bodyRect;
      var offsetPosition = elementPosition - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'instant'
      });
    }
  }, [activeCategory]);
  var renderContent = function renderContent(key) {
    switch (key) {
      case keys.basic:
        return /*#__PURE__*/React.createElement("div", {
          className: "px-5 mb-5"
        }, /*#__PURE__*/React.createElement("div", {
          className: "grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-4 mb-2"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(MakesFilter$1, {
          context: context
        })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ModelsFilter$1, {
          context: context
        }))), /*#__PURE__*/React.createElement("div", {
          className: "mb-0 md:mb-2 mt-5 md:mt-0"
        }, /*#__PURE__*/React.createElement(BodyFilter, {
          context: context
        })), /*#__PURE__*/React.createElement("div", {
          className: "grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-4 mb-2"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FuelFilter$1, {
          context: context
        })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(GearboxFilter$1, {
          context: context
        }))), /*#__PURE__*/React.createElement("div", {
          className: "md:w-1/2 pr-6"
        }, /*#__PURE__*/React.createElement(PriceFilter$1, {
          context: context
        })), /*#__PURE__*/React.createElement("div", {
          className: "grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-4 mb-0 md:mb-2"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(YearFilter$1, {
          context: context
        })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(MileageFilter$1, {
          context: context
        }))), /*#__PURE__*/React.createElement("div", {
          className: "grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-4 mb-2"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PowerFilter$1, {
          context: context
        })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DoorsFilter$1, {
          context: context
        }))), /*#__PURE__*/React.createElement("div", {
          className: "grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-4 mb-2"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CategoryFilter$1, {
          context: context
        })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(VatFilter$1, {
          context: context
        }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SeatFilter, {
          context: context
        })));
      case keys.equipments:
        return /*#__PURE__*/React.createElement("div", {
          className: "p-5"
        }, /*#__PURE__*/React.createElement(EquipmentFilter$1, {
          context: context
        }));
      case keys.exterior:
        return /*#__PURE__*/React.createElement("div", {
          className: "p-5"
        }, /*#__PURE__*/React.createElement(ExteriorColorFilter$1, {
          context: context
        }));
      case keys.upholstery:
        return /*#__PURE__*/React.createElement("div", {
          className: "p-5"
        }, /*#__PURE__*/React.createElement(InteriorColorFilter$1, {
          context: context
        }), /*#__PURE__*/React.createElement(InteriorUpholsteryFilter, {
          context: context
        }));
      case keys.environment:
        return /*#__PURE__*/React.createElement("div", {
          className: "px-5 mb-5"
        }, /*#__PURE__*/React.createElement("div", {
          className: "grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-4 mb-2"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(EuroNormFilter$1, {
          context: context
        })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CO2Filter$1, {
          context: context
        }))));
      case keys.extra:
        return /*#__PURE__*/React.createElement("div", {
          className: "p-5"
        }, /*#__PURE__*/React.createElement(WishesTextArea$1, null));
      default:
        return /*#__PURE__*/React.createElement("div", null);
    }
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "rounded-10 border border-secondary-lightest relative "
  }, map(orderBy(searchAgentCategories, ['priority']), function (searchAgentCategory, i) {
    var isFirst = i === 0;
    var isLast = searchAgentCategories.length - 1 === i;
    var isActive = searchAgentCategory.key === activeCategory;
    return /*#__PURE__*/React.createElement("div", {
      key: "filter-category-" + i,
      id: searchAgentCategory.key,
      className: "border-secondary-eight text-white " + (isLast ? '' : 'border-b')
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between cursor-pointer p-5 bg-secondary-one text-white " + (isFirst && 'rounded-t-10') + " " + (isLast && !isActive && 'rounded-b-10'),
      onClick: function onClick() {
        return setActiveCategory(searchAgentCategory.key !== activeCategory ? searchAgentCategory.key : '');
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "font-secondary font-semibold"
    }, searchAgentCategory.translation(t)), /*#__PURE__*/React.createElement("i", {
      className: "fal " + (searchAgentCategory.key === activeCategory ? 'fa-angle-up' : 'fa-angle-down') + " text-white",
      style: {
        marginTop: 2
      }
    })), isActive && renderContent(searchAgentCategory.key));
  })));
};

var SearchAgentTopBar = function SearchAgentTopBar(_ref) {
  var criteria = _ref.criteria,
    criteriaDelete = _ref.criteriaDelete;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if ((criteria === null || criteria === void 0 ? void 0 : criteria.length) === 0) return /*#__PURE__*/React.createElement("div", null);
  return /*#__PURE__*/React.createElement(Sticky, {
    top: getStickiesOffset('sticky-header'),
    activeClass: "w-full",
    innerZ: 50
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 overflow-x-auto md:overflow-auto bg-white py-3 md:py-5"
  }, criteria.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-primary font-semibold mr-2 mb-2 hidden md:block whitespace-nowrap",
    style: {
      width: 110,
      minWidth: 110
    }
  }, t('Selected filters'), ":"), /*#__PURE__*/React.createElement("div", {
    className: "flex px-5 md:px-0",
    style: {
      width: 'max-content'
    }
  }, map(filter(criteria, function (c) {
    return c.type !== FilterTypes.segment;
  }), function (c, index) {
    var isLast = criteria.length - 1 === index;
    return /*#__PURE__*/React.createElement("div", {
      key: "filter.type" + index,
      className: "flex flex-row bg-secondary-four rounded-4 px-5 py-2 mb-0 md:mb-2 " + (isLast ? '' : ' mr-2')
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-secondary-five",
      style: {
        width: 'max-content'
      }
    }, c.label), /*#__PURE__*/React.createElement("div", {
      className: "cursor-pointer ml-2 md:ml-4 hover:text-primary hover:spin-animation",
      onClick: function onClick() {
        return criteriaDelete(c);
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "fal fa-trash-alt font-normal"
    }))));
  })))));
};
var SearchAgentTopBar$1 = baseSearchAgentTopBar(SearchAgentTopBar);

var SearchAgentUserForm = function SearchAgentUserForm(_ref) {
  var value = _ref.value,
    userFieldUpdate = _ref.userFieldUpdate,
    fieldUpdate = _ref.fieldUpdate,
    submit = _ref.submit,
    submitSuccess = _ref.submitSuccess,
    submitError = _ref.submitError,
    onPrevious = _ref.onPrevious,
    context = _ref.context;
  var _useState = useState(undefined),
    errors = _useState[0],
    setErrors = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var validate = function validate() {
    var errors = {};
    if (!hasValue(value.user.email)) {
      errors['email'] = t('Please fill in your e-mail address.');
    } else if (!isValidEmail(value.user.email)) {
      errors['email'] = t('Invalid email address');
    }
    if (!hasValue(value.user.firstName)) {
      errors['firstName'] = t('Please fill in your first name.');
    }
    if (!hasValue(value.user.lastName)) {
      errors['lastName'] = t('Please fill in your first name.');
    }
    if (!hasValue(value.user.telephone)) {
      errors['telephone'] = t('Please fill in your telephone number.');
    }
    if (!hasValue(value.user.privacy)) {
      errors['privacy'] = t('Please accept the privacy terms.');
    }
    if (value.criteria.length < 1) {
      errors['criteria'] = t('Please choose at least one criteria.');
    }
    setErrors(errors);
    return keys$2(errors).length <= 0;
  };
  var handleSubmit = function handleSubmit() {
    if (validate()) {
      submit(value);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: ""
  }, submitSuccess && /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement(SuccessIndicator, {
    success: t('Your request has been sent!')
  })), submitError && /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement(ErrorIndicator, {
    error: t('Your request has NOT been sent!')
  })), /*#__PURE__*/React.createElement("div", {
    className: "rounded-10 border border-secondary-lightest p-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4 mb-5"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "appearance-none block w-full focus:outline-none focus:border-gray-300 rounded mb-2 md:mb-0",
    label: t('First name'),
    placeholder: t('First name'),
    value: value.user.firstName,
    onChange: function onChange(value) {
      return userFieldUpdate('firstName', value);
    },
    errorText: errors && errors['firstName'] ? errors['firstName'] : undefined,
    required: true
  }), /*#__PURE__*/React.createElement(InputField, {
    containerClass: "appearance-none block w-full focus:outline-none focus:border-gray-300 rounded",
    label: t('Last name'),
    placeholder: t('Last name'),
    value: value.user.lastName,
    onChange: function onChange(value) {
      return userFieldUpdate('lastName', value);
    },
    errorText: errors && errors['lastName'] ? errors['lastName'] : undefined,
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4 mb-5"
  }, /*#__PURE__*/React.createElement(InputField, {
    containerClass: "appearance-none block w-full focus:outline-none focus:border-gray-300 rounded mb-2 md:mb-0",
    label: t('Email'),
    placeholder: t('Email'),
    value: value.user.email,
    onChange: function onChange(value) {
      return userFieldUpdate('email', value);
    },
    errorText: errors && errors['email'] ? errors['email'] : undefined,
    required: true
  }), /*#__PURE__*/React.createElement(InputField, {
    containerClass: "appearance-none block w-full focus:outline-none focus:border-gray-300 rounded",
    label: t('Telephone'),
    placeholder: t('Telephone'),
    value: value.user.telephone,
    onChange: function onChange(value) {
      return userFieldUpdate('telephone', value);
    },
    errorText: errors && errors['telephone'] ? errors['telephone'] : undefined,
    required: true
  })), /*#__PURE__*/React.createElement(TextAreaField, {
    containerClass: "appearance-none block w-full focus:outline-none focus:border-gray-300 rounded",
    heightClass: "h-30",
    label: t('Any comments'),
    placeholder: t('Comments'),
    value: value.notes,
    onChange: function onChange(value) {
      return fieldUpdate('notes', value);
    },
    required: false
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex my-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-primary font-secondary  " + (errors && errors['privacy'] !== undefined ? 'text-red-400' : '')
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: value.user.privacy,
    onChange: function onChange(e) {
      return userFieldUpdate('privacy', e.target.checked);
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "mr-1 ml-2 " + (errors && errors['privacy'] !== undefined ? 'text-red-400' : '')
  }, t('I agree to the'), " "), /*#__PURE__*/React.createElement("span", {
    className: "underline cursor-pointer " + (errors && errors['privacy'] !== undefined ? 'text-red-400' : ''),
    onClick: function onClick() {
      return navigateInternalPage(context, context.defaultPageNames.privacy);
    }
  }, t('privacy terms')), ".")), errors && errors['criteria'] && /*#__PURE__*/React.createElement("div", {
    className: "flex md:hidden flex-1 items-center justify-center px-5 text-red-400 mt-5"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-exclamation-triangle mr-2"
  }), " ", errors['criteria']), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between w-full mt-5"
  }, /*#__PURE__*/React.createElement("button", {
    className: "button draw-border",
    onClick: onPrevious
  }, t('Modify filters')), errors && errors['criteria'] && /*#__PURE__*/React.createElement("div", {
    className: "hidden md:flex flex-1 items-center justify-end px-5 text-red-400"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-exclamation-triangle mr-2"
  }), " ", errors['criteria']), /*#__PURE__*/React.createElement("button", {
    className: "primary-button",
    onClick: handleSubmit
  }, t('Send'))));
};
var SearchAgentUserForm$1 = baseSearchAgentForm(SearchAgentUserForm);

var viewTypes = {
  SearchCriteria: 'SearchCriteria',
  UserInfo: 'UserInfo'
};
var SearchAgent = function SearchAgent(_ref) {
  var data = _ref.data,
    loading = _ref.loading,
    context = _ref.context;
  var _useState = useState(viewTypes.SearchCriteria),
    currentView = _useState[0],
    setCurrentView = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (loading || !data) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, currentView === viewTypes.SearchCriteria && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchAgentTopBar$1, {
    context: context
  }), /*#__PURE__*/React.createElement(SearchAgentCriteria, {
    context: context
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end w-full mt-5"
  }, /*#__PURE__*/React.createElement("button", {
    className: "primary-button",
    onClick: function onClick() {
      return setCurrentView(viewTypes.UserInfo);
    }
  }, t('Next'), ' '))), currentView === viewTypes.UserInfo && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SearchAgentTopBar$1, {
    context: context
  }), /*#__PURE__*/React.createElement(SearchAgentUserForm$1, {
    context: context,
    onPrevious: function onPrevious() {
      return setCurrentView(viewTypes.SearchCriteria);
    }
  }))));
};
var SearchAgent$1 = baseSearchAgent(SearchAgent);

var VehicleSearchAgent = function VehicleSearchAgent(_ref) {
  var text = _ref.text,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center container mx-auto my-5 md:my-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full xl:w-8/12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-5 xl:mb-12"
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: text,
    context: context
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SearchAgent$1, {
    context: context
  })))));
};
VehicleSearchAgent.defaultProps = {
  text: DefaultText
};
VehicleSearchAgent.human = {
  nl: '',
  fr: '',
  en: ''
};
VehicleSearchAgent.preview = function () {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      height: 100
    }
  }, "Vehicle search agent");
};

var ModelsFilterCheckbox = function ModelsFilterCheckbox(_ref) {
  var filterData = _ref.filterData,
    makeFilterValues = _ref.makeFilterValues,
    modelFilterValues = _ref.modelFilterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    selectedMake = _ref.selectedMake;
  var makes = filterData.makes,
    models = filterData.models;
  var handleFilterChanged = function handleFilterChanged(data) {
    var makeKey = selectedMake.value;
    var modelKey = data.value;
    var value = makeKey + "|" + modelKey;
    if (hasFilterWithValue(value)) {
      filterDelete(value);
      if (filter(makeFilterValues, function (m) {
        return (m === null || m === void 0 ? void 0 : m.toLowerCase()) === (makeKey === null || makeKey === void 0 ? void 0 : makeKey.toLowerCase());
      }).length <= 1) {
        filterAdd(makeKey);
      }
    } else {
      filterAdd(value);
    }
  };
  var availableMakes = makeFilterValues.length > 0 ? filter(makes, function (m) {
    return includes(makeFilterValues, m.key);
  }) : makes;
  var modelsPerMake = filter(models, function (model) {
    return find(availableMakes, function (make) {
      return make.key === model.custom;
    });
  });
  var items = map(filter(modelsPerMake, function (model) {
    return model.custom === (selectedMake === null || selectedMake === void 0 ? void 0 : selectedMake.value);
  }), function (model) {
    return {
      key: model === null || model === void 0 ? void 0 : model.key,
      text: model === null || model === void 0 ? void 0 : model.text
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "text-red-500"
  }, /*#__PURE__*/React.createElement(GenericList, {
    items: items,
    values: map(modelFilterValues, function (modelFilter) {
      return modelFilter.model;
    }),
    containerClass: "",
    handleFilterChanged: handleFilterChanged
  }));
};
var ModelsFilterCheckbox$1 = baseModelFilterForMakeModel(ModelsFilterCheckbox);

var MakeModelFilter = function MakeModelFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    onFilterChange = _ref.onFilterChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-xsmall font-semibold text-primary mb-2 mt-2"
  }, t('Make and model')), /*#__PURE__*/React.createElement(GenericList, {
    items: filterData,
    values: filterValues,
    containerClass: "",
    renderSubFilters: function renderSubFilters(option) {
      return /*#__PURE__*/React.createElement("div", {
        className: "pl-4"
      }, /*#__PURE__*/React.createElement(ModelsFilterCheckbox$1, {
        selectedMake: option
      }));
    },
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
      onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
    }
  }));
};
var MakeModelFilter$1 = baseMakeFilterForMakeModel(MakeModelFilter);

var VehiclesFiltersQuery = "query VehiclesFilter($params: VehiclesFilterParamType!) {\n  vehiclesFilter(params: $params) {\n    makes {\n      key\n      description      \n      seo      \n    }\n    \n    models {\n      key\n      makeKey\n      description                 \n    }\n    \n    fuelTypes {\n      key\n      description            \n    }\n    \n    categories {\n      key\n      description      \n    }\n  }\n  \n  dataSettings {\n    priceMax,\n    priceStep\n    monthlyMax\n    monthlyStep    \n  }\n}";
var Query = "query TotalCountQuery {\n  vehiclesCount \n}";
var initialState = {
  makeModels: [],
  price: undefined,
  monthlyPrice: undefined,
  category: undefined,
  fuels: []
};
var VehicleHomeSearchForm = function VehicleHomeSearchForm(_ref) {
  var _uniq, _uniq2;
  var onSubmit = _ref.onSubmit,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(initialState),
    state = _useState[0],
    setState = _useState[1];
  var _useVehiclesFilterDat = useVehiclesFilterData(VehiclesFiltersQuery, context),
    data = _useVehiclesFilterDat.data,
    fetchVehiclesFilterData = _useVehiclesFilterDat.fetchVehiclesFilterData,
    loading = _useVehiclesFilterDat.loading;
  var _useVehiclesCount = useVehiclesCount(context),
    count = _useVehiclesCount.count,
    countVehicles = _useVehiclesCount.countVehicles;
  var _useQuery = useQuery(context),
    totalCount = _useQuery.data,
    fetchData = _useQuery.fetchData;
  var _useIsMobile = useIsMobile(),
    isMobile = _useIsMobile.isMobile;
  useEffect(function () {
    fetchVehiclesFilterData();
    fetchData(Query, undefined);
  }, []);
  useEffect(function () {
    if (state && state.makeModels !== [] || state && state.fuels !== [] || state.price !== undefined || state.monthlyPrice !== undefined || state.category !== undefined) {
      countVehicles(generateVehicleFilterCountNodeByFormData(context, state));
    }
  }, [state]);
  if (loading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "w-full p-0 md:p-5 home-search-form"
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-full home-search-form"
    }, /*#__PURE__*/React.createElement("div", {
      className: "h-12 w-full animate-pulse bg-gray-200 w-full mb-2 xl:mb-3"
    }), /*#__PURE__*/React.createElement("div", {
      className: "h-12 w-full animate-pulse bg-gray-200 mb-2 xl:mb-3"
    }), /*#__PURE__*/React.createElement("div", {
      className: "h-12 w-full animate-pulse bg-gray-200 mb-4 xl:mb-5"
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex mb-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "h-6 w-20 mr-4 animate-pulse bg-gray-200"
    }), /*#__PURE__*/React.createElement("div", {
      className: "h-6 w-20 animate-pulse bg-gray-200"
    })), /*#__PURE__*/React.createElement("div", {
      className: "h-5 w-full animate-pulse bg-gray-200"
    }), /*#__PURE__*/React.createElement("div", {
      className: "h-6 w-20 animate-pulse bg-gray-200 mt-2"
    }), /*#__PURE__*/React.createElement("div", {
      className: "block bg-secondary-four my-4 md:my-5",
      style: {
        height: 2
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex mb-8 md:mb-4 xl:mb-5"
    }, /*#__PURE__*/React.createElement("div", {
      className: "h-5 w-20 mr-4 animate-pulse bg-gray-200"
    }), /*#__PURE__*/React.createElement("div", {
      className: "h-5 w-20 animate-pulse bg-gray-200"
    })), /*#__PURE__*/React.createElement("div", {
      className: "h-10 w-2/3 animate-pulse bg-gray-200"
    })));
  }
  var setValue = function setValue(key, value) {
    var _extends2;
    setState(_extends({}, state, (_extends2 = {}, _extends2[key] = value, _extends2)));
  };
  var getMake = function getMake(makeModel) {
    return head(makeModel.split('|'));
  };
  var makeOptions = !loading ? map(data.makes, function (make) {
    return {
      value: make.key,
      label: make.text
    };
  }) : [];
  var availableMakesForModels = state.makeModels.length > 0 ? filter(data.makes, function (m) {
    return some(state.makeModels, function (makeModel) {
      return getMake(makeModel) === m.key;
    });
  }) : data.makes;
  var modelsPerMake = map(availableMakesForModels, function (make) {
    return data.models ? {
      key: make.key,
      value: make.key,
      label: make.text,
      options: map(filter(data.models, function (model) {
        return model.custom === make.key;
      }), function (model) {
        return {
          key: model.key,
          value: make.key + '|' + model.key,
          label: model.text
        };
      })
    } : {};
  });
  var fuelOptions = !loading ? data.fuels.map(function (fuel) {
    return {
      value: fuel.key,
      label: fuel.text
    };
  }) : [];
  var prices = !loading ? {
    min: 0,
    max: data.dataSettings ? data.dataSettings.priceMax : 0,
    step: data.dataSettings ? data.dataSettings.priceStep : 0
  } : [];
  var monthlyPrices = !loading ? {
    min: 0,
    max: data.dataSettings ? data.dataSettings.monthlyMax : 0,
    step: data.dataSettings ? data.dataSettings.monthlyStep : 0
  } : [];
  var sliderValues = {
    price: state.price ? state.price : undefined,
    monthly: state.monthlyPrice ? state.monthlyPrice : undefined
  };
  var handleMakeClick = function handleMakeClick(make) {
    var exists = find(state.makeModels, function (m) {
      return getMake(m) === make;
    });
    if (exists) {
      setValue('makeModels', filter(state.makeModels, function (m) {
        return getMake(m) !== make;
      }));
    } else {
      setValue('makeModels', [].concat(state.makeModels, [make]));
    }
  };
  var handleModelClick = function handleModelClick(makeModel) {
    var make = getMake(makeModel);
    var exists = find(state.makeModels, function (m) {
      return m === makeModel;
    });
    var makeModelsUpdated = [];
    if (exists) {
      makeModelsUpdated = [].concat(filter(state.makeModels, function (m) {
        return m !== makeModel;
      }), [make]);
    } else {
      makeModelsUpdated = [].concat(filter(state.makeModels, function (m) {
        return m !== make;
      }), [makeModel]);
    }
    setValue('makeModels', makeModelsUpdated);
  };
  var handleFuelClick = function handleFuelClick(fuel) {
    var exists = find(state.fuels, function (f) {
      return f === fuel;
    });
    if (exists) {
      setValue('fuels', filter(state.fuels, function (f) {
        return f !== fuel;
      }));
    } else {
      setValue('fuels', [].concat(state.fuels, [fuel]));
    }
  };
  var makesLabel = !isEmpty(state.makeModels) ? toString((_uniq = uniq(map(state.makeModels, function (makeModel) {
    return capitalize(head(makeModel.split('|')));
  }))) === null || _uniq === void 0 ? void 0 : _uniq.sort()) : '';
  var fuelLabel = !isEmpty(state.fuels) ? toString((_uniq2 = uniq(map(state.fuels, function (f) {
    return capitalize(f);
  }))) === null || _uniq2 === void 0 ? void 0 : _uniq2.sort()) : '';
  var modelsLabel = '';
  if (!isEmpty(state.makeModels)) {
    var result = [];
    map(state.makeModels, function (makeModel) {
      var spliced = makeModel.split('|');
      if (spliced.length > 1) {
        result.push(capitalize(head(spliced)) + ": " + capitalize(last(spliced)));
      }
    });
    modelsLabel = toString(result);
  }
  var selectedNew = state.category === 'new';
  var selectedUsed = state.category === 'used';
  var counterValue = count && typeof count === 'number' ? count : totalCount ? totalCount.vehiclesCount : undefined;
  var hasResults = counterValue;
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: loading ? undefined : function (e) {
      e.preventDefault();
      onSubmit(state, data);
    },
    className: "w-full p-0 md:p-5 home-search-form",
    style: {
      boxShadow: isMobile ? 'none' : '0px 3px 6px #00000029'
    }
  }, /*#__PURE__*/React.createElement(SelectBox, {
    options: makeOptions,
    placeholder: t('Make'),
    value: makesLabel ? {
      label: makesLabel
    } : '',
    isLoading: loading,
    isDisabled: loading,
    className: "mb-2 xl:mb-3",
    closeMenuOnSelect: false,
    customComponents: {
      Option: function Option(_ref2) {
        var innerProps = _ref2.innerProps,
          isDisabled = _ref2.isDisabled,
          data = _ref2.data;
        var isSelected = find(state.makeModels, function (makeModel) {
          return getMake(makeModel) === data.value;
        });
        return !isDisabled ? /*#__PURE__*/React.createElement("div", innerProps, /*#__PURE__*/React.createElement("div", {
          className: "flex flex-row py-1 px-3 cursor-pointer hover:text-primary hover:font-semibold",
          onClick: function onClick() {
            return handleMakeClick(data.value);
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex items-center"
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex items-center justify-center rounded border mr-2 w-4 h-4 " + (isSelected ? 'bg-secondary-one border-secondary-one' : 'bg-white border-primary')
        }, isSelected && /*#__PURE__*/React.createElement("i", {
          className: "far fa-check text-white text-10",
          style: {
            marginTop: 2
          }
        }))), /*#__PURE__*/React.createElement("div", {
          className: "flex flex-1 paragraph-small " + (isSelected ? 'font-semibold' : '')
        }, /*#__PURE__*/React.createElement("div", {
          className: "capitalize"
        }, data.label)))) : null;
      }
    }
  }), /*#__PURE__*/React.createElement(SelectBox, {
    value: modelsLabel ? {
      label: modelsLabel
    } : '',
    options: modelsPerMake,
    isLoading: loading,
    isDisabled: isEmpty(state.makeModels) || loading,
    placeholder: t('Model'),
    className: "mb-2 xl:mb-3",
    closeMenuOnSelect: false,
    customComponents: {
      Option: function Option(_ref3) {
        var innerProps = _ref3.innerProps,
          isDisabled = _ref3.isDisabled,
          data = _ref3.data;
        var isSelected = find(state.makeModels, function (makeModel) {
          return makeModel === data.value;
        });
        return !isDisabled ? /*#__PURE__*/React.createElement("div", innerProps, /*#__PURE__*/React.createElement("div", {
          className: "flex flex-row py-1 cursor-pointer pl-5 text-primary hover:font-semibold",
          onClick: function onClick() {
            return handleModelClick(data.value);
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex items-center"
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex items-center justify-center rounded border mr-2 w-4 h-4 " + (isSelected ? 'bg-secondary-one border-secondary-one' : 'bg-white border-primary')
        }, isSelected && /*#__PURE__*/React.createElement("i", {
          className: "far fa-check text-white text-10",
          style: {
            marginTop: 2
          }
        }))), /*#__PURE__*/React.createElement("div", {
          className: "flex flex-1 paragraph-small " + (isSelected ? 'font-semibold' : '')
        }, /*#__PURE__*/React.createElement("div", {
          className: "capitalize"
        }, data.label)))) : null;
      }
    }
  }), /*#__PURE__*/React.createElement(SelectBox, {
    value: fuelLabel ? {
      label: fuelLabel
    } : '',
    options: fuelOptions,
    placeholder: t('Fuel type'),
    isLoading: loading,
    isDisabled: loading,
    className: "mb-4 xl:mb-5",
    closeMenuOnSelect: false,
    customComponents: {
      Option: function Option(_ref4) {
        var innerProps = _ref4.innerProps,
          isDisabled = _ref4.isDisabled,
          data = _ref4.data;
        var isSelected = find(state.fuels, function (f) {
          return f === data.value;
        });
        return !isDisabled ? /*#__PURE__*/React.createElement("div", innerProps, /*#__PURE__*/React.createElement("div", {
          className: "flex flex-row py-1 px-3 cursor-pointer hover:text-primary hover:font-semibold",
          onClick: function onClick() {
            return handleFuelClick(data.value);
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex items-center"
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex items-center justify-center rounded border mr-2 w-4 h-4 " + (isSelected ? 'bg-secondary-one border-secondary-one' : 'bg-white border-primary')
        }, isSelected && /*#__PURE__*/React.createElement("i", {
          className: "far fa-check text-white text-10",
          style: {
            marginTop: 2
          }
        }))), /*#__PURE__*/React.createElement("div", {
          className: "flex flex-1 paragraph-small " + (isSelected ? 'font-semibold' : '')
        }, /*#__PURE__*/React.createElement("div", {
          className: "capitalize"
        }, data.label)))) : null;
      }
    }
  }), /*#__PURE__*/React.createElement(PriceSlider, {
    className: 'px-4',
    values: sliderValues,
    prices: prices,
    monthlyPrices: monthlyPrices,
    onChange: function onChange(values) {
      if (values.price) {
        if (values.price[1] !== prices.max) {
          setValue('price', values.price);
        } else {
          setValue('price', undefined);
        }
      }
      if (values.monthly) {
        if (values.monthly[1] !== monthlyPrices.max) {
          setValue('monthlyPrice', values.monthly);
        } else {
          setValue('monthlyPrice', undefined);
        }
      }
    },
    loading: loading,
    radioButtonSize: 16,
    title: false
  }), /*#__PURE__*/React.createElement("div", {
    className: "block bg-secondary-four my-4 md:my-5",
    style: {
      height: 2
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "px-4 flex mb-8 md:mb-4 xl:mb-5 font-secondary font-normal mt-4 xl:mt-5"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: selectedNew,
    label: t('New'),
    onClick: function onClick(value) {
      if (state.category === 'new') {
        setValue('category', undefined);
      } else {
        setValue('category', 'new');
      }
    }
  }), /*#__PURE__*/React.createElement(Checkbox, {
    checked: selectedUsed,
    label: t('Used'),
    onClick: function onClick(value) {
      if (state.category === 'used') {
        setValue('category', undefined);
      } else {
        setValue('category', 'used');
      }
    }
  })), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "primary-button ml-4 " + (loading ? 'opacity-50 cursor-default' : '')
  }, hasResults ? t('Search the') + " " + counterValue + " " + t('vehicles') : t('Search the') + " " + t('vehicles')));
};

var bodyFiltersData = [{
  key: 'berline',
  translation: function translation(t) {
    return t('Berline');
  },
  value: "sedans",
  priority: 1
}, {
  key: 'break',
  translation: function translation(t) {
    return t('Break');
  },
  value: "station_wagon",
  priority: 2
}, {
  key: 'convertible',
  translation: function translation(t) {
    return t('Convertible');
  },
  value: "convertible",
  priority: 3
}, {
  key: 'monovolume',
  translation: function translation(t) {
    return t('Monovolume');
  },
  value: "van",
  priority: 4
}, {
  key: 'compact',
  translation: function translation(t) {
    return t('Stadswagen');
  },
  value: "compact",
  priority: 5
}, {
  key: 'suv',
  translation: function translation(t) {
    return t('SUV');
  },
  value: "off-road/pick-up",
  priority: 6
}];
var VehicleHomeBodySearch = function VehicleHomeBodySearch(_ref) {
  var context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var resolveBodyUrl = function resolveBodyUrl(body) {
    var item = find(context.vehicleSearchFilters, function (f) {
      return f.type === 'category' && f.name === body;
    });
    return item === null || item === void 0 ? void 0 : item.url;
  };
  var renderMobile = function renderMobile() {
    var orderedFilters = orderBy(bodyFiltersData, ['priority']);
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center px-5 bg-secondary-one overflow-x-auto",
      style: {
        height: 140
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-nowrap",
      style: {
        width: 'min-content'
      }
    }, map(orderedFilters, function (filter, i) {
      var isLast = orderedFilters.length - 1 === i;
      return /*#__PURE__*/React.createElement(InternalLink, {
        url: resolveBodyUrl(filter.key),
        context: context,
        key: "BodyType" + i,
        style: {
          width: 107,
          height: 93,
          borderRadius: 4
        },
        className: "flex cursor-pointer items-center justify-center bg-secondary-three text-white p-3 flex-col " + (isLast ? 'mr-5' : 'mr-2')
      }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", {
        className: "icon-" + filter.key,
        style: {
          fontSize: 35
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "text-12 truncate font-primary mt-2"
      }, filter.translation(t))));
    })));
  };
  var renderDesktop = function renderDesktop() {
    return /*#__PURE__*/React.createElement("div", {
      className: "bg-white z-10"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center justify-between container mx-auto",
      style: {
        height: 110
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex grid grid-cols-6 md:pr-5 xl:pr-20",
      style: {
        width: 'calc(100% - 350px)'
      }
    }, map(orderBy(bodyFiltersData, ['priority']), function (filter, i) {
      return /*#__PURE__*/React.createElement(InternalLink, {
        url: resolveBodyUrl(filter.key),
        context: context,
        key: "BodyType" + i,
        className: "text-secondary-three hover:text-secondary-one flex flex-col items-center justify-center cursor-pointer outline-none"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col justify-center items-center"
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon-" + filter.key,
        style: {
          fontSize: 29
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "hidden xl:block mt-3 truncate leading-24 font-primary w-full text-center"
      }, filter.translation(t))));
    }))));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "block md:hidden"
  }, renderMobile()), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block"
  }, renderDesktop()));
};

var VehicleSearchMultiImageText = function VehicleSearchMultiImageText(_ref) {
  var text = _ref.text,
    images = _ref.images,
    context = _ref.context;
  var _useVehiclesCount = useVehiclesCount(context),
    count = _useVehiclesCount.count,
    countVehicles = _useVehiclesCount.countVehicles;
  var _useState = useState(0),
    currentBackgroundIndex = _useState[0],
    setCurrentBackgroundIndex = _useState[1];
  var _useIsMobile = useIsMobile(),
    isMobile = _useIsMobile.isMobile;
  var handleSubmit = function handleSubmit(data, filterData) {
    var filtersUrl = generateUrlParametersByFormDataV2({
      makeModels: data === null || data === void 0 ? void 0 : data.makeModels,
      categories: data !== null && data !== void 0 && data.category ? [data.category] : '',
      fuels: data !== null && data !== void 0 && data.fuels ? data.fuels : '',
      price: data !== null && data !== void 0 && data.price ? data.price : '',
      monthlyPrice: data !== null && data !== void 0 && data.monthlyPrice ? data.monthlyPrice : ''
    }, filterData, context);
    navigateInternalPage(context, context.defaultPageNames.vehicles, filtersUrl);
  };
  useEffect(function () {
    countVehicles();
  }, []);
  var changeDuration = 10;
  useEffect(function () {
    if (images.length > 0) {
      var interval = setInterval(function () {
        var max = images.length - 1;
        if (currentBackgroundIndex === max) {
          setCurrentBackgroundIndex(0);
        } else {
          setCurrentBackgroundIndex(currentBackgroundIndex + 1);
        }
      }, changeDuration * 1000);
      return function () {
        return clearInterval(interval);
      };
    }
  }, [currentBackgroundIndex]);
  var currentImage = images[currentBackgroundIndex];
  var background = images.length > 0 ? {
    backgroundImage: "url(" + (currentImage === null || currentImage === void 0 ? void 0 : currentImage.desktop) + ")",
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover'
  } : {};
  if (isMobile) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "w-full"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center text-white text-center relative",
      style: _extends({}, background, {
        height: 200
      }),
      onClick: function onClick() {
        navigateInternalPage(context, context.defaultPageNames.vehicles, 'label=top_deal');
      }
    }, count && count > 0 && /*#__PURE__*/React.createElement(MarkupText, {
      text: text,
      context: context,
      data: {
        vehicle_count: count
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "mx-5 mb-10 mt-0 sm:mt-10 p-5 bg-white rounded-4 shadow"
    }, /*#__PURE__*/React.createElement(VehicleHomeSearchForm, {
      onSubmit: handleSubmit,
      context: context
    })), /*#__PURE__*/React.createElement(VehicleHomeBodySearch, {
      context: context
    })));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full relative cursor-pointer",
    role: "img",
    "aria-label": currentImage === null || currentImage === void 0 ? void 0 : currentImage.alt,
    title: currentImage === null || currentImage === void 0 ? void 0 : currentImage.alt,
    style: _extends({}, background, {
      height: 570
    }),
    onClick: function onClick() {
      if (location) {
        location.href = 'https://www.topmotors.be/zorgeloze-mobiliteit';
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "z-50",
    style: {
      height: 570
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex container mx-auto h-full md:px-5 xl:px-20"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center flex-1 pr-12"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 700
    }
  }, count && count > 0 && /*#__PURE__*/React.createElement(MarkupText, {
    text: text,
    context: context,
    data: {
      vehicle_count: count
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-end justify-end z-20",
    style: {
      minWidth: 350,
      marginBottom: -105
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center bg-white relative rounded-10 cursor-default",
    style: {
      minWidth: 350,
      minHeight: 200
    },
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, ' ', /*#__PURE__*/React.createElement(VehicleHomeSearchForm, {
    onSubmit: handleSubmit,
    context: context
  })))))), /*#__PURE__*/React.createElement(VehicleHomeBodySearch, {
    context: context
  }));
};
VehicleSearchMultiImageText.human = {
  nl: 'Vehicle search multi image text NL',
  fr: 'Vehicle search multi image text FR',
  en: 'Vehicle search multi image text EN'
};
VehicleSearchMultiImageText.defaultProps = {
  images: [],
  text: DefaultText
};
VehicleSearchMultiImageText.preview = function () {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      height: 100
    }
  }, "Vehicle Search MULTI image and text");
};

var VehiclesFiltersQuery$1 = "query VehiclesFilter($params: VehiclesFilterParamType!) {\n  vehiclesFilter(params: $params) {\n    bodyTypes {\n      key\n      description      \n    }\n  }\n}";
var DEFAULT_HEIGHT = 570;
var MAX_MOBILE_HEIGHT = 350;
var DEFAULT_MOBILE_HEIGHT = 230;
var VehicleSearchMultiVideoText = function VehicleSearchMultiVideoText(_ref) {
  var text = _ref.text,
    videos = _ref.videos,
    context = _ref.context;
  var _useState = useState(DEFAULT_HEIGHT),
    wrapperHeight = _useState[0],
    setWrapperHeight = _useState[1];
  var _useState2 = useState(DEFAULT_HEIGHT),
    wrapperMaxHeight = _useState2[0],
    setWrapperMaxHeight = _useState2[1];
  var _useState3 = useState(0),
    frameTopOffset = _useState3[0],
    setFrameTopOffset = _useState3[1];
  var _useState4 = useState(DEFAULT_MOBILE_HEIGHT),
    mobileWrapperHeight = _useState4[0],
    setMobileWrapperHeight = _useState4[1];
  var _useVehiclesCount = useVehiclesCount(context),
    count = _useVehiclesCount.count,
    countVehicles = _useVehiclesCount.countVehicles;
  var _useVehiclesFilterDat = useVehiclesFilterData(VehiclesFiltersQuery$1, context),
    fetchVehiclesFilterData = _useVehiclesFilterDat.fetchVehiclesFilterData;
  var _useIsMobile = useIsMobile(),
    isMobile = _useIsMobile.isMobile;
  var handleSubmit = function handleSubmit(data, filterData) {
    var filtersUrl = generateUrlParametersByFormDataV2({
      makeModels: data === null || data === void 0 ? void 0 : data.makeModels,
      categories: data !== null && data !== void 0 && data.category ? [data.category] : '',
      fuels: data !== null && data !== void 0 && data.fuels ? data.fuels : '',
      price: data !== null && data !== void 0 && data.price ? data.price : '',
      monthlyPrice: data !== null && data !== void 0 && data.monthlyPrice ? data.monthlyPrice : ''
    }, filterData, context);
    navigateInternalPage(context, context.defaultPageNames.vehicles, filtersUrl);
  };
  useEffect(function () {
    fetchVehiclesFilterData();
    countVehicles();
  }, []);
  useEffect(function () {
    saveMaxWrapperHeight();
  }, []);
  var saveMaxWrapperHeight = function saveMaxWrapperHeight() {
    var maxHeight;
    if (hasWindow()) {
      maxHeight = window.innerHeight - getStickiesOffset();
      if (hasDocument()) {
        var bodyWrapperEl = document.getElementById('body-icons-wrapper');
        maxHeight = maxHeight - (bodyWrapperEl === null || bodyWrapperEl === void 0 ? void 0 : bodyWrapperEl.clientHeight);
      }
      setWrapperMaxHeight(maxHeight);
    }
  };
  var saveWrapperHeight = function saveWrapperHeight(height) {
    if (height) {
      var frameOffsetTop = height > wrapperMaxHeight ? (height - wrapperMaxHeight) / 2 : 0;
      setFrameTopOffset(frameOffsetTop);
      if (height > wrapperMaxHeight) {
        height = wrapperMaxHeight;
      }
      setWrapperHeight(height);
    }
  };
  var saveMobileWrapperHeight = function saveMobileWrapperHeight(height) {
    if (height) {
      if (height > MAX_MOBILE_HEIGHT) {
        height = MAX_MOBILE_HEIGHT;
      }
      setMobileWrapperHeight(height);
    }
  };
  useEffect(function () {
    var resize = function resize() {
      if (!isMobile) {
        var el = document.getElementById('desktop-iframe');
        saveWrapperHeight(el === null || el === void 0 ? void 0 : el.clientHeight);
        saveMaxWrapperHeight();
      }
    };
    window.addEventListener('resize', resize);
    return function () {
      window.removeEventListener('resize', resize);
    };
  });
  var video = videos && head(videos);
  if (isMobile) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "w-full"
    }, /*#__PURE__*/React.createElement("div", {
      className: "home-video flex items-center justify-center text-white text-center relative",
      style: {
        height: mobileWrapperHeight
      }
    }, /*#__PURE__*/React.createElement(MarkupText, {
      text: text,
      context: context,
      data: {
        vehicle_count: count
      }
    }), video && /*#__PURE__*/React.createElement("div", {
      className: "absolute right-0 left-0 top-0 bottom-0 flex items-center",
      style: {
        zIndex: -1
      }
    }, /*#__PURE__*/React.createElement("iframe", {
      src: "" + video,
      id: "mobile-iframe",
      loading: "lazy",
      onLoad: function onLoad(e) {
        saveMobileWrapperHeight(e.target.clientHeight);
      },
      className: "border-0 absolute inset-0 w-full h-full",
      allow: "accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;",
      allowFullScreen: "true"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "mx-5 mb-10 mt-5 border border-gray-200 md:border-0 md:border-transparent sm:mt-10 p-5 bg-white rounded-4 shadow"
    }, /*#__PURE__*/React.createElement(VehicleHomeSearchForm, {
      onSubmit: handleSubmit,
      context: context
    })), /*#__PURE__*/React.createElement(VehicleHomeBodySearch, {
      context: context
    })));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full relative",
    style: {
      height: wrapperHeight
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "z-50",
    style: {
      height: wrapperHeight
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex container mx-auto h-full md:px-5 xl:px-20"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center flex-1 pr-12"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 700
    }
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: text,
    context: context,
    data: {
      vehicle_count: count
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-end justify-end z-20",
    style: {
      minWidth: 350,
      marginBottom: -105
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center bg-white relative rounded-10",
    style: {
      minWidth: 350,
      minHeight: 200
    }
  }, /*#__PURE__*/React.createElement(VehicleHomeSearchForm, {
    onSubmit: handleSubmit,
    context: context
  }))))), video && /*#__PURE__*/React.createElement("div", {
    className: "home-video absolute inset-0 flex items-center",
    style: {
      zIndex: -1
    }
  }, /*#__PURE__*/React.createElement("iframe", {
    src: "" + video,
    id: "desktop-iframe",
    loading: "lazy",
    width: "100%",
    onLoad: function onLoad(e) {
      return saveWrapperHeight(e.target.clientHeight);
    },
    className: "border-0 absolute left-0 right-0 bottom-0 w-full h-full",
    style: {
      top: -frameTopOffset
    },
    allow: "accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;",
    allowFullScreen: "true"
  }))), /*#__PURE__*/React.createElement("div", {
    id: "body-icons-wrapper"
  }, /*#__PURE__*/React.createElement(VehicleHomeBodySearch, {
    context: context
  })));
};
VehicleSearchMultiVideoText.human = {
  nl: '',
  fr: '',
  en: ''
};
VehicleSearchMultiVideoText.defaultProps = {
  videos: [],
  text: DefaultText
};
VehicleSearchMultiVideoText.preview = function () {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      height: 100
    }
  }, "Vehicle Search MULTI video and text");
};

var VehiclesFiltersQuery$2 = "query VehiclesFilter($params: VehiclesFilterParamType!) {\n  vehiclesFilter(params: $params) {\n    makes {\n      key\n      description            \n    }\n    \n    models {\n      key\n      makeKey\n      description                 \n    }\n            \n    fuelTypes {\n      key\n      description\n      count      \n    }\n  }\n}";
var initialState$1 = {
  make: undefined,
  model: undefined,
  fuel: undefined
};
var getMakeFromWindowUrl = function getMakeFromWindowUrl(makeOptions) {
  var make = hasWindow() ? window.location.pathname.split('/')[1] : '';
  var makeOption = find(makeOptions, function (option) {
    return option.value === make;
  });
  return makeOption ? makeOption : undefined;
};
var VehicleSearchText = function VehicleSearchText(_ref) {
  var text = _ref.text,
    context = _ref.context;
  var _useState = useState(initialState$1),
    state = _useState[0],
    setState = _useState[1];
  var _useVehiclesFilterDat = useVehiclesFilterData(VehiclesFiltersQuery$2, context),
    data = _useVehiclesFilterDat.data,
    fetchVehiclesFilterData = _useVehiclesFilterDat.fetchVehiclesFilterData,
    loading = _useVehiclesFilterDat.loading;
  var _useIsMobile = useIsMobile(),
    isMobile = _useIsMobile.isMobile;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    fetchVehiclesFilterData();
  }, []);
  var setValue = function setValue(key, value) {
    var _extends2;
    setState(_extends({}, state, (_extends2 = {}, _extends2[key] = value, _extends2)));
  };
  var makeOptions = !loading ? data.makes.map(function (make) {
    return {
      value: make.key,
      label: make.text
    };
  }) : [];
  var modelOptions = !loading ? state.make ? data.models.filter(function (model) {
    return model.custom === state.make;
  }).map(function (model) {
    return {
      value: model.key,
      label: model.text
    };
  }) : [] : [];
  var fuelOptions = !loading ? data.fuels.map(function (fuel) {
    return {
      value: fuel.key,
      label: fuel.text
    };
  }) : [];
  useEffect(function () {
    if (state.make === undefined && makeOptions.length > 0) {
      var make = getMakeFromWindowUrl(makeOptions);
      if (make) {
        setValue('make', make.value);
      }
    }
  }, [makeOptions]);
  var onSearch = function onSearch(e) {
    e.preventDefault();
    var filtersUrl = generateUrlParametersByFormDataV2({
      makeModels: state === null || state === void 0 ? void 0 : state.makeModels,
      price: state.price ? state.price : '',
      monthlyPrice: state.monthlyPrice ? state.monthlyPrice : ''
    }, data, context);
    navigateInternalPage(context, context.defaultPageNames.vehicles, filtersUrl);
  };
  var selectedMake = find(makeOptions, function (m) {
    return m.value === state.make;
  });
  var selectedModel = find(modelOptions, function (m) {
    return m.value === state.model;
  });
  var selectedFuel = find(fuelOptions, function (m) {
    return m.value === state.fuel;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "flex bg-primary",
    style: {
      height: isMobile ? 'auto' : 475
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col lg:flex-row items-center container mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mr-0 lg:mr-40 leading-24 my-5 md:my-0",
    style: {
      maxWidth: 841
    }
  }, /*#__PURE__*/React.createElement(MarkupText, {
    text: text,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "bg-white rounded-lg",
    style: {
      minWidth: 432
    }
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: loading ? undefined : function (e) {
      return onSearch(e);
    },
    className: "w-full p-10"
  }, /*#__PURE__*/React.createElement(SelectBox, {
    value: selectedMake,
    onChange: function onChange(make) {
      return setValue('make', make.value);
    },
    options: makeOptions,
    placeholder: t('Make'),
    isLoading: loading,
    isDisabled: loading,
    className: "mb-2 md:mb-4"
  }), /*#__PURE__*/React.createElement(SelectBox, {
    value: selectedModel,
    onChange: function onChange(model) {
      return setValue('model', model.value);
    },
    options: modelOptions,
    isLoading: loading,
    isDisabled: !selectedMake || loading,
    placeholder: t('Model'),
    className: "mb-2 md:mb-4"
  }), /*#__PURE__*/React.createElement(SelectBox, {
    value: selectedFuel,
    onChange: function onChange(selectedFuel) {
      return setValue('fuel', selectedFuel.value);
    },
    options: fuelOptions,
    placeholder: t('Fuel type'),
    isLoading: loading,
    isDisabled: loading
  }), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "primary-button mt-8 " + (loading ? 'opacity-50 cursor-default' : ''),
    style: {
      height: 54,
      width: 177
    }
  }, t('Search vehicle'))))));
};
VehicleSearchText.human = {
  nl: '',
  fr: '',
  en: ''
};
VehicleSearchText.preview = function () {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      height: 100
    }
  }, "Vehicle search text");
};

var ImageCard = function ImageCard(_ref) {
  var _custom_card$image;
  var custom_card = _ref.custom_card,
    context = _ref.context;
  return /*#__PURE__*/React.createElement(ActionLink, {
    context: context,
    className: "shadow overflow-hidden hover:opacity cursor-pointer rounded-4",
    action: custom_card === null || custom_card === void 0 ? void 0 : custom_card.action,
    style: {
      background: "url(" + (custom_card === null || custom_card === void 0 ? void 0 : (_custom_card$image = custom_card.image) === null || _custom_card$image === void 0 ? void 0 : _custom_card$image.desktop) + ") no-repeat center bottom",
      backgroundSize: 'cover',
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement("div", null));
};

var VehicleSliderSkeleton = function VehicleSliderSkeleton(_ref) {
  var totalSlides = _ref.totalSlides;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "overflow-x-hidden w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-nowrap relative left-0 " + (totalSlides < 2 ? '' : 'space-x-2.5'),
    style: {
      width: 'fit-content'
    }
  }, times(totalSlides, function (slide) {
    return /*#__PURE__*/React.createElement(VehicleCardSkeleton, {
      key: slide
    });
  })))));
};
VehicleSliderSkeleton.defaultProps = {
  totalSlides: 4
};

var VehicleSlider = function VehicleSlider(_ref) {
  var cards = _ref.cards,
    loading = _ref.loading,
    error = _ref.error;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (loading) {
    var totalSlides = hasWindow() ? window.innerWidth < 768 ? 1 : 4 : 4;
    return /*#__PURE__*/React.createElement(VehicleSliderSkeleton, {
      totalSlides: totalSlides
    });
  }
  if (error) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ErrorIndicator, {
      error: t('The vehicles cannot be show at the moment.')
    }));
  }
  return /*#__PURE__*/React.createElement(Slider$1, {
    cards: cards
  });
};
var VehicleSlider$1 = baseSliderWithCustomImageCard(VehicleSlider);

var VehicleSliderContainer = function VehicleSliderContainer(_ref) {
  var title = _ref.title,
    filters = _ref.filters,
    custom_card = _ref.custom_card,
    custom_card_index = _ref.custom_card_index,
    context = _ref.context;
  return /*#__PURE__*/React.createElement(React.Fragment, null, title && title !== undefined && /*#__PURE__*/React.createElement("div", {
    className: "flex w-full mb-6"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-primary"
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: "w-full mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full block md:flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-95%"
  }, /*#__PURE__*/React.createElement(VehicleSlider$1, {
    filters: filters,
    renderVehicleCard: function renderVehicleCard(vehicle, context) {
      return /*#__PURE__*/React.createElement(VehicleCard$1, {
        vehicle: vehicle,
        context: context
      });
    },
    renderCustomImageCard: custom_card ? function () {
      return /*#__PURE__*/React.createElement(ImageCard, {
        custom_card: custom_card,
        context: context
      });
    } : undefined,
    customImageCardIndex: custom_card_index,
    context: context
  })), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:flex md:w-5% items-center justify-center ml-4"
  }, /*#__PURE__*/React.createElement(InternalLink, {
    url: filters === null || filters === void 0 ? void 0 : filters.url
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-plus-circle text-32 text-secondary-two hover:text-primary cursor-pointer"
  }))))));
};
VehicleSliderContainer.defaultProps = {
  financingVisible: true
};

var VehicleSlider$2 = function VehicleSlider(_ref) {
  var filters = _ref.filters,
    custom_card = _ref.custom_card,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "lg:container px-5 py-8 md:py-12"
  }, /*#__PURE__*/React.createElement(VehicleSliderContainer, {
    filters: filters,
    custom_card: custom_card,
    custom_card_index: 0,
    context: context
  }));
};
VehicleSlider$2.human = {
  nl: '',
  fr: '',
  en: ''
};
VehicleSlider$2.preview = function () {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      height: 100
    }
  }, "Vehicle slider static for POC");
};

var VehicleSliderWithHeaderAndLegal = function VehicleSliderWithHeaderAndLegal(_ref) {
  var title = _ref.title,
    custom_card = _ref.custom_card,
    filters = _ref.filters,
    more_title = _ref.more_title,
    context = _ref.context;
  var url = filters && filters.url ? filters.url : undefined;
  return /*#__PURE__*/React.createElement("div", {
    className: "mt-5 md:mt-10 container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex w-full mb-6"
  }, /*#__PURE__*/React.createElement("h2", null, title)), /*#__PURE__*/React.createElement("div", {
    className: "w-full mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full block md:flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-95%"
  }, /*#__PURE__*/React.createElement(VehicleSlider$1, {
    filters: filters,
    renderVehicleCard: function renderVehicleCard(vehicle, context) {
      return /*#__PURE__*/React.createElement(VehicleCard$1, {
        vehicle: vehicle,
        styles: {},
        context: context
      });
    },
    renderCustomImageCard: custom_card ? function () {
      return /*#__PURE__*/React.createElement(ImageCard, {
        custom_card: custom_card,
        context: context
      });
    } : undefined,
    context: context
  })), /*#__PURE__*/React.createElement(InternalLink, {
    url: url,
    className: "hidden md:flex md:w-5% items-center justify-center ml-4",
    context: context
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-arrow-right text-32 text-secondary-two hover:text-primary cursor-pointer"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "w-full mx-auto flex w-full justify-start"
  }, /*#__PURE__*/React.createElement(InternalLink, {
    url: url,
    className: "flex primary-button",
    context: context
  }, more_title)));
};
VehicleSliderWithHeaderAndLegal.human = {
  nl: '',
  fr: '',
  en: ''
};
VehicleSliderWithHeaderAndLegal.preview = function () {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      height: 100
    }
  }, "Vehicle slider");
};

var VehicleSliderWithHeaderAndBrands = function VehicleSliderWithHeaderAndBrands(_ref) {
  var title = _ref.title,
    custom_card = _ref.custom_card,
    filters = _ref.filters,
    more_title = _ref.more_title,
    brand_logos = _ref.brand_logos,
    context = _ref.context;
  var url = filters && filters.url ? filters.url : undefined;
  return /*#__PURE__*/React.createElement("div", {
    className: "mt-5 md:mt-10 container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex w-full mb-6"
  }, /*#__PURE__*/React.createElement("h2", null, title), /*#__PURE__*/React.createElement("div", {
    className: "hidden xl:flex flex-1 justify-end ml-4 h-full space-x-6"
  }, map(brand_logos, function (item, i) {
    var isLast = item.length - 1 === i;
    var actionExists = item.action && item.action.type !== '';
    var logoUrl = item.image && typeof item.image === 'object' ? item.image.desktop : item.image;
    var logoAlt = item.image && typeof item.image === 'object' ? item.image.alt : 'ALT';
    return /*#__PURE__*/React.createElement(ActionLink, {
      action: item.action,
      context: context
    }, /*#__PURE__*/React.createElement("img", {
      key: "brand-logo-" + i,
      src: logoUrl,
      alt: logoAlt,
      style: {
        maxHeight: 40
      },
      className: (isLast ? '' : 'mr-13') + " " + (actionExists ? 'cursor-pointer' : '')
    }));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "w-full mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full block md:flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-95%"
  }, /*#__PURE__*/React.createElement(VehicleSlider$1, {
    filters: filters,
    renderVehicleCard: function renderVehicleCard(vehicle, context) {
      return /*#__PURE__*/React.createElement(VehicleCard$1, {
        vehicle: vehicle,
        context: context
      });
    },
    renderCustomImageCard: custom_card ? function () {
      return /*#__PURE__*/React.createElement(ImageCard, {
        custom_card: custom_card,
        context: context
      });
    } : undefined,
    context: context
  })), /*#__PURE__*/React.createElement(InternalLink, {
    url: url,
    className: "hidden md:flex md:w-5% items-center justify-center ml-4",
    context: context
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-arrow-right text-32 text-secondary-two hover:text-primary cursor-pointer"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "w-full mx-auto flex w-full justify-start mt-5"
  }, /*#__PURE__*/React.createElement(InternalLink, {
    url: url,
    className: "flex primary-button",
    context: context
  }, more_title)));
};
VehicleSliderWithHeaderAndBrands.human = {
  nl: '',
  fr: '',
  en: ''
};
VehicleSliderWithHeaderAndBrands.preview = function () {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      height: 100
    }
  }, "Vehicle slider");
};

var VehicleSliderWithHeaderAndLegal$1 = function VehicleSliderWithHeaderAndLegal(_ref) {
  var title = _ref.title,
    custom_card = _ref.custom_card,
    filters = _ref.filters,
    more_title = _ref.more_title,
    context = _ref.context;
  var url = filters && filters.url ? filters.url : undefined;
  return /*#__PURE__*/React.createElement("div", {
    className: "mt-5 md:mt-10 container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex w-full mb-6"
  }, /*#__PURE__*/React.createElement("h2", null, title)), /*#__PURE__*/React.createElement("div", {
    className: "w-full mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full block md:flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-95%"
  }, /*#__PURE__*/React.createElement(VehicleSlider$1, {
    filters: filters,
    renderVehicleCard: function renderVehicleCard(vehicle, context) {
      return /*#__PURE__*/React.createElement(VehicleCard$1, {
        vehicle: vehicle,
        styles: {},
        context: context
      });
    },
    renderCustomImageCard: custom_card ? function () {
      return /*#__PURE__*/React.createElement(ImageCard, {
        custom_card: custom_card,
        context: context
      });
    } : undefined,
    context: context
  })), /*#__PURE__*/React.createElement(InternalLink, {
    url: url,
    className: "hidden md:flex md:w-5% items-center justify-center ml-4",
    context: context
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-arrow-right text-32 text-secondary-two hover:text-primary cursor-pointer"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "w-full mx-auto flex w-full justify-start mt-5"
  }, /*#__PURE__*/React.createElement(InternalLink, {
    url: url,
    className: "flex primary-button",
    context: context
  }, more_title)));
};
VehicleSliderWithHeaderAndLegal$1.human = {
  nl: '',
  fr: '',
  en: ''
};
VehicleSliderWithHeaderAndLegal$1.preview = function () {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      height: 100
    }
  }, "Vehicle slider");
};

var VehicleSliderWithHeaderGray = function VehicleSliderWithHeaderGray(_ref) {
  var title = _ref.title,
    custom_card = _ref.custom_card,
    filters = _ref.filters,
    more_title = _ref.more_title,
    context = _ref.context;
  var url = filters && filters.url ? filters.url : undefined;
  return /*#__PURE__*/React.createElement("div", {
    className: "py-5 md:py-10 bg-transparent md:bg-secondary-four mt-5 md:mt-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex w-full mb-6"
  }, /*#__PURE__*/React.createElement("h2", null, title)), /*#__PURE__*/React.createElement("div", {
    className: "w-full mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full block md:flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full md:w-95%"
  }, /*#__PURE__*/React.createElement(VehicleSlider$1, {
    filters: filters,
    renderVehicleCard: function renderVehicleCard(vehicle, context) {
      return /*#__PURE__*/React.createElement(VehicleCard$1, {
        vehicle: vehicle,
        styles: {},
        context: context
      });
    },
    renderCustomImageCard: custom_card ? function () {
      return /*#__PURE__*/React.createElement(ImageCard, {
        custom_card: custom_card,
        context: context
      });
    } : undefined,
    context: context
  })), /*#__PURE__*/React.createElement(InternalLink, {
    url: url,
    className: "hidden md:flex md:w-5% items-center justify-center ml-4",
    context: context
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-arrow-right text-32 text-secondary-two hover:text-primary cursor-pointer"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "w-full mx-auto flex w-full justify-start mt-5"
  }, /*#__PURE__*/React.createElement(InternalLink, {
    url: url,
    className: "flex primary-button",
    context: context
  }, more_title))));
};
VehicleSliderWithHeaderGray.human = {
  nl: '',
  fr: '',
  en: ''
};
VehicleSliderWithHeaderGray.preview = function () {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      height: 100
    }
  }, "Vehicle Slider with Gray backgroundC");
};

var MakesFilter$2 = function MakesFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    onFilterChange = _ref.onFilterChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-xsmall font-semibold text-primary mb-2 mt-2"
  }, t('Makes')), /*#__PURE__*/React.createElement(GenericList, {
    items: filterData,
    values: filterValues,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
      onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
    }
  }));
};
baseMakeFilterForMakeModel(MakesFilter$2);

var ModelsFilter$2 = function ModelsFilter(_ref) {
  var filterData = _ref.filterData,
    makeFilterValues = _ref.makeFilterValues,
    modelFilterValues = _ref.modelFilterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    onFilterChange = _ref.onFilterChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var makes = filterData.makes,
    models = filterData.models;
  var availableMakesForModels = makeFilterValues.length > 0 ? filter(makes, function (m) {
    return includes(makeFilterValues, m.key);
  }) : makes;
  var modelOptions = map(availableMakesForModels, function (make) {
    return {
      value: make.key,
      label: make.text,
      make: make,
      options: models ? orderBy(map(filter(models, function (model) {
        return model.custom === make.key;
      }), function (model) {
        return {
          value: model.key,
          label: model.text,
          make: make
        };
      }), ['label']) : []
    };
  });
  var modelLabel = '';
  var modelFiltersByMake = groupBy(modelFilterValues, 'make');
  if (!isEmpty(modelFiltersByMake)) {
    Object.keys(modelFiltersByMake).map(function (key) {
      var make = find(makes, function (m) {
        return m.key === key;
      });
      var modelString = '';
      map(modelFiltersByMake[key], function (m) {
        var model = find(models, function (model) {
          return model.key === m.model;
        });
        if (model) {
          modelString = modelString ? modelString + ", " + model.text : "" + model.text;
        }
      });
      modelLabel = modelLabel ? modelLabel + ", " + make.text + ": " + modelString : make.text + ": " + modelString;
    });
  }
  var handleFilterChanged = function handleFilterChanged(data) {
    var makeKey = data.make.key;
    var modelKey = data.value;
    var value = makeKey + "|" + modelKey;
    if (hasFilterWithValue(value)) {
      filterDelete(value);
    } else {
      filterAdd(value);
    }
    onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "font-secondary font-semibold text-primary mb-2 mt-5"
  }, t('Model')), /*#__PURE__*/React.createElement(SelectBox, {
    value: modelLabel ? {
      label: modelLabel
    } : '',
    options: orderBy(modelOptions, ['label']),
    closeMenuOnSelect: false,
    placeholder: t('All'),
    customComponents: {
      Option: function Option(_ref2) {
        var innerProps = _ref2.innerProps,
          isDisabled = _ref2.isDisabled,
          data = _ref2.data;
        var isSelected = find(modelFilterValues, function (item) {
          return item.make === data.make.key && item.model === data.value;
        }) !== undefined;
        return !isDisabled ? /*#__PURE__*/React.createElement("div", innerProps, /*#__PURE__*/React.createElement("div", {
          className: "flex flex-row py-1 hover:bg-gray-100 cursor-pointer hover:text-primary ml-5",
          onClick: function onClick() {
            return handleFilterChanged(data);
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex items-center"
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex items-center justify-center rounded border border-primary mr-2",
          style: {
            height: 16,
            width: 16
          }
        }, isSelected && /*#__PURE__*/React.createElement("i", {
          className: "far fa-check text-secondary-two font-bold",
          style: {
            fontSize: 10,
            marginTop: 2
          }
        }))), /*#__PURE__*/React.createElement("div", {
          className: "flex flex-row justify-between flex-1 relative text-secondary-three font-secondary " + (isSelected ? 'text-bold' : '')
        }, /*#__PURE__*/React.createElement("div", {
          className: "capitalize"
        }, data.label)))) : null;
      }
    },
    isLoading: false
  }));
};
baseModelFilterForMakeModel(ModelsFilter$2);

var BodiesFilter$1 = function BodiesFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    onFilterChange = _ref.onFilterChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-xsmall font-semibold text-primary mb-2 mt-5"
  }, t('Body type')), /*#__PURE__*/React.createElement(GenericSelect, {
    placeHolder: t('All'),
    items: filterData,
    values: filterValues,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
      onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
    }
  }));
};
baseTypedFilter(FilterTypes.body, BodiesFilter$1);

var YearFilter$2 = function YearFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterUpdate = _ref.filterUpdate,
    hasFilter = _ref.hasFilter,
    onFilterChange = _ref.onFilterChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var yearsFrom = range(filterData.min, filterData.max + 1).map(function (item) {
    return {
      value: item,
      label: item
    };
  });
  var yearsTo = range(filterData.min, filterData.max + 1).map(function (item) {
    return {
      value: item,
      label: item
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-xsmall font-semibold text-primary mb-2 mt-5"
  }, t('First registration')), /*#__PURE__*/React.createElement(GenericRangeSelect, {
    placeHolderFrom: t('From'),
    placeHolderTo: t('To'),
    optionsFrom: orderBy(yearsFrom, ['value'], ['desc']),
    optionsTo: orderBy(yearsTo, ['value'], ['desc']),
    value: filterValues && filterValues.length > 0 ? filterValues[0] : undefined,
    handleFilterChanged: function handleFilterChanged(range) {
      if (hasFilter()) {
        filterUpdate(range);
      } else {
        filterAdd(range);
      }
      onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
    }
  }));
};
var YearFilter$3 = baseTypedFilter(FilterTypes.year, YearFilter$2);

var PriceFilter$2 = function PriceFilter(_ref) {
  var filters = _ref.filters,
    filterData = _ref.filterData,
    filterAdd = _ref.filterAdd,
    filterUpdate = _ref.filterUpdate,
    filterDeleteByType = _ref.filterDeleteByType,
    hasFilter = _ref.hasFilter,
    radioButtonSize = _ref.radioButtonSize,
    onFilterChange = _ref.onFilterChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var priceMax = filterData ? filterData.dataSettings.priceMax : 0;
  var priceStep = filterData ? filterData.dataSettings.priceStep : 0;
  var monthlyMax = filterData ? filterData.dataSettings.monthlyMax : 0;
  var monthlyStep = filterData ? filterData.dataSettings.monthlyStep : 0;
  var prices = {
    min: 0,
    max: priceMax,
    step: priceStep
  };
  var monthlyPrices = {
    min: 0,
    max: monthlyMax,
    step: monthlyStep
  };
  var handleChange = function handleChange(type, range) {
    var typeMax = type === FilterTypes.price ? prices.max : type === FilterTypes.monthlyPrice ? monthlyPrices.max : 0;
    var rangeIsMax = range[1] === typeMax;
    if (!rangeIsMax) {
      var labelPrefix = type === FilterTypes.price ? t('Max.') : type === FilterTypes.monthlyPrice ? t('Monthly max.') : '';
      if (hasFilter(type)) {
        filterUpdate(type, range);
      } else {
        filterAdd(type, range);
      }
    } else {
      filterDeleteByType(type);
    }
    onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
  };
  var priceFilter = find(filters, function (f) {
    return f.type === FilterTypes.price;
  });
  var monthlyFilter = find(filters, function (f) {
    return f.type === FilterTypes.monthlyPrice;
  });
  return /*#__PURE__*/React.createElement(PriceSlider, {
    prices: prices,
    monthlyPrices: monthlyPrices,
    values: {
      price: priceFilter ? priceFilter.value : undefined,
      monthly: monthlyFilter ? monthlyFilter.value : undefined
    },
    onChange: function onChange(values) {
      if (values.price) {
        handleChange(FilterTypes.price, values.price);
      }
      if (values.monthly) {
        handleChange(FilterTypes.monthlyPrice, values.monthly);
      }
    },
    radioButtonSize: radioButtonSize
  });
};
PriceFilter$2.defaultProps = {
  radioButtonSize: 14
};
var PriceFilter$3 = baseFilter(PriceFilter$2);

var FuelFilter$2 = function FuelFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    onFilterChange = _ref.onFilterChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-xsmall font-semibold text-primary mb-2 mt-5"
  }, t('Fuel type')), /*#__PURE__*/React.createElement(GenericSelect, {
    placeHolder: t('All'),
    items: filterData,
    values: filterValues,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
      onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
    }
  }));
};
baseTypedFilter(FilterTypes.fuel, FuelFilter$2);

var MileageFilter$2 = function MileageFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterUpdate = _ref.filterUpdate,
    hasFilter = _ref.hasFilter,
    onFilterChange = _ref.onFilterChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var mileagesFrom = range(filterData.min, filterData.max + 1, 5000).map(function (mileage) {
    return {
      value: Math.round(mileage / 1000) * 1000,
      label: formatNumber(Math.round(mileage / 1000) * 1000) + " km"
    };
  });
  var mileagesTo = range(filterData.min, filterData.max + 1, 5000).map(function (mileage) {
    return {
      value: Math.round(mileage / 1000) * 1000,
      label: formatNumber(Math.round(mileage / 1000) * 1000) + " km"
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-xsmall font-semibold text-primary mb-2 mt-5"
  }, t('Mileage')), /*#__PURE__*/React.createElement(GenericRangeSelect, {
    placeHolderFrom: t('From'),
    placeHolderTo: t('To'),
    optionsFrom: mileagesFrom,
    optionsTo: mileagesTo,
    value: filterValues && filterValues.length > 0 ? filterValues[0] : undefined,
    handleFilterChanged: function handleFilterChanged(range) {
      if (hasFilter()) {
        filterUpdate(range);
      } else {
        filterAdd(range);
      }
      onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
    }
  }));
};
var MileageFilter$3 = baseTypedFilter(FilterTypes.mileage, MileageFilter$2);

var labels$1 = {
  PK: 'PK',
  KW: 'KW'
};
var initPK$1 = {
  min: '',
  max: ''
};
var initKW$1 = {
  min: '',
  max: ''
};
var PowerFilter$2 = function PowerFilter(_ref) {
  var filters = _ref.filters,
    filterAdd = _ref.filterAdd,
    filterUpdate = _ref.filterUpdate,
    filterDeleteByType = _ref.filterDeleteByType,
    hasFilter = _ref.hasFilter,
    onFilterChange = _ref.onFilterChange;
  var _useState = useState(labels$1.PK),
    activeOption = _useState[0],
    setActiveOption = _useState[1];
  var _useState2 = useState(initPK$1),
    pk = _useState2[0],
    setPk = _useState2[1];
  var _useState3 = useState(initKW$1),
    kw = _useState3[0],
    setKw = _useState3[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    var pkFilters = head(filter(filters, function (f) {
      return f.type === FilterTypes.pk;
    }));
    var kwFilters = head(filter(filters, function (f) {
      return f.type === FilterTypes.kw;
    }));
    if (pkFilters) {
      setPk({
        min: pkFilters.value[0],
        max: pkFilters.value[1]
      });
    }
    if (kwFilters) {
      setKw({
        min: kwFilters.value[0],
        max: kwFilters.value[1]
      });
    }
  }, []);
  var powerOptions = [{
    value: labels$1.PK,
    label: t('hp')
  }, {
    value: labels$1.KW,
    label: t('kW')
  }];
  var onPkChange = function onPkChange() {
    if (pk.min !== '' || pk.max !== '') {
      var value = [pk.min, pk.max];
      if (hasFilter(FilterTypes.pk)) {
        filterUpdate(FilterTypes.pk, value);
      } else {
        filterAdd(FilterTypes.pk, value);
      }
    } else {
      filterDeleteByType(FilterTypes.pk);
    }
    onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
  };
  var onKwChange = function onKwChange() {
    if (kw.min !== '' || kw.max !== '') {
      var value = [kw.min, kw.max];
      if (hasFilter(FilterTypes.kw)) {
        filterUpdate(FilterTypes.kw, value);
      } else {
        filterAdd(FilterTypes.kw, value);
      }
    } else {
      filterDeleteByType(FilterTypes.kw);
    }
    onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
  };
  var renderPK = function renderPK() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
      className: "w-1/2 filter-input border border-primary font-secondary text-primary rounded-l-4 focus:outline-none",
      value: pk.min,
      type: "number",
      style: {
        maxHeight: 46,
        height: 46
      },
      placeholder: t('From'),
      onChange: function onChange(e) {
        return setPk(_extends({}, pk, {
          min: e.target.value
        }));
      },
      onBlur: function onBlur() {
        return onPkChange();
      }
    }), /*#__PURE__*/React.createElement("input", {
      className: "w-1/2 filter-input border-t border-b border-r border-primary font-secondary text-primary rounded-r-4 focus:outline-none",
      value: pk.max,
      type: "number",
      style: {
        maxHeight: 46,
        height: 46
      },
      placeholder: t('To'),
      onChange: function onChange(e) {
        return setPk(_extends({}, pk, {
          max: e.target.value
        }));
      },
      onBlur: function onBlur() {
        return onPkChange();
      }
    }));
  };
  var renderKW = function renderKW() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
      className: "w-1/2 filter-input border border-primary font-secondary text-primary rounded-l-4 focus:outline-none",
      value: kw.min,
      type: "number",
      style: {
        maxHeight: 46,
        height: 46
      },
      placeholder: t('From'),
      onChange: function onChange(e) {
        return setKw(_extends({}, kw, {
          min: e.target.value
        }));
      },
      onBlur: function onBlur() {
        return onKwChange();
      }
    }), /*#__PURE__*/React.createElement("input", {
      className: "w-1/2 filter-input border-t border-b border-r border-primary font-secondary text-primary rounded-r-4 focus:outline-none",
      value: kw.max,
      type: "number",
      style: {
        maxHeight: 46,
        height: 46
      },
      placeholder: t('To'),
      onChange: function onChange(e) {
        return setKw(_extends({}, kw, {
          max: e.target.value
        }));
      },
      onBlur: function onBlur() {
        return onKwChange();
      }
    }));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-xsmall font-semibold text-primary mb-2 mt-5"
  }, t('Power')), /*#__PURE__*/React.createElement("div", {
    className: "flex font-secondary"
  }, /*#__PURE__*/React.createElement("div", {
    className: "power-filter-selector",
    style: {
      width: 90
    }
  }, /*#__PURE__*/React.createElement(SelectBox, {
    value: find(powerOptions, function (i) {
      return i.value === activeOption;
    }),
    options: powerOptions,
    className: "focus:outline-none h-full",
    isLoading: false,
    onChange: function onChange(option) {
      return setActiveOption(option.value);
    }
  })), /*#__PURE__*/React.createElement(Fade, {
    spy: activeOption
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full flex flex-1 ml-2"
  }, activeOption === labels$1.PK && renderPK(), activeOption === labels$1.KW && renderKW()))));
};
var PowerFilter$3 = baseFilter(PowerFilter$2);

var GearboxFilter$2 = function GearboxFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    onFilterChange = _ref.onFilterChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-xsmall font-semibold text-primary mb-2 mt-5"
  }, t('Gear')), /*#__PURE__*/React.createElement(GenericSelect, {
    placeHolder: t('All'),
    items: filterData,
    values: filterValues,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
      onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
    }
  }));
};
baseTypedFilter(FilterTypes.transmission, GearboxFilter$2);

var DoorsFilter$2 = function DoorsFilter(_ref) {
  var filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterUpdate = _ref.filterUpdate,
    filterDeleteByType = _ref.filterDeleteByType,
    hasFilter = _ref.hasFilter,
    onFilterChange = _ref.onFilterChange;
  var doorsRangeValue = filterValues && filterValues.length > 0 ? filterValues[0] : undefined;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var filterExists = function filterExists(range) {
    return doorsRangeValue ? includes(doorsRangeValue, range[0]) && includes(doorsRangeValue, range[1]) : false;
  };
  var handleFilterChanged = function handleFilterChanged(range) {
    if (hasFilter()) {
      filterUpdate(range);
    } else {
      filterAdd(range);
    }
    onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
  };
  var handleRemoveFilter = function handleRemoveFilter() {
    filterDeleteByType();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-xsmall font-semibold text-primary mb-2 mt-5"
  }, t('Nr. of Doors')), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-4 font-secondary",
    style: {
      minHeight: 44
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-input cursor-pointer text-center border border-primary rounded-l-4 " + (!doorsRangeValue ? 'bg-secondary-two text-white' : 'text-secondary'),
    onClick: function onClick() {
      return handleRemoveFilter();
    }
  }, t('All')), /*#__PURE__*/React.createElement("div", {
    className: "filter-input cursor-pointer text-center border-t border-b border-primary  " + (filterExists([2, 3]) ? 'bg-secondary-two text-white' : 'text-secondary'),
    onClick: function onClick() {
      return handleFilterChanged([2, 3]);
    }
  }, "2/3"), /*#__PURE__*/React.createElement("div", {
    className: "filter-input cursor-pointer text-center border-t border-b border-l border-primary  " + (filterExists([4, 5]) ? 'bg-secondary-two text-white' : 'text-secondary'),
    onClick: function onClick() {
      return handleFilterChanged([4, 5]);
    }
  }, "4/5"), /*#__PURE__*/React.createElement("div", {
    className: "filter-input cursor-pointer text-center border border-primary rounded-r-4 " + (filterExists([6, 7]) ? 'bg-secondary-two text-white' : 'text-secondary'),
    onClick: function onClick() {
      return handleFilterChanged([6, 7]);
    }
  }, "6/7")));
};
var DoorsFilter$3 = baseTypedFilter(FilterTypes.doorsRange, DoorsFilter$2);

var totalSeats = 12;
var SeatsFilter$1 = function SeatsFilter(_ref) {
  var filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterUpdate = _ref.filterUpdate,
    hasFilter = _ref.hasFilter,
    onFilterChange = _ref.onFilterChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var filterValue = filterValues && filterValues.length > 0 ? filterValues[0] : undefined;
  var minValue = filterValue ? filterValue[0] : 1;
  var maxValue = filterValue ? filterValue[1] : totalSeats;
  var seatsFromOptions = range(1, maxValue + 1).map(function (seat) {
    return {
      value: seat,
      label: seat
    };
  });
  var seatsToOptions = range(minValue, totalSeats + 1).map(function (seat) {
    return {
      value: seat,
      label: seat
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-xsmall font-semibold text-primary mb-2 mt-5"
  }, t('Nr. of Seats')), /*#__PURE__*/React.createElement(GenericRangeSelect, {
    placeHolderFrom: t('From'),
    placeHolderTo: t('To'),
    optionsFrom: seatsFromOptions,
    optionsTo: seatsToOptions,
    value: filterValues && filterValues.length > 0 ? filterValues[0] : undefined,
    handleFilterChanged: function handleFilterChanged(range) {
      if (hasFilter()) {
        filterUpdate(range);
      } else {
        filterAdd(range);
      }
      onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
    }
  }));
};
var SeatsFilter$2 = baseTypedFilter(FilterTypes.seatsRange, SeatsFilter$1);

var CategoryFilter$2 = function CategoryFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    onFilterChange = _ref.onFilterChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-xsmall font-semibold text-primary mb-2 mt-5"
  }, t('Vehicle condition')), /*#__PURE__*/React.createElement(GenericList, {
    items: filterData,
    values: filterValues,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
      onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
    }
  }));
};
var CategoryFilter$3 = baseTypedFilter(FilterTypes.category, CategoryFilter$2);

var VatFilter$2 = function VatFilter(_ref) {
  var filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    onFilterChange = _ref.onFilterChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var handleFilterChanged = function handleFilterChanged() {
    if (hasFilterWithValue(true)) {
      filterDelete(true);
    } else {
      filterAdd(true);
    }
    onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
  };
  var isSelected = includes(filterValues, true);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-xsmall font-semibold text-primary mb-2 mt-5"
  }, t('VAT')), /*#__PURE__*/React.createElement("div", {
    key: "filter-vat",
    className: "flex flex-col text-gray-900 mb-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row py-1 hover:bg-gray-100 cursor-pointer hover:text-primary",
    onClick: function onClick() {
      return handleFilterChanged();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center rounded border mr-2 " + (isSelected ? 'bg-secondary-one border-secondary-one' : 'border-primary'),
    style: {
      height: 16,
      width: 16
    }
  }, isSelected && /*#__PURE__*/React.createElement("i", {
    className: "far fa-check text-white",
    style: {
      fontSize: 10,
      marginTop: 2
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 paragraph-small " + (isSelected ? 'font-semibold' : 'font-normal')
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, t('VAT deductible'))))));
};
var VatFilter$3 = baseTypedFilter(FilterTypes.vat, VatFilter$2);

var EquipmentFilter$2 = function EquipmentFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    onFilterChange = _ref.onFilterChange;
  var _useState = useState(false),
    showAll = _useState[0],
    setShowAll = _useState[1];
  var orderedEquipments = orderBy(filterData, ['text']);
  var equipmentsToShow = showAll ? orderedEquipments : take(orderedEquipments, 10);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "mt-5"
  }, /*#__PURE__*/React.createElement(GenericList, {
    placeHolder: t('All'),
    items: equipmentsToShow,
    values: filterValues,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
      onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
    }
  }), filterData.length > 10 && /*#__PURE__*/React.createElement("div", {
    className: "paragraph-default text-primary cursor-pointer hover:text-secondary mt-2",
    onClick: function onClick() {
      return setShowAll(!showAll);
    }
  }, showAll ? /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, t('Show less equipment'), /*#__PURE__*/React.createElement("i", {
    className: "fal fa-arrow-up ml-2"
  })) : /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, t('Show more equipment'), /*#__PURE__*/React.createElement("i", {
    className: "fal fa-arrow-down ml-2"
  }))));
};
var EquipmentFilter$3 = baseTypedFilter(FilterTypes.equipments, EquipmentFilter$2);

var ExteriorColorFilter$2 = function ExteriorColorFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    onFilterChange = _ref.onFilterChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-xsmall font-semibold text-primary mb-2 mt-5"
  }, t('Body Color')), /*#__PURE__*/React.createElement(GenericColorList, {
    placeHolder: t('All'),
    items: filterData,
    values: filterValues,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
      onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
    }
  }));
};
var ExteriorColorFilter$3 = baseTypedFilter(FilterTypes.exteriorColor, ExteriorColorFilter$2);

var InteriorColorFilter$2 = function InteriorColorFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    onFilterChange = _ref.onFilterChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-xsmall font-semibold text-primary mb-2 mt-2"
  }, t('Interior Color')), /*#__PURE__*/React.createElement(GenericColorList, {
    placeHolder: t('All'),
    items: filterData,
    values: filterValues,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
      onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
    }
  }));
};
var InteriorColorFilter$3 = baseTypedFilter(FilterTypes.interiorColor, InteriorColorFilter$2);

var InteriorUpholstery$1 = function InteriorUpholstery(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    onFilterChange = _ref.onFilterChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-xsmall font-semibold text-primary mb-2 mt-5"
  }, t('Upholstery')), /*#__PURE__*/React.createElement(GenericList, {
    items: filterData,
    values: filterValues,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
      onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
    }
  }));
};
var InteriorUpholsteryFilter$1 = baseTypedFilter(FilterTypes.interiorUpholstery, InteriorUpholstery$1);

var EuroNormFilter$2 = function EuroNormFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    onFilterChange = _ref.onFilterChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-xsmall font-semibold text-primary mb-2 mt-5"
  }, t('Euro Emission Class')), /*#__PURE__*/React.createElement(GenericSelect, {
    placeHolder: t('All'),
    items: filterData,
    values: filterValues,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
      onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
    }
  }));
};
var EuroNormFilter$3 = baseTypedFilter(FilterTypes.euroNorm, EuroNormFilter$2);

var initCoValue$1 = {
  min: '',
  max: ''
};
var CO2Filter$2 = function CO2Filter(_ref) {
  var filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterUpdate = _ref.filterUpdate,
    filterDeleteByType = _ref.filterDeleteByType,
    hasFilter = _ref.hasFilter,
    onFilterChange = _ref.onFilterChange;
  var activeFilter = filterValues && filterValues.length > 0 ? filterValues[0] : undefined;
  var _useState = useState(activeFilter ? {
      min: activeFilter[0],
      max: activeFilter[1]
    } : initCoValue$1),
    value = _useState[0],
    setValue = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var handleChange = function handleChange() {
    if (value.min !== '' || value.max !== '') {
      var range = [value.min, value.max];
      if (hasFilter()) {
        filterUpdate(range);
      } else {
        filterAdd(range);
      }
    } else {
      filterDeleteByType();
    }
    onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-xsmall font-semibold text-primary mb-2 mt-5"
  }, t('CO2 (g/km)')), /*#__PURE__*/React.createElement("div", {
    className: "flex paragraph-default text-secondary-four",
    style: {
      minHeight: 44
    }
  }, /*#__PURE__*/React.createElement("input", {
    className: "w-1/2 filter-input border border-primary font-secondary text-primary rounded-l-4 focus:outline-none",
    value: value.min,
    style: {
      maxHeight: 46
    },
    placeholder: t('From'),
    onChange: function onChange(e) {
      return setValue(_extends({}, value, {
        min: e.target.value
      }));
    },
    onBlur: function onBlur() {
      return handleChange();
    }
  }), /*#__PURE__*/React.createElement("input", {
    className: "w-1/2 filter-input border-t border-b border-r border-primary font-secondary text-primary rounded-r-4 focus:outline-none",
    value: value.max,
    style: {
      maxHeight: 46
    },
    placeholder: t('To'),
    onChange: function onChange(e) {
      return setValue(_extends({}, value, {
        max: e.target.value
      }));
    },
    onBlur: function onBlur() {
      return handleChange();
    }
  })));
};
var CO2Filter$3 = baseTypedFilter(FilterTypes.co2Range, CO2Filter$2);

var IdentificationFilter = function IdentificationFilter(_ref) {
  var filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterUpdate = _ref.filterUpdate,
    filterDeleteByType = _ref.filterDeleteByType,
    hasFilter = _ref.hasFilter,
    onFilterChange = _ref.onFilterChange;
  var _useState = useState(filterValues ? head(filterValues) : ''),
    identification = _useState[0],
    setIdentification = _useState[1];
  var identificationFilter = head(filterValues);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    if (filterValues) {
      setIdentification(head(filterValues) ? head(filterValues) : '');
    }
  }, [filterValues]);
  var handleFilterChanged = function handleFilterChanged() {
    if (identification && identification !== '') {
      if (hasFilter()) {
        filterUpdate(identification);
      } else {
        filterAdd(identification);
      }
    } else {
      filterDeleteByType();
    }
    onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
  };
  var handleKeyPress = function handleKeyPress(event) {
    if (event.keyCode === 13) {
      handleFilterChanged();
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex w-full mb-4 relative bg-white items-center rounded border border-primary font-secondary text-primary rounded-l-10 rounded-r-10"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: "flex-1 font-secondary text-primary outline-none rounded-l-10",
    style: {
      padding: '15px 18px 15px 15px'
    },
    placeholder: t('Reference'),
    value: identification,
    onChange: function onChange(e) {
      return setIdentification(e.target.value);
    },
    onBlur: function onBlur() {
      return handleFilterChanged();
    },
    onKeyDown: handleKeyPress
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center mr-2",
    onClick: handleFilterChanged
  }, /*#__PURE__*/React.createElement("span", {
    className: "flex items-center leading-normal bg-white px-3 border-0 rounded-10 rounded-r-none"
  }, /*#__PURE__*/React.createElement("i", {
    className: "far fa-search text-secondary-two cursor-pointer"
  }))));
};
var IdentificationFilter$1 = baseTypedFilter(FilterTypes.identification, IdentificationFilter);

var FuelFilter$3 = function FuelFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    onFilterChange = _ref.onFilterChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-xsmall font-semibold text-primary mb-2 mt-5"
  }, t('Label')), /*#__PURE__*/React.createElement(GenericSelect, {
    placeHolder: t('All'),
    items: filterData,
    values: filterValues,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
      onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
    }
  }));
};
var LabelFilter = baseTypedFilter(FilterTypes.label, FuelFilter$3);

var DealershipsFilter = function DealershipsFilter(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    onFilterChange = _ref.onFilterChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-xsmall font-semibold text-primary mb-2 mt-5"
  }, t('Dealership')), /*#__PURE__*/React.createElement(GenericSelect, {
    placeHolder: t('All'),
    items: filterData,
    values: filterValues,
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
      onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
    }
  }));
};
var DealershipsFilter$1 = baseTypedFilter(FilterTypes.dealership, DealershipsFilter);

var FuelFilterCheckbox = function FuelFilterCheckbox(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    onFilterChange = _ref.onFilterChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-xsmall font-semibold text-primary mb-2 mt-5"
  }, t('Fuel type')), /*#__PURE__*/React.createElement(GenericList, {
    items: filterData,
    values: filterValues,
    containerClass: "",
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
      onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
    }
  }));
};
var FuelFilterCheckbox$1 = baseTypedFilter(FilterTypes.fuel, FuelFilterCheckbox);

var GearboxFilterCheckbox = function GearboxFilterCheckbox(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    onFilterChange = _ref.onFilterChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-xsmall font-semibold text-primary mb-2 mt-5"
  }, t('Gear')), /*#__PURE__*/React.createElement(GenericList, {
    items: filterData,
    values: filterValues,
    containerClass: "",
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
      onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
    }
  }));
};
var GearboxFilterCheckbox$1 = baseTypedFilter(FilterTypes.transmission, GearboxFilterCheckbox);

var BodiesFilterCheckbox = function BodiesFilterCheckbox(_ref) {
  var filterData = _ref.filterData,
    filterValues = _ref.filterValues,
    filterAdd = _ref.filterAdd,
    filterDelete = _ref.filterDelete,
    hasFilterWithValue = _ref.hasFilterWithValue,
    onFilterChange = _ref.onFilterChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "paragraph-xsmall font-semibold text-primary mb-2 mt-5"
  }, t('Body type')), /*#__PURE__*/React.createElement(GenericList, {
    items: filterData,
    values: filterValues,
    containerClass: "",
    handleFilterChanged: function handleFilterChanged(data) {
      if (hasFilterWithValue(data.value)) {
        filterDelete(data.value);
      } else {
        filterAdd(data.value);
      }
      onFilterChange && typeof onFilterChange === 'function' && onFilterChange();
    }
  }));
};
var BodiesFilterCheckbox$1 = baseTypedFilter(FilterTypes.body, BodiesFilterCheckbox);

var keys$1 = {
  basic: 'basic',
  equipments: 'equipments',
  exterior: 'exterior',
  upholstery: 'upholstery',
  environment: 'environment',
  adDetail: 'adDetail'
};
var Filters = function Filters(_ref) {
  var _useState2;
  var UIState = _ref.UIState,
    UIStateSave = _ref.UIStateSave,
    toggleSmallFilters = _ref.toggleSmallFilters,
    context = _ref.context;
  var activeCategoriesFromUIState = UIState && UIState.activeCategories ? UIState.activeCategories : undefined;
  var _useState = useState((_useState2 = {}, _useState2[keys$1.basic] = {
      key: keys$1.basic,
      translation: function translation(t) {
        return t('Basic specifications');
      },
      level: 1,
      active: activeCategoriesFromUIState ? includes(activeCategoriesFromUIState, keys$1.basic) : true
    }, _useState2[keys$1.equipments] = {
      key: keys$1.equipments,
      translation: function translation(t) {
        return t('Equipment');
      },
      level: 2,
      active: activeCategoriesFromUIState ? includes(activeCategoriesFromUIState, keys$1.equipments) : false
    }, _useState2[keys$1.exterior] = {
      key: keys$1.exterior,
      translation: function translation(t) {
        return t('Exterior');
      },
      level: 3,
      active: activeCategoriesFromUIState ? includes(activeCategoriesFromUIState, keys$1.exterior) : false
    }, _useState2[keys$1.upholstery] = {
      key: keys$1.upholstery,
      translation: function translation(t) {
        return t('Interior');
      },
      level: 4,
      active: activeCategoriesFromUIState ? includes(activeCategoriesFromUIState, keys$1.upholstery) : false
    }, _useState2[keys$1.environment] = {
      key: keys$1.environment,
      translation: function translation(t) {
        return t('Milieu');
      },
      level: 5,
      active: activeCategoriesFromUIState ? includes(activeCategoriesFromUIState, keys$1.environment) : false
    }, _useState2[keys$1.adDetail] = {
      key: keys$1.adDetail,
      translation: function translation(t) {
        return t('Offer detail');
      },
      level: 6,
      active: activeCategoriesFromUIState ? includes(activeCategoriesFromUIState, keys$1.environment) : false
    }, _useState2)),
    categories = _useState[0],
    setCategories = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var onFilterChange = function onFilterChange() {
    if (toggleSmallFilters && typeof toggleSmallFilters === 'function') {
      toggleSmallFilters(true);
    }
  };
  var renderContent = function renderContent(key) {
    switch (key) {
      case keys$1.basic:
        return /*#__PURE__*/React.createElement("div", {
          className: "px-5 mb-5 mt-3"
        }, /*#__PURE__*/React.createElement(MakeModelFilter$1, {
          context: context,
          onFilterChange: onFilterChange
        }), /*#__PURE__*/React.createElement(BodiesFilterCheckbox$1, {
          context: context,
          onFilterChange: onFilterChange
        }), /*#__PURE__*/React.createElement(YearFilter$3, {
          context: context,
          onFilterChange: onFilterChange
        }), /*#__PURE__*/React.createElement(PriceFilter$3, {
          context: context,
          onFilterChange: onFilterChange
        }), /*#__PURE__*/React.createElement(FuelFilterCheckbox$1, {
          context: context,
          onFilterChange: onFilterChange
        }), /*#__PURE__*/React.createElement(MileageFilter$3, {
          context: context,
          onFilterChange: onFilterChange
        }), /*#__PURE__*/React.createElement(PowerFilter$3, {
          context: context,
          onFilterChange: onFilterChange
        }), /*#__PURE__*/React.createElement(GearboxFilterCheckbox$1, {
          context: context,
          onFilterChange: onFilterChange
        }), /*#__PURE__*/React.createElement(DoorsFilter$3, {
          context: context,
          onFilterChange: onFilterChange
        }), /*#__PURE__*/React.createElement(SeatsFilter$2, {
          context: context,
          onFilterChange: onFilterChange
        }), /*#__PURE__*/React.createElement(CategoryFilter$3, {
          context: context,
          onFilterChange: onFilterChange
        }), /*#__PURE__*/React.createElement(LabelFilter, {
          context: context,
          onFilterChange: onFilterChange
        }), /*#__PURE__*/React.createElement(DealershipsFilter$1, {
          context: context,
          onFilterChange: onFilterChange
        }), /*#__PURE__*/React.createElement(VatFilter$3, {
          context: context,
          onFilterChange: onFilterChange
        }));
      case keys$1.equipments:
        return /*#__PURE__*/React.createElement("div", {
          className: "p-5"
        }, /*#__PURE__*/React.createElement(EquipmentFilter$3, {
          context: context,
          onFilterChange: onFilterChange
        }));
      case keys$1.exterior:
        return /*#__PURE__*/React.createElement("div", {
          className: "p-5"
        }, /*#__PURE__*/React.createElement(ExteriorColorFilter$3, {
          context: context,
          onFilterChange: onFilterChange
        }));
      case keys$1.upholstery:
        return /*#__PURE__*/React.createElement("div", {
          className: "p-5"
        }, /*#__PURE__*/React.createElement(InteriorColorFilter$3, {
          context: context,
          onFilterChange: onFilterChange
        }), /*#__PURE__*/React.createElement(InteriorUpholsteryFilter$1, {
          context: context,
          onFilterChange: onFilterChange
        }));
      case keys$1.environment:
        return /*#__PURE__*/React.createElement("div", {
          className: "px-5 mb-5"
        }, /*#__PURE__*/React.createElement(EuroNormFilter$3, {
          context: context,
          onFilterChange: onFilterChange
        }), /*#__PURE__*/React.createElement(CO2Filter$3, {
          context: context,
          onFilterChange: onFilterChange
        }));
      case keys$1.adDetail:
        return /*#__PURE__*/React.createElement("div", {
          className: "px-5 mt-5"
        }, /*#__PURE__*/React.createElement(IdentificationFilter$1, {
          context: context,
          onFilterChange: onFilterChange
        }));
      default:
        return /*#__PURE__*/React.createElement("div", null);
    }
  };
  var handleCategoryToggle = function handleCategoryToggle(category) {
    var _extends2;
    var result = _extends({}, categories, (_extends2 = {}, _extends2[category.key] = {
      key: category.key,
      translation: category.translation,
      level: category.level,
      active: !category.active
    }, _extends2));
    setCategories(result);
    UIStateSave(_extends({}, UIState, {
      scrollPosition: 0,
      activeCategories: map(filter(values(result), function (cat) {
        return cat.active === true;
      }), function (cat) {
        return cat.key;
      })
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "mx-5 md:mx-0 rounded-4 border border-secondary-eight relative"
  }, map(orderBy(categories, ['level']), function (category, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: "filter-category-" + i,
      id: category.key,
      className: "border-secondary-eight text-white " + (categories.length - 1 === i ? '' : 'border-b')
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between cursor-pointer p-5 bg-secondary-one text-white rounded-t-4",
      onClick: function onClick() {
        return handleCategoryToggle(category);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "font-secondary font-semibold text-15"
    }, category.translation(t)), /*#__PURE__*/React.createElement("i", {
      className: "fal " + (category.active ? 'fa-angle-up' : 'fa-angle-down'),
      style: {
        marginTop: 2
      }
    })), category.active && /*#__PURE__*/React.createElement("div", {
      className: "border-t border-secondary-five"
    }, renderContent(category.key)));
  }));
};
var Filters$1 = withFilters(Filters);

var FiltersMobile = function FiltersMobile(_ref) {
  var filters = _ref.filters,
    clearFilters = _ref.clearFilters,
    toggleSmallFilters = _ref.toggleSmallFilters,
    totalCountByFilters = _ref.totalCountByFilters,
    UIState = _ref.UIState,
    UIStateSave = _ref.UIStateSave,
    context = _ref.context;
  var _useState = useState(UIState !== null && UIState !== void 0 && UIState.filtersScrollPositionMobile ? UIState.filtersScrollPositionMobile : 0),
    filtersScrollPositionMobile = _useState[0],
    setFiltersScrollPositionMobile = _useState[1];
  var filtersMobileRef = useRef();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    if (filtersMobileRef && filtersMobileRef.current) {
      filtersMobileRef.current.scrollTop = filtersScrollPositionMobile;
    }
  }, []);
  useEffect(function () {
    UIStateSave(_extends({}, UIState, {
      filtersScrollPositionMobile: 0
    }));
  }, []);
  var scrollTimeout = null;
  var scrollEndDelay = 500;
  var scrollEndHandler = function scrollEndHandler() {
    if (hasDocument()) {
      var filtersMobileWrapper = document.getElementById('filters-mobile-wrapper');
      if (filtersMobileWrapper) {
        UIStateSave(_extends({}, UIState, {
          filtersScrollPositionMobile: filtersMobileWrapper === null || filtersMobileWrapper === void 0 ? void 0 : filtersMobileWrapper.scrollTop
        }));
        setFiltersScrollPositionMobile(filtersMobileWrapper === null || filtersMobileWrapper === void 0 ? void 0 : filtersMobileWrapper.scrollTop);
      }
    }
    scrollTimeout = null;
  };
  var handleFiltersMobileScroll = function handleFiltersMobileScroll() {
    if (scrollTimeout == null) ; else {
      clearTimeout(scrollTimeout);
    }
    scrollTimeout = setTimeout(scrollEndHandler, scrollEndDelay);
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: filtersMobileRef,
    id: "filters-mobile-wrapper",
    onScroll: function onScroll() {
      return handleFiltersMobileScroll();
    },
    className: "overflow-y-scroll",
    style: {
      maxWidth: '100%',
      height: '100vh'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center py-8 px-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center text-primary cursor-pointer",
    onClick: toggleSmallFilters
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-chevron-left mr-2",
    style: {
      marginTop: 2
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-20"
  }, t('Advanced search'))), filters.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "text-primary-light text-12 font-secondary underline hover:no-underline cursor-pointer",
    onClick: clearFilters
  }, t('Remove filters'))), /*#__PURE__*/React.createElement(Filters$1, {
    context: context,
    toggleSmallFilters: toggleSmallFilters,
    UIState: UIState,
    UIStateSave: UIStateSave
  }), /*#__PURE__*/React.createElement("div", {
    className: "",
    style: {
      height: 100
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "fixed cursor-pointer shadow-lg bottom-5 left-5 right-5 flex bg-secondary-two text-14 text-white items-center justify-center py-4 rounded-10",
    onClick: function onClick() {
      return toggleSmallFilters ? toggleSmallFilters() : undefined;
    }
  }, totalCountByFilters >= 0 ? totalCountByFilters + ' ' + t('results') : t('Back to last results')));
};
var FiltersMobile$1 = withFilters(FiltersMobile);

var CarSearchAgentBanner = function CarSearchAgentBanner(_ref) {
  var contentClass = _ref.contentClass,
    blockClassName = _ref.blockClassName,
    onClick = _ref.onClick;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-start justify-center w-full " + blockClassName
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center px-10 py-5 bg-secondary-two text-white rounded-4 cursor-pointer hover:bg-secondary-one " + contentClass,
    style: {
      marginBottom: '1%'
    },
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-24 font-primary font-semibold"
  }, t("Haven't found your dream car yet? We search for you."))));
};
CarSearchAgentBanner.defaultProps = {
  contentClass: '',
  blockClassName: ''
};
var CarSearchAgentBanner$1 = baseNotifyBtn(CarSearchAgentBanner);

var FiltersAndSortBadges = function FiltersAndSortBadges(_ref) {
  var filters = _ref.filters,
    sorter = _ref.sorter,
    filterDelete = _ref.filterDelete,
    sortDelete = _ref.sortDelete;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useIsMobile = useIsMobile(),
    isMobile = _useIsMobile.isMobile;
  if (filters.length === 0) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex mb-4 xl:mb-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 self-start"
  }, filters.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-primary font-semibold mr-2 hidden md:block"
  }, t('Filters'), ":"), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-nowrap"
  }, map(filters, function (filter, index) {
    var isLast = filters.length - 1 === index;
    return /*#__PURE__*/React.createElement("div", {
      key: "filter.type" + index,
      className: "flex flex-row bg-secondary-four rounded-4 px-5 py-2 mb-0 " + (isLast && isMobile ? '' : ' mr-2')
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-secondary-five w-full truncate capitalize"
    }, filter.label && filter.label !== '' ? filter.label : filter.key), /*#__PURE__*/React.createElement("div", {
      className: "text-secondary-five cursor-pointer ml-2 md:ml-4 hover:spin-animation",
      onClick: function onClick() {
        return filterDelete(filter);
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "fal fa-trash-alt font-normal"
    }))));
  }))), sorter && /*#__PURE__*/React.createElement("div", {
    className: "" + (filters.length > 0 ? 'flex items-center border-l border-secondary-four ml-2 pl-2 md:pl-4 mb-0' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row bg-secondary-four rounded-4 px-5 py-2 mr-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex capitalize text-secondary-five items-center"
  }, /*#__PURE__*/React.createElement("i", {
    className: "mr-2 " + (sorter.direction === 'asc' ? 'fal fa-sort-alpha-down' : 'fal fa-sort-alpha-down-alt')
  }), /*#__PURE__*/React.createElement("span", null, sorter.label)), /*#__PURE__*/React.createElement("div", {
    className: "cursor-pointer ml-2 md:ml-4 hover:text-primary hover:spin-animation text-secondary-five",
    onClick: sortDelete
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-trash-alt font-normal",
    style: {
      marginTop: 2
    }
  })))))));
};
var FiltersAndSortBadges$1 = withFilters(FiltersAndSortBadges);

var NotifyMeBtn = function NotifyMeBtn(_ref) {
  var onClick = _ref.onClick;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "text-secondary-two font-semibold font-secondary cursor-pointer",
    onClick: onClick
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-bell mr-2"
  }), t('Notify'));
};
var NotifyMeBtnSimple = baseNotifyBtn(NotifyMeBtn);

var NoSearchResults = function NoSearchResults(_ref) {
  var filters = _ref.filters,
    filterDelete = _ref.filterDelete,
    filtersClear = _ref.filtersClear,
    context = _ref.context;
  var _useIsMobile = useIsMobile(),
    isMobile = _useIsMobile.isMobile;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var handleBackClick = function handleBackClick() {
    if (filters.length >= 1) filterDelete(filters.pop());
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "px-5 sm:px-0 pt-5 sm:pt-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "border border-secondary-lightest rounded-10 mb-4 p-8"
  }, filters && filters.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "text-secondary-two font-secondary cursor-pointer mb-10",
    onClick: function onClick() {
      return handleBackClick();
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-arrow-left mr-2"
  }), " ", t('Back to last results')), /*#__PURE__*/React.createElement("h1", {
    className: ""
  }, t('Unfortunately, your search returned no results...')), /*#__PURE__*/React.createElement("div", {
    className: "paragraph-large"
  }, t('Please try again, but now with fewer or modified search criteria.')), filters.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "bg-secondary-four my-10",
    style: {
      height: 2
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col xl:flex-row items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-primary font-secondary font-semibold mr-2 mb-5 md:mb-0"
  }, t('Selected filters'), ":"), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 w-full flex-wrap xl:flex-nowrap overflow-x-scroll",
    style: {
      width: 'max-content'
    }
  }, map(filters, function (filter, index) {
    var isLast = filters.length - 1 === index;
    var style = isLast && isMobile ? {
      marginRight: 'calc(0.5rem + 20px)'
    } : {};
    return /*#__PURE__*/React.createElement("div", {
      key: "filter.type" + index,
      className: "flex flex-row bg-secondary-four rounded-4 px-5 py-2 mt-2 xl:mt-0 " + (isLast && isMobile ? '' : ' mr-2'),
      style: style
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-secondary-five",
      style: {
        width: 'max-content'
      }
    }, filter.label), /*#__PURE__*/React.createElement("div", {
      className: "text-secondary-five cursor-pointer ml-2 md:ml-4 hover:spin-animation",
      onClick: function onClick() {
        return filterDelete(filter);
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "fal fa-trash-alt font-normal"
    }))));
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row items-center mt-5 xl:mt-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex text-secondary-two text-14 cursor-pointer pr-4 border-r mr-4 ml-4",
    onClick: function onClick() {
      return filtersClear();
    }
  }, t('Remove all filters')), /*#__PURE__*/React.createElement(NotifyMeBtnSimple, {
    context: context
  }))))), /*#__PURE__*/React.createElement(CarSearchAgentBanner$1, {
    context: context,
    contentClass: "w-full"
  }));
};
var NoSearchResults$1 = withFilters(NoSearchResults);

var SegmentBlockAvailableVehiclesCard = function SegmentBlockAvailableVehiclesCard(_ref) {
  var name = _ref.name,
    count = _ref.count,
    onClick = _ref.onClick,
    style = _ref.style;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex relative rounded-4 bg-secondary-one justify-center items-center cursor-pointer",
    style: _extends({}, style),
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col font-semibold title text-white text-32 px-6 lg:px-12",
    style: {
      lineHeight: 1.15
    }
  }, /*#__PURE__*/React.createElement("div", null, t('There are')), /*#__PURE__*/React.createElement("div", {
    className: "text-secondary-two"
  }, count, " ", t('other vehicles available')), /*#__PURE__*/React.createElement("div", null, t('in the'), " ", /*#__PURE__*/React.createElement("span", {
    className: "capitalize"
  }, name), " ", t('offer'))), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end absolute bottom-0 left-0 right-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "font-secondary text-15 font-semibold rounded-tl-4 rounded-br-4 outline-none text-white bg-secondary-two",
    style: {
      padding: '12px 20px',
      width: 'fit-content'
    }
  }, t('Go to all vehicles'), " ", /*#__PURE__*/React.createElement("i", {
    className: "fal fa-long-arrow-right ml-2 font-normal"
  }))));
};

var SegmentBlock = function SegmentBlock(_ref) {
  var segment = _ref.segment,
    onSegmentClick = _ref.onSegmentClick,
    onSegmentVehicleClick = _ref.onSegmentVehicleClick,
    context = _ref.context;
  var cardWidthMobile = 290;
  var cardWidthDesktop = 320;
  var specsInTwoCols = true;
  var _useWindowDimensions = useWindowDimensions(),
    width = _useWindowDimensions.width;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var getNumberOfCols = function getNumberOfCols() {
    var numberOfCards = 1;
    if (width > 767) numberOfCards = 2;
    if (width > 1530) numberOfCards = 3;
    return numberOfCards;
  };
  var getGrid = function getGrid() {
    var gridCols = 'grid-cols-1';
    if (getNumberOfCols() === 2) gridCols = 'grid-cols-2';
    if (getNumberOfCols() === 3) gridCols = 'grid-cols-3';
    if (getNumberOfCols() === 4) gridCols = 'grid-cols-4';
    if (getNumberOfCols() === 5) gridCols = 'grid-cols-5';
    if (getNumberOfCols() === 6) gridCols = 'grid-cols-6';
    return "grid " + gridCols + " gap-4";
  };
  var renderMobile = function renderMobile() {
    var vehiclesToShowMobile = 3;
    var cardWidth = width <= 768 ? cardWidthMobile : cardWidthDesktop;
    return /*#__PURE__*/React.createElement("div", {
      key: "segment-main-" + segment.key,
      className: "mb-5 container mx-auto"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row md:flex-col lg:flex-row justify-between items-center md:items-start lg:items-center mb-5"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "text-primary font-semibold text-20 lg:text-36 cursor-pointer hover:text-primary-light",
      onClick: function onClick() {
        return onSegmentClick(segment);
      }
    }, segment.name, " (", segment.totalVehiclesCountByFilters, ")")), /*#__PURE__*/React.createElement("div", {
      className: "overflow-x-auto"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-nowrap",
      style: {
        width: 'min-content'
      }
    }, map(segment.vehicles.slice(0, vehiclesToShowMobile), function (vehicle, i) {
      return /*#__PURE__*/React.createElement("div", {
        key: "segment-vehicle-" + i,
        className: "segment-vehicle mr-5",
        style: {
          width: cardWidth
        }
      }, /*#__PURE__*/React.createElement(VehicleCard$1, {
        key: vehicle.reference,
        vehicle: vehicle,
        context: context,
        specsInTwoCols: specsInTwoCols,
        cardClass: "vehicle-card mb-5 sm:mb-0",
        onClick: onSegmentVehicleClick
      }));
    }), segment.vehicles.length > vehiclesToShowMobile && /*#__PURE__*/React.createElement(SegmentBlockAvailableVehiclesCard, {
      name: segment.name,
      count: segment.totalVehiclesCountByFilters - vehiclesToShowMobile,
      onClick: function onClick() {
        return onSegmentClick(segment);
      },
      style: {
        width: 290
      }
    }))), /*#__PURE__*/React.createElement("div", {
      className: "block text-secondary-two font-secondary cursor-pointer hover:underline py-5 font-semibold",
      onClick: function onClick() {
        return onSegmentClick(segment);
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "far fa-plus mr-2 font-normal"
    }), t('More'), " ", /*#__PURE__*/React.createElement("span", {
      className: "capitalize"
    }, segment.name.toLowerCase()), " ", t('vehicles')));
  };
  var renderDesktop = function renderDesktop() {
    var numberOfCols = getNumberOfCols();
    return /*#__PURE__*/React.createElement("div", {
      key: "segment-main-" + segment.key,
      className: "mb-5 "
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row md:flex-col lg:flex-row justify-between items-center md:items-start lg:items-center mb-5 px-5 md:px-0"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "text-primary font-semibold text-20 lg:text-36 cursor-pointer hover:text-primary-light",
      onClick: function onClick() {
        return onSegmentClick(segment);
      }
    }, segment.name, " (", segment.totalVehiclesCountByFilters, ")")), /*#__PURE__*/React.createElement("div", {
      className: "flex"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1 " + getGrid() + " px-5 md:px-0"
    }, map(segment.vehicles.slice(0, numberOfCols), function (vehicle, i) {
      return /*#__PURE__*/React.createElement("div", {
        key: "segment-vehicle-" + i
      }, /*#__PURE__*/React.createElement(VehicleCard$1, {
        key: vehicle.reference,
        vehicle: vehicle,
        context: context,
        specsInTwoCols: specsInTwoCols,
        cardClass: "vehicle-card mb-5 sm:mb-0",
        onClick: function onClick(vehicle) {
          onSegmentVehicleClick(vehicle);
        }
      }));
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center ml-4"
    }, /*#__PURE__*/React.createElement("i", {
      className: "fal fa-arrow-right text-32 text-secondary-two hover:text-primary cursor-pointer",
      onClick: function onClick() {
        return onSegmentClick(segment);
      }
    }))), /*#__PURE__*/React.createElement("button", {
      className: "primary-button mt-5",
      onClick: function onClick() {
        return onSegmentClick(segment);
      }
    }, t('More'), " ", /*#__PURE__*/React.createElement("span", {
      className: "capitalize"
    }, segment.name.toLowerCase()), " ", t('vehicles'), " (", segment.totalVehiclesCountByFilters, ")"));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "block lg:hidden"
  }, renderMobile()), /*#__PURE__*/React.createElement("div", {
    className: "hidden lg:block"
  }, renderDesktop()));
};

var NotifyMeBtn$1 = function NotifyMeBtn(_ref) {
  var onClick = _ref.onClick;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center text-secondary-two font-semibold font-secondary cursor-pointer",
    onClick: onClick,
    style: {
      height: 36
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-bell mr-2",
    style: {
      marginTop: 1
    }
  }), " ", /*#__PURE__*/React.createElement("span", null, t('Please notify me')));
};
var NotifyMeBtn$2 = baseNotifyBtn(NotifyMeBtn$1);

var SegmentsTopBar = function SegmentsTopBar(_ref) {
  var filters = _ref.filters,
    onToggleSmallFilters = _ref.onToggleSmallFilters,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var renderCustomBreadcrumbs = function renderCustomBreadcrumbs() {
    return /*#__PURE__*/React.createElement("div", {
      className: "font-secondary font-extralight",
      style: {
        color: '#34424866'
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "cursor-pointer",
      onClick: function onClick() {
        return navigateInternalPage(context, context.defaultPageNames.home);
      }
    }, "Home"), ' ', /*#__PURE__*/React.createElement("i", {
      className: "fal fa-chevron-right mx-2"
    }), /*#__PURE__*/React.createElement("span", null, t('Vehicles')));
  };
  var renderMobileContent = function renderMobileContent() {
    return /*#__PURE__*/React.createElement("div", {
      className: "top-filters-container container flex flex-col items-center justify-center font-secondary relative bg-white " + (filters.length > 0 ? 'pt-5' : 'py-5'),
      style: {
        minHeight: 80
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex w-full mb-2 items-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1 overflow-x-auto"
    }, renderCustomBreadcrumbs()), /*#__PURE__*/React.createElement("div", {
      className: "flex"
    }, /*#__PURE__*/React.createElement(NotifyMeBtn$2, {
      context: context
    }))), /*#__PURE__*/React.createElement("div", {
      className: "flex w-full justify-between items-center mb-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1 justify-end"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-secondary-two text-white flex flex-1 items-center justify-center font-normal rounded-4 ",
      style: {
        width: 80,
        height: 46
      },
      onClick: onToggleSmallFilters
    }, t('Filter'), " ", t('vehicles')))), /*#__PURE__*/React.createElement("div", {
      className: "flex w-full"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1 overflow-x-auto"
    }, /*#__PURE__*/React.createElement(FiltersAndSortBadges$1, {
      context: context
    }))));
  };
  var renderDesktopContent = function renderDesktopContent() {
    return /*#__PURE__*/React.createElement("div", {
      className: "top-filters-container flex flex-col items-center justify-center font-secondary relative bg-white px-0 " + (filters.length > 0 ? 'pb-3' : 'pb-5'),
      style: {
        minHeight: 80
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between w-full"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1 overflow-x-auto md:overflow-auto"
    }, (filters === null || filters === void 0 ? void 0 : filters.length) === 0 && renderCustomBreadcrumbs(), (filters === null || filters === void 0 ? void 0 : filters.length) > 0 && /*#__PURE__*/React.createElement(FiltersAndSortBadges$1, {
      context: context
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex ml-4"
    }, /*#__PURE__*/React.createElement(NotifyMeBtn$2, {
      context: context
    }))), (filters === null || filters === void 0 ? void 0 : filters.length) > 0 && /*#__PURE__*/React.createElement("div", {
      className: "bg-secondary-eight mt-3 w-full",
      style: {
        height: 1
      }
    }));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "block xl:hidden"
  }, renderMobileContent()), /*#__PURE__*/React.createElement("div", {
    className: "hidden xl:block"
  }, renderDesktopContent()));
};

var SegmentSelector = function SegmentSelector(_ref) {
  var segments = _ref.segments,
    currentSegment = _ref.currentSegment,
    _onClick = _ref.onClick;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    expanded = _useState[0],
    setExpanded = _useState[1];
  if (segments && segments.length > 0) {
    var renderMobile = function renderMobile() {
      var segmentsToShow = currentSegment ? segments.filter(function (os) {
        return os.key !== currentSegment.key;
      }) : segments;
      return /*#__PURE__*/React.createElement("div", {
        className: "segments-top-bar bg-white px-5 pb-5"
      }, !currentSegment && /*#__PURE__*/React.createElement("div", {
        className: "bg-primary p-3 text-white font-semibold border-r border-l border-primary"
      }, t('Our stock per category based on the selected filters'), ":"), currentSegment && /*#__PURE__*/React.createElement("div", {
        className: "flex justify-between p-3 capitalize w-full truncate cursor-pointer text-center bg-secondary text-white " + (expanded ? 'rounded-t' : 'rounded'),
        onClick: function onClick() {
          return setExpanded(!expanded);
        }
      }, currentSegment.name.toLowerCase(), " (", currentSegment.totalVehiclesCountByFilters, ") ", /*#__PURE__*/React.createElement("i", {
        className: "far fa-angle-down text-white ml-2"
      })), !currentSegment && /*#__PURE__*/React.createElement("div", {
        className: "flex justify-between p-3 capitalize text-primary w-full truncate cursor-pointer hover:bg-secondary-two text-center bg-secondary-two border-r border-l border-secondary-two",
        onClick: function onClick() {
          return setExpanded(!expanded);
        }
      }, t('Choose'), " ", /*#__PURE__*/React.createElement("i", {
        className: "far fa-angle-down text-primary ml-2"
      })), expanded && /*#__PURE__*/React.createElement("div", {
        className: "border-r border-l border-b rounded-b border-secondary-lightest"
      }, map(segmentsToShow, function (segment) {
        if (segment.totalVehiclesCountByFilters > 0) {
          return /*#__PURE__*/React.createElement("div", {
            key: "segment-" + segment.key,
            onClick: function onClick() {
              setExpanded(!expanded);
              _onClick(segment);
            },
            className: "flex justify-between p-3 capitalize text-primary w-full truncate cursor-pointer hover:bg-secondary-eight text-center"
          }, segment.name.toLowerCase(), " (", segment.totalVehiclesCountByFilters, ") ", /*#__PURE__*/React.createElement("i", {
            className: "fal fa-long-arrow-right ml-2 font-normal"
          }));
        }
      })));
    };
    var renderDesktop = function renderDesktop() {
      return /*#__PURE__*/React.createElement("div", {
        className: "segments-top-bar border border-secondary-eight rounded-4 bg-white px-5 md:px-0"
      }, /*#__PURE__*/React.createElement("div", {
        className: "bg-secondary p-3 text-white font-semibold border-r border-l border-primary rounded-t-4 font-secondary"
      }, t('Our stock per category based on the selected filters'), ":"), /*#__PURE__*/React.createElement("div", {
        className: "grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-0 rounded-b-4"
      }, map(segments, function (segment, i) {
        if (segment.totalVehiclesCountByFilters > 0) {
          return /*#__PURE__*/React.createElement("div", {
            key: "segment-" + segment.key,
            onClick: function onClick() {
              return _onClick(segment);
            },
            className: "font-secondary p-3 capitalize w-full truncate cursor-pointer hover:bg-secondary-two hover:text-white text-center " + (currentSegment && currentSegment.key === segment.key ? 'bg-secondary-two text-white' : 'text-secondary')
          }, segment.name && segment.name.toLowerCase(), " (", segment.totalVehiclesCountByFilters, ")");
        }
      })));
    };
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "block md:hidden"
    }, renderMobile()), /*#__PURE__*/React.createElement("div", {
      className: "hidden md:block"
    }, renderDesktop()));
  }
  return null;
};

var Pagination = function Pagination(_ref) {
  var goToNextPage = _ref.goToNextPage,
    goToPreviousPage = _ref.goToPreviousPage,
    goToPage = _ref.goToPage,
    currentPage = _ref.currentPage,
    pages = _ref.pages,
    amountOfPages = _ref.amountOfPages;
  var firstShownPage = pages[0];
  var lastShownPage = pages[pages.length - 1];
  var renderPreviousButton = function renderPreviousButton() {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center bg-secondary-four rounded-4 w-10 h-10 cursor-pointer hover:bg-secondary-eight",
      onClick: function onClick() {
        return goToPreviousPage();
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "far fa-chevron-left"
    }));
  };
  var renderGoToFirstPage = function renderGoToFirstPage() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center w-10 h-10 cursor-pointer",
      onClick: function onClick() {
        return goToPage(1);
      }
    }, "1"), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center w-10 h-10"
    }, "..."));
  };
  var renderPageNumber = function renderPageNumber(page) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center w-10 h-10 cursor-pointer " + (page === currentPage ? 'text-secondary-two' : ''),
      onClick: function onClick() {
        return goToPage(page);
      }
    }, page);
  };
  var renderGoToLastPage = function renderGoToLastPage() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center w-10 h-10"
    }, "..."), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center w-10 h-10 cursor-pointer",
      onClick: function onClick() {
        return goToPage(amountOfPages);
      }
    }, amountOfPages));
  };
  var renderNextButton = function renderNextButton() {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center bg-secondary-four rounded-4 w-10 h-10 cursor-pointer hover:bg-secondary-eight",
      onClick: function onClick() {
        return goToNextPage();
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "far fa-chevron-right"
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "flex w-full justify-center mt-8"
  }, currentPage > 1 && renderPreviousButton(), firstShownPage > 2 && renderGoToFirstPage(), pages === null || pages === void 0 ? void 0 : pages.map(function (page) {
    return renderPageNumber(page);
  }), lastShownPage < amountOfPages - 1 && renderGoToLastPage(), currentPage < amountOfPages && renderNextButton());
};
var Pagination$1 = basePagination(Pagination);

var List = function List(_ref) {
  var loading = _ref.loading,
    cards = _ref.cards,
    customCardsByBatch = _ref.customCardsByBatch,
    hasMore = _ref.hasMore,
    selectVehicle = _ref.selectVehicle,
    goToNextPage = _ref.goToNextPage,
    goToPreviousPage = _ref.goToPreviousPage,
    goToPage = _ref.goToPage,
    currentPage = _ref.currentPage,
    batchSize = _ref.batchSize,
    totalCount = _ref.totalCount,
    context = _ref.context;
  if (loading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "p-5 md:p-0 grid grid-cols-1 gap-0 md:grid-cols-2 md:gap-4 4xl:grid-cols-3"
    }, times(12, function (item) {
      return /*#__PURE__*/React.createElement(VehicleCardSkeleton, {
        key: "list-vehicle-card-" + item,
        options: {
          width: '100%'
        }
      });
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "p-5 md:p-0 grid grid-cols-1 gap-0 md:grid-cols-2 md:gap-4 4xl:grid-cols-3"
  }, map(cards, function (card) {
    if (card._type === 'vehicle') {
      return /*#__PURE__*/React.createElement(VehicleCard$1, {
        vehicle: card,
        context: context,
        cardClass: "vehicle-card",
        onClick: selectVehicle
      });
    } else if (card._type === 'banner') {
      var _card$image, _card$image2, _card$image3, _card$image4, _card$image5;
      return /*#__PURE__*/React.createElement(ActionLink, {
        action: card.action,
        className: "vehicle-card shadow-xl overflow-hidden hover:opacity relative cursor-pointer",
        style: {
          marginBottom: '2%'
        },
        context: context
      }, /*#__PURE__*/React.createElement("img", {
        srcSet: ((_card$image = card.image) === null || _card$image === void 0 ? void 0 : _card$image.mobile) + " 300w, " + ((_card$image2 = card.image) === null || _card$image2 === void 0 ? void 0 : _card$image2.tablet) + " 768w, " + ((_card$image3 = card.image) === null || _card$image3 === void 0 ? void 0 : _card$image3.desktop) + " 1280w",
        src: (_card$image4 = card.image) === null || _card$image4 === void 0 ? void 0 : _card$image4.mobile,
        alt: (_card$image5 = card.image) === null || _card$image5 === void 0 ? void 0 : _card$image5.alt,
        className: "object-cover h-full w-full",
        style: {
          width: '100%',
          height: '100%'
        }
      }));
    }
  })), totalCount > batchSize && /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block"
  }, /*#__PURE__*/React.createElement(Pagination$1, {
    goToNextPage: goToNextPage,
    goToPreviousPage: goToPreviousPage,
    goToPage: goToPage,
    currentPage: currentPage,
    batchSize: batchSize,
    totalCount: totalCount,
    pageRange: 2,
    customCardsByBatch: customCardsByBatch
  })), !hasMore && /*#__PURE__*/React.createElement(CarSearchAgentBanner$1, {
    context: context
  }));
};
var List$1 = baseVehiclesPaged(List);

var NoFavoriteSearchResults = function NoFavoriteSearchResults(_ref) {
  var filters = _ref.filters,
    filterDelete = _ref.filterDelete,
    filtersClear = _ref.filtersClear,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isMobile = useIsMobile();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "border border-secondary-lightest rounded-10 mb-4 p-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-secondary-two font-secondary cursor-pointer mb-10",
    onClick: function onClick() {
      return navigateInternalPage(context, context.defaultPageNames.vehicles);
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fal fa-arrow-left mr-2"
  }), /*#__PURE__*/React.createElement("span", null, t('Back to last results'))), /*#__PURE__*/React.createElement("h1", null, t("You didn't select any favorites...")), /*#__PURE__*/React.createElement("div", {
    className: "paragraph-large"
  }, t('Add cars by clicking on the heart icon.')), filters.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col md:flex-row items-center mt-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-primary font-secondary font-semibold mr-2 mb-2 md:mb-0"
  }, t('Selected filters'), ":"), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 w-full overflow-x-scroll",
    style: {
      width: 'max-content'
    }
  }, map(filters, function (filter, index) {
    var isLast = filters.length - 1 === index;
    var style = isLast && isMobile ? {
      marginRight: 'calc(0.5rem + 20px)'
    } : {};
    return /*#__PURE__*/React.createElement("div", {
      key: "filter.type" + index,
      className: "flex flex-row bg-secondary-four rounded-4 px-5 py-2 mb-0 md:mb-2 " + (isLast && isMobile ? '' : ' mr-2'),
      style: style
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-secondary-five",
      style: {
        width: 'max-content'
      }
    }, filter.label), /*#__PURE__*/React.createElement("div", {
      className: "text-secondary-five cursor-pointer ml-2 md:ml-4 hover:spin-animation",
      onClick: function onClick() {
        return filterDelete(filter);
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "fal fa-trash-alt font-normal"
    }))));
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center pl-6 mb-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-secondary-two text-14 pr-3 mr-3 border-r border-secondary-eight cursor-pointer mt-2 md:mt-0",
    onClick: filtersClear
  }, t('Remove all filters')), /*#__PURE__*/React.createElement(NotifyMeBtn$2, {
    context: context
  })))), /*#__PURE__*/React.createElement(CarSearchAgentBanner$1, {
    context: context,
    contentClass: "w-full"
  }));
};
var NoFavoriteSearchResults$1 = withFilters(NoFavoriteSearchResults);

var SortCombo = function SortCombo(_ref) {
  var sorters = _ref.sorters,
    sorter = _ref.sorter,
    sortAdd = _ref.sortAdd,
    sortChangeDirection = _ref.sortChangeDirection;
  var sortAscending = sorter && sorter.direction === 'desc' ? false : true;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useIsMobile = useIsMobile(),
    isMobile = _useIsMobile.isMobile;
  var sorterOptions = map(sorters, function (defaultSorter) {
    return {
      value: defaultSorter.field,
      label: defaultSorter.label
    };
  });
  var sorterValue = sorter ? {
    value: sorter.field,
    label: sorter.label
  } : undefined;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center mb-2",
    style: {
      minWidth: isMobile ? 130 : 170
    }
  }, /*#__PURE__*/React.createElement(SelectBox, {
    value: sorterValue,
    options: sorterOptions,
    className: "w-full rounded-l-10 rounded-r-10 cursor-pointer",
    placeholder: t('Sort'),
    customComponents: {
      Option: function Option(_ref2) {
        var innerProps = _ref2.innerProps,
          isDisabled = _ref2.isDisabled,
          data = _ref2.data;
        var isSelected = sorter ? sorter.value === data.value : false;
        return !isDisabled ? /*#__PURE__*/React.createElement("div", innerProps, /*#__PURE__*/React.createElement("div", {
          className: "flex flex-row py-1 hover:bg-gray-100 cursor-pointer hover:text-primary px-2 lg:px-5",
          onClick: function onClick() {
            return sortAdd(data);
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex flex-row justify-between flex-1 relative font-secondary " + (isSelected ? 'text-secondary-two' : 'text-secondary-three')
        }, /*#__PURE__*/React.createElement("div", {
          className: "capitalize"
        }, data.label)))) : null;
      }
    },
    isLoading: false
  }), /*#__PURE__*/React.createElement("i", {
    className: (sortAscending ? 'fal fa-sort-alpha-down' : 'fal fa-sort-alpha-down-alt') + " text-24 text-secondary-two hover:text-secondary-two-light ml-2 cursor-pointer",
    onClick: sortChangeDirection
  })));
};
var SortCombo$1 = withSort(SortCombo);

var VehiclesTopBar = function VehiclesTopBar(_ref) {
  var filters = _ref.filters,
    onToggleSmallFilters = _ref.onToggleSmallFilters,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var renderCustomBreadcrumbs = function renderCustomBreadcrumbs() {
    return /*#__PURE__*/React.createElement("div", {
      className: "font-secondary font-extralight",
      style: {
        color: '#34424866'
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "cursor-pointer",
      onClick: function onClick() {
        return navigateInternalPage(context, context.defaultPageNames.home);
      }
    }, "Home"), ' ', /*#__PURE__*/React.createElement("i", {
      className: "fal fa-chevron-right mx-2"
    }), /*#__PURE__*/React.createElement("span", null, t('Vehicles')));
  };
  var renderMobileContent = function renderMobileContent() {
    return /*#__PURE__*/React.createElement("div", {
      className: "top-filters-container flex flex-col items-center justify-center font-secondary relative bg-white px-5 " + (filters.length > 0 ? 'pt-5' : 'py-5'),
      style: {
        minHeight: 80
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex w-full mb-2 items-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1 overflow-x-auto"
    }, renderCustomBreadcrumbs()), /*#__PURE__*/React.createElement("div", {
      className: "flex ml-4"
    }, /*#__PURE__*/React.createElement(NotifyMeBtn$2, {
      context: context
    }))), /*#__PURE__*/React.createElement("div", {
      className: "flex w-full justify-between items-center mb-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1 justify-end"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-secondary-two text-white flex flex-1 items-center justify-center md:hidden mr-2 font-normal rounded-4 ",
      style: {
        width: 80,
        height: 46
      },
      onClick: onToggleSmallFilters
    }, t('Filter'), " ", t('vehicles')), /*#__PURE__*/React.createElement(SortCombo$1, {
      context: context
    }))), /*#__PURE__*/React.createElement("div", {
      className: "flex w-full"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1 overflow-x-auto"
    }, /*#__PURE__*/React.createElement(FiltersAndSortBadges$1, {
      context: context
    }))));
  };
  var renderDesktopContent = function renderDesktopContent() {
    return /*#__PURE__*/React.createElement("div", {
      className: "top-filters-container flex flex-col items-center justify-center font-secondary relative bg-white px-0 " + (filters.length > 0 ? 'pb-3' : 'pb-5'),
      style: {
        minHeight: 80
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between w-full"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1 overflow-x-auto md:overflow-auto"
    }, filters.filter(function (filter) {
      return filter.type !== 'segment';
    }).length === 0 && renderCustomBreadcrumbs(), (filters === null || filters === void 0 ? void 0 : filters.length) > 0 && /*#__PURE__*/React.createElement(FiltersAndSortBadges$1, {
      context: context
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex mx-4"
    }, /*#__PURE__*/React.createElement(NotifyMeBtn$2, {
      context: context
    })), /*#__PURE__*/React.createElement(SortCombo$1, {
      context: context
    })), (filters === null || filters === void 0 ? void 0 : filters.length) > 0 && /*#__PURE__*/React.createElement("div", {
      className: "bg-secondary-eight mt-3 w-full",
      style: {
        height: 1
      }
    }));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "block md:hidden"
  }, renderMobileContent()), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block"
  }, renderDesktopContent()));
};

var FavoritesTopBar = function FavoritesTopBar(_ref) {
  var onToggleSmallFilters = _ref.onToggleSmallFilters,
    filters = _ref.filters,
    context = _ref.context;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var renderDesktopContent = function renderDesktopContent() {
    return /*#__PURE__*/React.createElement("div", {
      className: "top-filters-container flex flex-col items-center justify-center font-secondary relative bg-white px-0 " + ((filters === null || filters === void 0 ? void 0 : filters.length) > 0 ? 'pb-3' : 'pb-5'),
      style: {
        minHeight: 80
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between w-full"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1 overflow-x-auto md:overflow-auto"
    }, filters.length === 0 && /*#__PURE__*/React.createElement("div", {
      className: "text-secondary-two font-secondary cursor-pointer",
      onClick: function onClick() {
        return navigateInternalPage(context, context.defaultPageNames.vehicles);
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "fal fa-arrow-left mr-2"
    }), /*#__PURE__*/React.createElement("span", null, t('Back to last results'))), (filters === null || filters === void 0 ? void 0 : filters.length) > 0 && /*#__PURE__*/React.createElement(FiltersAndSortBadges$1, {
      context: context
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex mr-4"
    }, /*#__PURE__*/React.createElement(NotifyMeBtn$2, {
      context: context
    })), /*#__PURE__*/React.createElement(SortCombo$1, {
      context: context
    })));
  };
  var renderMobileContent = function renderMobileContent() {
    return /*#__PURE__*/React.createElement("div", {
      className: "top-filters-container flex flex-col items-center justify-center font-secondary relative bg-white px-5 " + ((filters === null || filters === void 0 ? void 0 : filters.length) > 0 ? 'pt-5 pb-3' : 'py-5'),
      style: {
        minHeight: 80
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex w-full mb-5 items-center justify-between"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-secondary-two font-secondary cursor-pointer",
      onClick: function onClick() {
        return navigateInternalPage(context, context.defaultPageNames.vehicles);
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "fal fa-arrow-left mr-2"
    }), /*#__PURE__*/React.createElement("span", null, t('Back to last results'))), /*#__PURE__*/React.createElement("div", {
      className: "flex"
    }, /*#__PURE__*/React.createElement(NotifyMeBtn$2, {
      context: context
    }))), /*#__PURE__*/React.createElement("div", {
      className: "flex w-full justify-between items-center " + ((filters === null || filters === void 0 ? void 0 : filters.length) > 0 ? 'mb-5' : 'mb-0')
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1 justify-end"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-secondary-two text-white flex flex-1 items-center justify-center md:hidden mr-2 font-normal rounded-4 ",
      style: {
        width: 80,
        height: 46
      },
      onClick: onToggleSmallFilters
    }, t('Filter'), " ", t('vehicles')), /*#__PURE__*/React.createElement(SortCombo$1, {
      context: context
    }))), /*#__PURE__*/React.createElement("div", {
      className: "flex w-full"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-1 overflow-x-auto"
    }, /*#__PURE__*/React.createElement(FiltersAndSortBadges$1, {
      context: context
    }))));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "md:hidden"
  }, renderMobileContent()), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block"
  }, renderDesktopContent()));
};

var SegmentSkeleton = function SegmentSkeleton(_ref) {
  var grid = _ref.grid;
  return /*#__PURE__*/React.createElement("div", {
    className: "m-5 md:m-0 " + grid
  }, times(12, function (item) {
    return /*#__PURE__*/React.createElement(VehicleCardSkeleton, {
      key: "list-vehicle-card-" + item,
      options: {
        width: '100%'
      }
    });
  }));
};

var ListSkeleton = function ListSkeleton(_ref) {
  var advertise_top_images = _ref.advertise_top_images,
    grid = _ref.grid;
  var totalCards = 12;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col my-5 md:my-0",
    style: {
      minHeight: '100vh'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block bg-white mr-5",
    style: {
      width: 320,
      minWidth: 320,
      maxWidth: 320
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "overflow-y-auto ",
    style: {
      height: "100%",
      top: "calc(" + getStickiesOffset() + "px + 1.25rem)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-full"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "vehicles-list-container flex flex-col w-full"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, advertise_top_images && /*#__PURE__*/React.createElement("div", {
    className: "hidden md:block bg-gray-200 animate-pulse h-60 mb-5"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-6 w-40"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-6 w-16 mr-4"
  }), /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-200 animate-pulse h-6 w-16 "
  }))), /*#__PURE__*/React.createElement("div", {
    className: grid
  }, times(totalCards, function (item) {
    var isLast = item === totalCards - 1;
    return /*#__PURE__*/React.createElement("div", {
      key: "skeleton-card-" + item,
      className: (isLast ? 'mb-0' : 'mb-4') + " lg:mb-0"
    }, /*#__PURE__*/React.createElement(VehicleCardSkeleton, {
      key: "vehicles-list-card-" + item,
      options: {
        width: '100%'
      }
    }));
  }))))));
};

var FiltersAndListPaged = function FiltersAndListPaged(props) {
  var _advertise_top_images, _advertise_top_images2, _advertise_top_images3, _advertise_top_images4, _advertise_top_images5;
  var view = props.view,
    loading = props.loading,
    defaultFilterModalStyles = props.defaultFilterModalStyles,
    context = props.context;
  var advertise_top_images = props.advertise_top_images,
    advertise_list_images = props.advertise_list_images,
    customCardsByBatch = props.customCardsByBatch;
  var vehicles = props.vehicles,
    selectVehicle = props.selectVehicle,
    batchSize = props.batchSize;
  var filters = props.filters,
    filtersUrl = props.filtersUrl;
  var UIState = props.UIState,
    UIStateSave = props.UIStateSave;
  var segments = props.segments,
    currentSegment = props.currentSegment,
    hasSegmentsData = props.hasSegmentsData,
    segmentSelect = props.segmentSelect;
  var _useState = useState(UIState !== null && UIState !== void 0 && UIState.mobileFilterModalVisible ? UIState === null || UIState === void 0 ? void 0 : UIState.mobileFilterModalVisible : false),
    mobileFilterModalVisible = _useState[0],
    setMobileFilterModalVisible = _useState[1];
  var _useState2 = useState('top'),
    seoTextPosition = _useState2[0],
    setSeoTextPosition = _useState2[1];
  var _useState3 = useState(UIState !== null && UIState !== void 0 && UIState.scrollPosition ? UIState.scrollPosition : 0),
    filtersScrollPosition = _useState3[0],
    setFiltersScrollPosition = _useState3[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useWindowDimensions = useWindowDimensions(),
    width = _useWindowDimensions.width;
  var filtersRef = useRef();
  var rightSideRef = useRef();
  useEffect(function () {
    setSeoTextPosition('bottom');
  }, [filtersUrl]);
  useEffect(function () {
    if (filtersRef && filtersRef.current) {
      filtersRef.current.scrollTop = filtersScrollPosition;
    }
  }, []);
  useEffect(function () {
    UIStateSave(_extends({}, UIState, {
      scrollPosition: 0
    }));
    if (hasWindow()) {
      window.scrollTo(0, 0);
    }
  }, [view]);
  var skeletonGrid = "grid grid-cols-1 gap-4 sm:grid-cols-2 " + (width > 940 ? 'md:grid-cols-2' : 'md:grid-cols-1') + " lg:grid-cols-2 lg2:grid-cols-3 xl:grid-cols-3";
  var renderLoadingIndicator = function renderLoadingIndicator() {
    return /*#__PURE__*/React.createElement("div", {
      className: "bg-white w-full"
    }, /*#__PURE__*/React.createElement(ListSkeleton, {
      advertise_top_images: (advertise_top_images === null || advertise_top_images === void 0 ? void 0 : advertise_top_images.length) > 0,
      grid: skeletonGrid
    }));
  };
  var renderRight = function renderRight() {
    switch (view) {
      case 'FiltersAndSegments':
        return renderSegments();
      case 'FiltersAndVehicles':
        return renderVehicles();
      case 'FiltersAndFavorites':
        return renderFavorites();
      case 'NoResults':
        return renderNoResults();
      case 'NoResultsFavorites':
        return renderNoFavoritesResults();
      default:
        return /*#__PURE__*/React.createElement("div", null, "No view defined");
    }
  };
  var renderSegments = function renderSegments() {
    if (!hasSegmentsData) return /*#__PURE__*/React.createElement(SegmentSkeleton, {
      grid: skeletonGrid
    });
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "w-full"
    }, /*#__PURE__*/React.createElement(Sticky, {
      enabled: true,
      top: getStickiesOffset(),
      bottomBoundary: ".bottom-container",
      activeClass: "bg-white w-full boris top-filters-sticky",
      innerZ: 21
    }, /*#__PURE__*/React.createElement(SegmentsTopBar, {
      onToggleSmallFilters: function onToggleSmallFilters() {
        return setMobileFilterModalVisible(!mobileFilterModalVisible);
      },
      filters: filters,
      context: context
    }))), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col flex-1"
    }, map(segments, function (segment) {
      if (segment.totalVehiclesCountByFilters > 0) {
        return /*#__PURE__*/React.createElement(SegmentBlock, {
          segment: segment,
          onSegmentClick: segmentSelect,
          onSegmentVehicleClick: selectVehicle,
          context: context
        });
      }
    })));
  };
  var renderVehicles = function renderVehicles() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "w-full"
    }, /*#__PURE__*/React.createElement(Sticky, {
      enabled: true,
      top: getStickiesOffset(),
      bottomBoundary: ".bottom-container",
      activeClass: "bg-white w-full boris top-filters-sticky",
      innerZ: 21
    }, /*#__PURE__*/React.createElement(VehiclesTopBar, {
      onToggleSmallFilters: function onToggleSmallFilters() {
        return setMobileFilterModalVisible(!mobileFilterModalVisible);
      },
      filters: filters,
      context: context
    }), context.vehicleSegmentation && hasFilter(filters, FilterTypes.segment) && hasSegmentsData && vehicles.length > 0 && /*#__PURE__*/React.createElement(SegmentSelector, {
      segments: segments,
      currentSegment: currentSegment,
      onClick: segmentSelect
    }))), /*#__PURE__*/React.createElement(List$1, {
      advertise_list_images: advertise_list_images,
      customCardsByBatch: customCardsByBatch,
      context: context,
      batchSize: batchSize
    }));
  };
  var renderFavorites = function renderFavorites() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "w-full pb-6"
    }, /*#__PURE__*/React.createElement(Sticky, {
      enabled: true,
      top: getStickiesOffset(),
      bottomBoundary: ".bottom-container",
      activeClass: "bg-white w-full boris top-filters-sticky",
      innerZ: 21
    }, /*#__PURE__*/React.createElement(FavoritesTopBar, {
      onToggleSmallFilters: function onToggleSmallFilters() {
        return setMobileFilterModalVisible(!mobileFilterModalVisible);
      },
      filters: filters,
      context: context
    }))), /*#__PURE__*/React.createElement("h1", {
      className: "text-primary mb-4"
    }, t('Favorites')), /*#__PURE__*/React.createElement(List$1, {
      advertise_list_images: advertise_list_images,
      customCardsByBatch: customCardsByBatch,
      context: context,
      batchSize: batchSize
    }));
  };
  var renderNoResults = function renderNoResults() {
    return /*#__PURE__*/React.createElement(NoSearchResults$1, {
      context: context
    });
  };
  var renderNoFavoritesResults = function renderNoFavoritesResults() {
    return /*#__PURE__*/React.createElement(NoFavoriteSearchResults$1, {
      context: context
    });
  };
  var renderSeoBlock = function renderSeoBlock() {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex leading-24 mb-4",
      style: {
        minHeight: 30
      }
    }, context.data && context.data.pageText && /*#__PURE__*/React.createElement(MarkupText, {
      text: JSON.parse(context.data.pageText),
      context: context
    }), !context.data || !context.data.pageText && /*#__PURE__*/React.createElement("p", null, "No seo text block ?"));
  };
  if (loading) {
    return renderLoadingIndicator();
  }
  var scrollTimeout = null;
  var scrollEndDelay = 500;
  var scrollEndHandler = function scrollEndHandler() {
    if (hasDocument()) {
      var filtersLeftEl = document.getElementById('filters-left-side');
      if (filtersLeftEl) {
        UIStateSave(_extends({}, UIState, {
          scrollPosition: filtersLeftEl === null || filtersLeftEl === void 0 ? void 0 : filtersLeftEl.scrollTop
        }));
        setFiltersScrollPosition(filtersLeftEl === null || filtersLeftEl === void 0 ? void 0 : filtersLeftEl.scrollTop);
      }
    }
    scrollTimeout = null;
  };
  var handleFiltersScroll = function handleFiltersScroll() {
    if (scrollTimeout == null) ; else {
      clearTimeout(scrollTimeout);
    }
    scrollTimeout = setTimeout(scrollEndHandler, scrollEndDelay);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "my-0 md:my-5 "
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col",
    style: {
      minHeight: '100vh'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row -mx-5 md:mx-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden xl:block mr-5 bg-white items-start justify-start",
    style: {
      width: 320,
      minWidth: 320,
      maxWidth: 320
    }
  }, /*#__PURE__*/React.createElement("div", {
    ref: filtersRef,
    id: "filters-left-side",
    onScroll: function onScroll() {
      return handleFiltersScroll();
    },
    className: "overflow-y-auto sticky",
    style: {
      top: getStickiesOffset() + 20,
      height: "calc(100vh - " + getStickiesOffset() + "px)"
    }
  }, /*#__PURE__*/React.createElement(Filters$1, {
    context: context,
    UIState: UIState,
    UIStateSave: UIStateSave
  }))), /*#__PURE__*/React.createElement("div", {
    ref: rightSideRef,
    className: "flex flex-col vehicles-right-side-wrapper"
  }, seoTextPosition === 'top' && /*#__PURE__*/React.createElement("div", {
    className: "mb-7"
  }, renderSeoBlock()), /*#__PURE__*/React.createElement(React.Fragment, null, advertise_top_images && advertise_top_images.length > 0 && /*#__PURE__*/React.createElement(ActionLink, {
    action: advertise_top_images[0].action,
    className: "hidden md:block cursor-pointer mb-5",
    style: {
      maxHeight: 250
    },
    context: context
  }, /*#__PURE__*/React.createElement("img", {
    srcSet: ((_advertise_top_images = advertise_top_images[0].image) === null || _advertise_top_images === void 0 ? void 0 : _advertise_top_images.mobile) + " 300w, " + ((_advertise_top_images2 = advertise_top_images[0].image) === null || _advertise_top_images2 === void 0 ? void 0 : _advertise_top_images2.tablet) + " 768w, " + ((_advertise_top_images3 = advertise_top_images[0].image) === null || _advertise_top_images3 === void 0 ? void 0 : _advertise_top_images3.desktop) + " 1280w",
    src: (_advertise_top_images4 = advertise_top_images[0].image) === null || _advertise_top_images4 === void 0 ? void 0 : _advertise_top_images4.mobile,
    alt: (_advertise_top_images5 = advertise_top_images[0].image) === null || _advertise_top_images5 === void 0 ? void 0 : _advertise_top_images5.alt,
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    }
  })), renderRight()))), /*#__PURE__*/React.createElement("div", {
    id: "bottom-container",
    className: "opacity-0 bottom-container"
  })), seoTextPosition === 'bottom' && /*#__PURE__*/React.createElement("div", {
    className: "mt-7 mb-7"
  }, renderSeoBlock())), /*#__PURE__*/React.createElement(Modal, {
    isOpen: mobileFilterModalVisible,
    style: {
      content: _extends({}, defaultFilterModalStyles.content),
      overlay: _extends({}, defaultFilterModalStyles.overlay, {
        top: 58,
        zIndex: 999
      })
    },
    appElement: hasDocument() ? document.getElementById('root') : undefined
  }, /*#__PURE__*/React.createElement(FiltersMobile$1, {
    context: context,
    UIState: UIState,
    UIStateSave: UIStateSave,
    toggleSmallFilters: function toggleSmallFilters(value) {
      var val = value ? value : !mobileFilterModalVisible;
      setMobileFilterModalVisible(val);
      UIStateSave(_extends({}, UIState, {
        mobileFilterModalVisible: val
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    id: "bottom-container",
    className: "opacity-0 bottom-container"
  }));
};
var FiltersAndListPaged$1 = baseVehiclesAndFilters(FiltersAndListPaged);

var VehiclesListWithAdds = function VehiclesListWithAdds(_ref) {
  var advertise_top_images = _ref.advertise_top_images,
    advertise_list_images = _ref.advertise_list_images,
    context = _ref.context;
  return /*#__PURE__*/React.createElement("div", {
    className: "container mx-auto my-0 md:my-5"
  }, /*#__PURE__*/React.createElement(FiltersAndListPaged$1, {
    context: context,
    advertise_top_images: advertise_top_images,
    advertise_list_images: advertise_list_images
  }));
};
VehiclesListWithAdds.defaultProps = {
  advertise_top_images: [],
  advertise_list_images: []
};
VehiclesListWithAdds.human = {
  nl: '',
  fr: '',
  en: ''
};
VehiclesListWithAdds.preview = function () {
  return /*#__PURE__*/React.createElement("div", null, "VehiclesListWithAdds");
};

export { AboutHeaderImageAndText, Banner, BannerGenericIconTextAction, BannerGenericIconTextAndTitle, BannerImageAndTextWithAction, BannerImageIconTextWithAction, BannerImageIconTextWithActionImageRight as BannerImageIconTextWithAction_ImageRight, BannerResponsiveImage, BannerTwoBlocks, BannerUspWithQuotes, Breadcrumbs, ContactFormTextAndImage, CookieBanner$1 as CookieBanner, DealershipDetail, Default, FinanceBanner$1 as FinanceBanner, FinancingTextBlock$1 as FinancingTextBlock, FooterTopWay, HeaderTopWay, MarkerMapAndDealerships as MarkerMap_AndDealerships, Paragraph, Privacy, SeoBlockAndText, SeoGenericMakeModelBlockAndText, SeoMakeBlockComponent as SeoMakeBlock, Separator, VehicleCompare, VehicleCompareBanner$1 as VehicleCompareBanner, VehicleDetailWithAdds, VehicleFavorites, VehicleReservation, VehicleSearchAgent, VehicleSearchMultiImageText, VehicleSearchMultiVideoText, VehicleSearchText, VehicleSlider$2 as VehicleSlider, VehicleSliderWithHeaderAndLegal as VehicleSliderWithHeader, VehicleSliderWithHeaderAndBrands, VehicleSliderWithHeaderAndLegal$1 as VehicleSliderWithHeader_AndLegal, VehicleSliderWithHeaderGray as VehicleSliderWithHeader_Gray, VehiclesListWithAdds, VehiclesSeoBlock, config };
